/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Kids Home API
 * Gamified family chore / habit / allowance API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AcceptInvitationDto,
  AcceptInvitationResponse,
  AchievementBonusResponse,
  ActiveQuestsResponse,
  ActivityControllerChildFeedV1200,
  ActivityControllerChildFeedV1Params,
  ActivityControllerHouseholdFeedV1200,
  ActivityControllerHouseholdFeedV1Params,
  AddChildDto,
  AddChildResponse,
  AdjustBalanceDto,
  AnswerSessionDto,
  AnswerSessionResponse,
  ApprovalItemResponse,
  ApproveOccurrenceDto,
  ArchetypeResponse,
  AssignRolesDto,
  AssignmentResponse,
  AuthTokenResponse,
  BackfillOccurrenceDto,
  BackgroundChoicesResponse,
  BalancesControllerBalanceTrendV1Params,
  BalancesControllerLedgerV1200,
  BalancesControllerLedgerV1Params,
  CatalogResponse,
  CategoriesControllerListV1Params,
  CategoryResponse,
  ChangePasswordDto,
  CheckInHabitDto,
  CheckInHabitResponse,
  ChildBalanceResponse,
  ChildBalanceTrendResponse,
  ChildLoginDto,
  ChildRewardOverrideResponse,
  ChildStreaksResponse,
  ChooseHeroDto,
  ChooseHeroResponse,
  ChoreActionDto,
  CompletionTrendResponse,
  ConfigureEconomyDto,
  ConsentStateResponse,
  CosmeticCatalogResponse,
  CosmeticItemDto,
  CosmeticsControllerCatalogV1Params,
  CosmeticsControllerEquippedV1Params,
  CreateBonusDto,
  CreateBonusResponse,
  CreateCategoryDto,
  CreateCategoryResponse,
  CreateHabitDto,
  CreateHabitResponse,
  CreateLearningGoalDto,
  CreateLearningGoalResponse,
  CreateLibraryTemplateDto,
  CreateLibraryTemplateResponse,
  CreatePackDto,
  CreatePlatformAdminDto,
  CreatePlatformAdminResponse,
  CreateQuestDto,
  CreateQuestResponse,
  CreateRedemptionDto,
  CreateRewardDto,
  CreateRewardResponse,
  CreateRoleDto,
  CreateRoleResponse,
  CreateRoleTemplateDto,
  CreateRoleTemplateResponse,
  CreateSavingsGoalDto,
  CreateSavingsGoalResponse,
  CreateTemplateDto,
  CreateTemplateResponse,
  CsrfResponse,
  DayTasksResponse,
  DecideRedemptionDto,
  EconomyAdminControllerAnalyticsV1Params,
  EconomyAnalyticsResponse,
  EconomyAutomationResponse,
  EconomyConfigResponse,
  EnabledGradesResponse,
  EnterHouseholdDto,
  EquipBackgroundDto,
  EquipBackgroundResponse,
  EquipPetDto,
  EquipPetResponse,
  EquippedCosmeticsResponse,
  EraseHouseholdResponse,
  ExcuseHabitDayDto,
  ExcuseHabitDayResponse,
  GoalStatusResponse,
  GoalTrendResponse,
  HabitDetailResponse,
  HabitHistoryResponse,
  HabitsControllerHistoryV1Params,
  HabitsControllerListV1200,
  HabitsControllerListV1Params,
  HabitsControllerTodayV1Params,
  HealthControllerLiveness200,
  HealthControllerLiveness503,
  HealthControllerReadiness200,
  HealthControllerReadiness503,
  HeroChoicesResponse,
  HeroEnvelopeResponse,
  HoldResponse,
  HouseholdBundlesResponse,
  HouseholdDetailResponse,
  HouseholdExportResponse,
  HouseholdFeaturesResponse,
  HouseholdHoldResponse,
  HouseholdResponse,
  HouseholdSummaryResponse,
  IncomeForecastResponse,
  InvitationContextResponse,
  InvitationListItemResponse,
  InviteMemberDto,
  InviteMemberResponse,
  IssuedLinkResponse,
  LearningControllerClearPlacementV1Params,
  LearningControllerGoalStatusV1Params,
  LearningControllerGoalTrendV1Params,
  LearningControllerMapV1Params,
  LearningControllerPreviewTopicV1Params,
  LearningControllerRulesV1Params,
  LearningGoalResponse,
  LearningMapResponse,
  LessonResponse,
  LessonViewedResponse,
  LibraryTemplateResponse,
  LoginDto,
  MarkAllReadDto,
  MarkLessonViewedDto,
  MarkVoiceSeenDto,
  MeResponse,
  MemberAvatarControllerUploadV1Body,
  MemberResponse,
  MembersControllerListV1200,
  MembersControllerListV1Params,
  MissionsResponse,
  NotificationListResponse,
  NotificationPreferencesResponse,
  NotificationRecentListResponse,
  NotificationStatsResponse,
  NotificationsControllerListV1Params,
  OccurrenceResponse,
  PackDetailResponse,
  PackListResponse,
  PackSummaryResponse,
  PetChoicesResponse,
  PhotoProofControllerPhotoCompleteV1Body,
  PhotoProofControllerUploadV1Body,
  PlaceHoldDto,
  PlaceHoldResponse,
  PlacementResponse,
  PlatformAdminControllerHouseholdMembersV1200,
  PlatformAdminControllerListAuditV1200,
  PlatformAdminControllerListAuditV1Params,
  PlatformAdminControllerListHouseholdsV1200,
  PlatformAdminControllerListHouseholdsV1Params,
  PlatformAdminControllerListSystemEventsV1200,
  PlatformAdminControllerListSystemEventsV1Params,
  PlatformAdminControllerSystemLogsV1Params,
  PlatformAdminResponse,
  PlatformInvitationResponse,
  PlatformNotificationsControllerRecentV1Params,
  PlatformNotificationsControllerStatsV1Params,
  PlatformTemplatesControllerListV1Params,
  PlayControllerBackgroundsV1Params,
  PlayControllerHeroV1Params,
  PlayControllerHeroesV1Params,
  PlayControllerPetsV1Params,
  PlayControllerStateV1Params,
  PlayControllerVoiceV1Params,
  PlayStateResponse,
  ProblemDetailsResponse,
  ProvisionHouseholdDto,
  ProvisionHouseholdResponse,
  PurchaseCosmeticResponse,
  PurgeResponse,
  QuestsControllerListV1200,
  QuestsControllerListV1Params,
  RecordConsentResponse,
  RedemptionsControllerListV1200,
  RedemptionsControllerListV1Params,
  RedoOccurrenceDto,
  ReinstateHouseholdDto,
  RejectOccurrenceDto,
  RenameHeroDto,
  RenameHeroResponse,
  RequestPasswordResetDto,
  RequestRedemptionResponse,
  ResendInvitationResponse,
  ResetPasswordDto,
  ResumeSessionResponse,
  RewardGoalResponse,
  RewardPhotosControllerUploadV1Body,
  RewardResponse,
  RewardsControllerGetV1Params,
  RewardsControllerListV1Params,
  RoleResponse,
  RoleTemplateResponse,
  RulesResponse,
  SavePackDto,
  SavingsControllerListForChildV1Params,
  SavingsGoalResponse,
  SavingsMovementDto,
  SendAnnouncementDto,
  SendAnnouncementResponse,
  SessionResponse,
  SetAssignmentDto,
  SetChildPinDto,
  SetChildRewardOverrideDto,
  SetEnabledGradesDto,
  SetHouseholdBundlesDto,
  SetHouseholdFeaturesDto,
  SetKnownTagsDto,
  SetMemberLocaleDto,
  SetRewardGoalDto,
  StartSessionDto,
  StartSessionResponse,
  SubscribeDto,
  SubscribeResponse,
  SuspendHouseholdDto,
  SystemEventActionDto,
  SystemEventDetailResponse,
  SystemLogResponse,
  SystemStatusResponse,
  TasksControllerCompletionTrendV1Params,
  TasksControllerDayV1Params,
  TasksControllerFinishedMissionsV1Params,
  TasksControllerMissionsV1Params,
  TasksControllerWeekV1Params,
  TemplateCatalogControllerListV1Params,
  TemplateCatalogItemResponse,
  TemplateCoverControllerUploadV1Body,
  TemplateResponse,
  TemplatesControllerListV1200,
  TemplatesControllerListV1Params,
  TodayHabitsResponse,
  TopicPreviewResponse,
  UncheckHabitDto,
  UncheckHabitResponse,
  UnexcuseHabitDayResponse,
  UnlockBackgroundDto,
  UnlockBackgroundResponse,
  UnlockHeroDto,
  UnlockHeroResponse,
  UnlockPetDto,
  UnlockPetResponse,
  UnreadCountResponse,
  UnsubscribeDto,
  UpdateBonusDto,
  UpdateCategoryDto,
  UpdateHabitDto,
  UpdateHouseholdDto,
  UpdateLearningGoalDto,
  UpdateLibraryTemplateDto,
  UpdateMemberProfileDto,
  UpdatePreferencesDto,
  UpdateQuestDto,
  UpdateRewardDto,
  UpdateRoleDto,
  UpdateRoleTemplateDto,
  UpdateSavingsGoalDto,
  UpdateTemplateDto,
  UploadPhotoProofResponse,
  VapidPublicKeyResponse,
  VoiceFeedResponse,
  WaysToEarnResponse,
  WeekAgendaResponse,
} from './models';

import { apiFetch } from '../mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const healthControllerLiveness = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HealthControllerLiveness200>(
    { url: `/health/liveness`, method: 'GET', signal },
    options,
  );
};

export const getHealthControllerLivenessQueryKey = () => {
  return [`/health/liveness`] as const;
};

export const getHealthControllerLivenessQueryOptions = <
  TData = Awaited<ReturnType<typeof healthControllerLiveness>>,
  TError = HealthControllerLiveness503,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthControllerLivenessQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerLiveness>>> = ({
    signal,
  }) => healthControllerLiveness(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthControllerLiveness>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthControllerLivenessQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthControllerLiveness>>
>;
export type HealthControllerLivenessQueryError = HealthControllerLiveness503;

export function useHealthControllerLiveness<
  TData = Awaited<ReturnType<typeof healthControllerLiveness>>,
  TError = HealthControllerLiveness503,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerLiveness>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthControllerLiveness<
  TData = Awaited<ReturnType<typeof healthControllerLiveness>>,
  TError = HealthControllerLiveness503,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerLiveness>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthControllerLiveness<
  TData = Awaited<ReturnType<typeof healthControllerLiveness>>,
  TError = HealthControllerLiveness503,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHealthControllerLiveness<
  TData = Awaited<ReturnType<typeof healthControllerLiveness>>,
  TError = HealthControllerLiveness503,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerLiveness>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthControllerLivenessQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const healthControllerReadiness = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HealthControllerReadiness200>(
    { url: `/health/readiness`, method: 'GET', signal },
    options,
  );
};

export const getHealthControllerReadinessQueryKey = () => {
  return [`/health/readiness`] as const;
};

export const getHealthControllerReadinessQueryOptions = <
  TData = Awaited<ReturnType<typeof healthControllerReadiness>>,
  TError = HealthControllerReadiness503,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthControllerReadinessQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerReadiness>>> = ({
    signal,
  }) => healthControllerReadiness(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthControllerReadiness>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthControllerReadinessQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthControllerReadiness>>
>;
export type HealthControllerReadinessQueryError = HealthControllerReadiness503;

export function useHealthControllerReadiness<
  TData = Awaited<ReturnType<typeof healthControllerReadiness>>,
  TError = HealthControllerReadiness503,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerReadiness>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthControllerReadiness<
  TData = Awaited<ReturnType<typeof healthControllerReadiness>>,
  TError = HealthControllerReadiness503,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthControllerReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthControllerReadiness>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthControllerReadiness<
  TData = Awaited<ReturnType<typeof healthControllerReadiness>>,
  TError = HealthControllerReadiness503,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHealthControllerReadiness<
  TData = Awaited<ReturnType<typeof healthControllerReadiness>>,
  TError = HealthControllerReadiness503,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthControllerReadiness>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthControllerReadinessQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const membersControllerAddChildV1 = (
  addChildDto: AddChildDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<AddChildResponse>(
    {
      url: `/v1/members/children`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addChildDto,
      signal,
    },
    options,
  );
};

export const getMembersControllerAddChildV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membersControllerAddChildV1>>,
    TError,
    { data: AddChildDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membersControllerAddChildV1>>,
  TError,
  { data: AddChildDto },
  TContext
> => {
  const mutationKey = ['membersControllerAddChildV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membersControllerAddChildV1>>,
    { data: AddChildDto }
  > = (props) => {
    const { data } = props ?? {};

    return membersControllerAddChildV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembersControllerAddChildV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerAddChildV1>>
>;
export type MembersControllerAddChildV1MutationBody = AddChildDto;
export type MembersControllerAddChildV1MutationError = ProblemDetailsResponse;

export const useMembersControllerAddChildV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof membersControllerAddChildV1>>,
      TError,
      { data: AddChildDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof membersControllerAddChildV1>>,
  TError,
  { data: AddChildDto },
  TContext
> => {
  const mutationOptions = getMembersControllerAddChildV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const membersControllerListV1 = (
  params?: MembersControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<MembersControllerListV1200>(
    { url: `/v1/members`, method: 'GET', params, signal },
    options,
  );
};

export const getMembersControllerListV1QueryKey = (params?: MembersControllerListV1Params) => {
  return [`/v1/members`, ...(params ? [params] : [])] as const;
};

export const getMembersControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof membersControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: MembersControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMembersControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof membersControllerListV1>>> = ({
    signal,
  }) => membersControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof membersControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MembersControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerListV1>>
>;
export type MembersControllerListV1QueryError = ProblemDetailsResponse;

export function useMembersControllerListV1<
  TData = Awaited<ReturnType<typeof membersControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | MembersControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof membersControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof membersControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMembersControllerListV1<
  TData = Awaited<ReturnType<typeof membersControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: MembersControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof membersControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof membersControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMembersControllerListV1<
  TData = Awaited<ReturnType<typeof membersControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: MembersControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMembersControllerListV1<
  TData = Awaited<ReturnType<typeof membersControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: MembersControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMembersControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const membersControllerGetV1 = (
  memberId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<MemberResponse>(
    { url: `/v1/members/${memberId}`, method: 'GET', signal },
    options,
  );
};

export const getMembersControllerGetV1QueryKey = (memberId?: string) => {
  return [`/v1/members/${memberId}`] as const;
};

export const getMembersControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof membersControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMembersControllerGetV1QueryKey(memberId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof membersControllerGetV1>>> = ({ signal }) =>
    membersControllerGetV1(memberId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!memberId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof membersControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MembersControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerGetV1>>
>;
export type MembersControllerGetV1QueryError = ProblemDetailsResponse;

export function useMembersControllerGetV1<
  TData = Awaited<ReturnType<typeof membersControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  memberId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof membersControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof membersControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMembersControllerGetV1<
  TData = Awaited<ReturnType<typeof membersControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof membersControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof membersControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMembersControllerGetV1<
  TData = Awaited<ReturnType<typeof membersControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMembersControllerGetV1<
  TData = Awaited<ReturnType<typeof membersControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  memberId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof membersControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMembersControllerGetV1QueryOptions(memberId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const membersControllerUpdateProfileV1 = (
  memberId: string,
  updateMemberProfileDto: UpdateMemberProfileDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/members/${memberId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateMemberProfileDto,
    },
    options,
  );
};

export const getMembersControllerUpdateProfileV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membersControllerUpdateProfileV1>>,
    TError,
    { memberId: string; data: UpdateMemberProfileDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membersControllerUpdateProfileV1>>,
  TError,
  { memberId: string; data: UpdateMemberProfileDto },
  TContext
> => {
  const mutationKey = ['membersControllerUpdateProfileV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membersControllerUpdateProfileV1>>,
    { memberId: string; data: UpdateMemberProfileDto }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return membersControllerUpdateProfileV1(memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembersControllerUpdateProfileV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerUpdateProfileV1>>
>;
export type MembersControllerUpdateProfileV1MutationBody = UpdateMemberProfileDto;
export type MembersControllerUpdateProfileV1MutationError = ProblemDetailsResponse;

export const useMembersControllerUpdateProfileV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof membersControllerUpdateProfileV1>>,
      TError,
      { memberId: string; data: UpdateMemberProfileDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof membersControllerUpdateProfileV1>>,
  TError,
  { memberId: string; data: UpdateMemberProfileDto },
  TContext
> => {
  const mutationOptions = getMembersControllerUpdateProfileV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const membersControllerAssignRolesV1 = (
  memberId: string,
  assignRolesDto: AssignRolesDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/members/${memberId}/roles`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: assignRolesDto,
    },
    options,
  );
};

export const getMembersControllerAssignRolesV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membersControllerAssignRolesV1>>,
    TError,
    { memberId: string; data: AssignRolesDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membersControllerAssignRolesV1>>,
  TError,
  { memberId: string; data: AssignRolesDto },
  TContext
> => {
  const mutationKey = ['membersControllerAssignRolesV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membersControllerAssignRolesV1>>,
    { memberId: string; data: AssignRolesDto }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return membersControllerAssignRolesV1(memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembersControllerAssignRolesV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerAssignRolesV1>>
>;
export type MembersControllerAssignRolesV1MutationBody = AssignRolesDto;
export type MembersControllerAssignRolesV1MutationError = ProblemDetailsResponse;

export const useMembersControllerAssignRolesV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof membersControllerAssignRolesV1>>,
      TError,
      { memberId: string; data: AssignRolesDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof membersControllerAssignRolesV1>>,
  TError,
  { memberId: string; data: AssignRolesDto },
  TContext
> => {
  const mutationOptions = getMembersControllerAssignRolesV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const membersControllerSetLocaleV1 = (
  memberId: string,
  setMemberLocaleDto: SetMemberLocaleDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/members/${memberId}/locale`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setMemberLocaleDto,
    },
    options,
  );
};

export const getMembersControllerSetLocaleV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membersControllerSetLocaleV1>>,
    TError,
    { memberId: string; data: SetMemberLocaleDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membersControllerSetLocaleV1>>,
  TError,
  { memberId: string; data: SetMemberLocaleDto },
  TContext
> => {
  const mutationKey = ['membersControllerSetLocaleV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membersControllerSetLocaleV1>>,
    { memberId: string; data: SetMemberLocaleDto }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return membersControllerSetLocaleV1(memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembersControllerSetLocaleV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerSetLocaleV1>>
>;
export type MembersControllerSetLocaleV1MutationBody = SetMemberLocaleDto;
export type MembersControllerSetLocaleV1MutationError = ProblemDetailsResponse;

export const useMembersControllerSetLocaleV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof membersControllerSetLocaleV1>>,
      TError,
      { memberId: string; data: SetMemberLocaleDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof membersControllerSetLocaleV1>>,
  TError,
  { memberId: string; data: SetMemberLocaleDto },
  TContext
> => {
  const mutationOptions = getMembersControllerSetLocaleV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const membersControllerDisableV1 = (
  memberId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/members/${memberId}/disable`, method: 'POST', signal },
    options,
  );
};

export const getMembersControllerDisableV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membersControllerDisableV1>>,
    TError,
    { memberId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membersControllerDisableV1>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationKey = ['membersControllerDisableV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membersControllerDisableV1>>,
    { memberId: string }
  > = (props) => {
    const { memberId } = props ?? {};

    return membersControllerDisableV1(memberId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembersControllerDisableV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerDisableV1>>
>;

export type MembersControllerDisableV1MutationError = ProblemDetailsResponse;

export const useMembersControllerDisableV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof membersControllerDisableV1>>,
      TError,
      { memberId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof membersControllerDisableV1>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationOptions = getMembersControllerDisableV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const membersControllerEnableV1 = (
  memberId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/members/${memberId}/enable`, method: 'POST', signal }, options);
};

export const getMembersControllerEnableV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof membersControllerEnableV1>>,
    TError,
    { memberId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof membersControllerEnableV1>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationKey = ['membersControllerEnableV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof membersControllerEnableV1>>,
    { memberId: string }
  > = (props) => {
    const { memberId } = props ?? {};

    return membersControllerEnableV1(memberId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MembersControllerEnableV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof membersControllerEnableV1>>
>;

export type MembersControllerEnableV1MutationError = ProblemDetailsResponse;

export const useMembersControllerEnableV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof membersControllerEnableV1>>,
      TError,
      { memberId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof membersControllerEnableV1>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationOptions = getMembersControllerEnableV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const memberAvatarControllerUploadV1 = (
  memberId: string,
  memberAvatarControllerUploadV1Body: MemberAvatarControllerUploadV1Body,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, memberAvatarControllerUploadV1Body.file);

  return apiFetch<MemberResponse>(
    {
      url: `/v1/members/${memberId}/avatar/photo`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getMemberAvatarControllerUploadV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memberAvatarControllerUploadV1>>,
    TError,
    { memberId: string; data: MemberAvatarControllerUploadV1Body },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memberAvatarControllerUploadV1>>,
  TError,
  { memberId: string; data: MemberAvatarControllerUploadV1Body },
  TContext
> => {
  const mutationKey = ['memberAvatarControllerUploadV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memberAvatarControllerUploadV1>>,
    { memberId: string; data: MemberAvatarControllerUploadV1Body }
  > = (props) => {
    const { memberId, data } = props ?? {};

    return memberAvatarControllerUploadV1(memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemberAvatarControllerUploadV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof memberAvatarControllerUploadV1>>
>;
export type MemberAvatarControllerUploadV1MutationBody = MemberAvatarControllerUploadV1Body;
export type MemberAvatarControllerUploadV1MutationError = ProblemDetailsResponse;

export const useMemberAvatarControllerUploadV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memberAvatarControllerUploadV1>>,
      TError,
      { memberId: string; data: MemberAvatarControllerUploadV1Body },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof memberAvatarControllerUploadV1>>,
  TError,
  { memberId: string; data: MemberAvatarControllerUploadV1Body },
  TContext
> => {
  const mutationOptions = getMemberAvatarControllerUploadV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const memberAvatarControllerRemoveV1 = (
  memberId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>({ url: `/v1/members/${memberId}/avatar/photo`, method: 'DELETE' }, options);
};

export const getMemberAvatarControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof memberAvatarControllerRemoveV1>>,
    TError,
    { memberId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof memberAvatarControllerRemoveV1>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationKey = ['memberAvatarControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof memberAvatarControllerRemoveV1>>,
    { memberId: string }
  > = (props) => {
    const { memberId } = props ?? {};

    return memberAvatarControllerRemoveV1(memberId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MemberAvatarControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof memberAvatarControllerRemoveV1>>
>;

export type MemberAvatarControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useMemberAvatarControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof memberAvatarControllerRemoveV1>>,
      TError,
      { memberId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof memberAvatarControllerRemoveV1>>,
  TError,
  { memberId: string },
  TContext
> => {
  const mutationOptions = getMemberAvatarControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const memberAvatarControllerServeV1 = (
  key: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<Blob>(
    { url: `/v1/members/avatar/${key}`, method: 'GET', responseType: 'blob', signal },
    options,
  );
};

export const getMemberAvatarControllerServeV1QueryKey = (key?: string) => {
  return [`/v1/members/avatar/${key}`] as const;
};

export const getMemberAvatarControllerServeV1QueryOptions = <
  TData = Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof memberAvatarControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMemberAvatarControllerServeV1QueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof memberAvatarControllerServeV1>>> = ({
    signal,
  }) => memberAvatarControllerServeV1(key, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MemberAvatarControllerServeV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof memberAvatarControllerServeV1>>
>;
export type MemberAvatarControllerServeV1QueryError = ProblemDetailsResponse;

export function useMemberAvatarControllerServeV1<
  TData = Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof memberAvatarControllerServeV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof memberAvatarControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemberAvatarControllerServeV1<
  TData = Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof memberAvatarControllerServeV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof memberAvatarControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMemberAvatarControllerServeV1<
  TData = Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof memberAvatarControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMemberAvatarControllerServeV1<
  TData = Awaited<ReturnType<typeof memberAvatarControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof memberAvatarControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMemberAvatarControllerServeV1QueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rolesControllerCreateV1 = (
  createRoleDto: CreateRoleDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateRoleResponse>(
    {
      url: `/v1/roles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRoleDto,
      signal,
    },
    options,
  );
};

export const getRolesControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesControllerCreateV1>>,
    TError,
    { data: CreateRoleDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesControllerCreateV1>>,
  TError,
  { data: CreateRoleDto },
  TContext
> => {
  const mutationKey = ['rolesControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesControllerCreateV1>>,
    { data: CreateRoleDto }
  > = (props) => {
    const { data } = props ?? {};

    return rolesControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rolesControllerCreateV1>>
>;
export type RolesControllerCreateV1MutationBody = CreateRoleDto;
export type RolesControllerCreateV1MutationError = ProblemDetailsResponse;

export const useRolesControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rolesControllerCreateV1>>,
      TError,
      { data: CreateRoleDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rolesControllerCreateV1>>,
  TError,
  { data: CreateRoleDto },
  TContext
> => {
  const mutationOptions = getRolesControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rolesControllerListV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RoleResponse[]>({ url: `/v1/roles`, method: 'GET', signal }, options);
};

export const getRolesControllerListV1QueryKey = () => {
  return [`/v1/roles`] as const;
};

export const getRolesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof rolesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof rolesControllerListV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRolesControllerListV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesControllerListV1>>> = ({ signal }) =>
    rolesControllerListV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rolesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RolesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof rolesControllerListV1>>
>;
export type RolesControllerListV1QueryError = ProblemDetailsResponse;

export function useRolesControllerListV1<
  TData = Awaited<ReturnType<typeof rolesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof rolesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRolesControllerListV1<
  TData = Awaited<ReturnType<typeof rolesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof rolesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRolesControllerListV1<
  TData = Awaited<ReturnType<typeof rolesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRolesControllerListV1<
  TData = Awaited<ReturnType<typeof rolesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRolesControllerListV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rolesControllerGetV1 = (
  roleId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RoleResponse>({ url: `/v1/roles/${roleId}`, method: 'GET', signal }, options);
};

export const getRolesControllerGetV1QueryKey = (roleId?: string) => {
  return [`/v1/roles/${roleId}`] as const;
};

export const getRolesControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof rolesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRolesControllerGetV1QueryKey(roleId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesControllerGetV1>>> = ({ signal }) =>
    rolesControllerGetV1(roleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!roleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rolesControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RolesControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof rolesControllerGetV1>>
>;
export type RolesControllerGetV1QueryError = ProblemDetailsResponse;

export function useRolesControllerGetV1<
  TData = Awaited<ReturnType<typeof rolesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  roleId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof rolesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRolesControllerGetV1<
  TData = Awaited<ReturnType<typeof rolesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rolesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof rolesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRolesControllerGetV1<
  TData = Awaited<ReturnType<typeof rolesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRolesControllerGetV1<
  TData = Awaited<ReturnType<typeof rolesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  roleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rolesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRolesControllerGetV1QueryOptions(roleId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rolesControllerUpdateV1 = (
  roleId: string,
  updateRoleDto: UpdateRoleDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/roles/${roleId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateRoleDto,
    },
    options,
  );
};

export const getRolesControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rolesControllerUpdateV1>>,
    TError,
    { roleId: string; data: UpdateRoleDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rolesControllerUpdateV1>>,
  TError,
  { roleId: string; data: UpdateRoleDto },
  TContext
> => {
  const mutationKey = ['rolesControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rolesControllerUpdateV1>>,
    { roleId: string; data: UpdateRoleDto }
  > = (props) => {
    const { roleId, data } = props ?? {};

    return rolesControllerUpdateV1(roleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RolesControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rolesControllerUpdateV1>>
>;
export type RolesControllerUpdateV1MutationBody = UpdateRoleDto;
export type RolesControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useRolesControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rolesControllerUpdateV1>>,
      TError,
      { roleId: string; data: UpdateRoleDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rolesControllerUpdateV1>>,
  TError,
  { roleId: string; data: UpdateRoleDto },
  TContext
> => {
  const mutationOptions = getRolesControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const householdControllerGetV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdResponse>({ url: `/v1/household`, method: 'GET', signal }, options);
};

export const getHouseholdControllerGetV1QueryKey = () => {
  return [`/v1/household`] as const;
};

export const getHouseholdControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof householdControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof householdControllerGetV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHouseholdControllerGetV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof householdControllerGetV1>>> = ({
    signal,
  }) => householdControllerGetV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof householdControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HouseholdControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof householdControllerGetV1>>
>;
export type HouseholdControllerGetV1QueryError = ProblemDetailsResponse;

export function useHouseholdControllerGetV1<
  TData = Awaited<ReturnType<typeof householdControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof householdControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof householdControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHouseholdControllerGetV1<
  TData = Awaited<ReturnType<typeof householdControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof householdControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof householdControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHouseholdControllerGetV1<
  TData = Awaited<ReturnType<typeof householdControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHouseholdControllerGetV1<
  TData = Awaited<ReturnType<typeof householdControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHouseholdControllerGetV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const householdControllerUpdateV1 = (
  updateHouseholdDto: UpdateHouseholdDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<HouseholdResponse>(
    {
      url: `/v1/household`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateHouseholdDto,
    },
    options,
  );
};

export const getHouseholdControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof householdControllerUpdateV1>>,
    TError,
    { data: UpdateHouseholdDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof householdControllerUpdateV1>>,
  TError,
  { data: UpdateHouseholdDto },
  TContext
> => {
  const mutationKey = ['householdControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof householdControllerUpdateV1>>,
    { data: UpdateHouseholdDto }
  > = (props) => {
    const { data } = props ?? {};

    return householdControllerUpdateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HouseholdControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof householdControllerUpdateV1>>
>;
export type HouseholdControllerUpdateV1MutationBody = UpdateHouseholdDto;
export type HouseholdControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useHouseholdControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof householdControllerUpdateV1>>,
      TError,
      { data: UpdateHouseholdDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof householdControllerUpdateV1>>,
  TError,
  { data: UpdateHouseholdDto },
  TContext
> => {
  const mutationOptions = getHouseholdControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Irreversibly delete the household and all its data (OWNER ONLY).
 */
export const householdDataControllerEraseV1 = (options?: SecondParameter<typeof apiFetch>) => {
  return apiFetch<EraseHouseholdResponse>({ url: `/v1/household`, method: 'DELETE' }, options);
};

export const getHouseholdDataControllerEraseV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof householdDataControllerEraseV1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof householdDataControllerEraseV1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['householdDataControllerEraseV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof householdDataControllerEraseV1>>,
    void
  > = () => {
    return householdDataControllerEraseV1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HouseholdDataControllerEraseV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof householdDataControllerEraseV1>>
>;

export type HouseholdDataControllerEraseV1MutationError = ProblemDetailsResponse;

/**
 * @summary Irreversibly delete the household and all its data (OWNER ONLY).
 */
export const useHouseholdDataControllerEraseV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof householdDataControllerEraseV1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof householdDataControllerEraseV1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getHouseholdDataControllerEraseV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerLoginV1 = (
  loginDto: LoginDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SessionResponse>(
    {
      url: `/v1/auth/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loginDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerLoginV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLoginV1>>,
    TError,
    { data: LoginDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLoginV1>>,
  TError,
  { data: LoginDto },
  TContext
> => {
  const mutationKey = ['authControllerLoginV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLoginV1>>,
    { data: LoginDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerLoginV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLoginV1>>
>;
export type AuthControllerLoginV1MutationBody = LoginDto;
export type AuthControllerLoginV1MutationError = ProblemDetailsResponse;

export const useAuthControllerLoginV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerLoginV1>>,
      TError,
      { data: LoginDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerLoginV1>>,
  TError,
  { data: LoginDto },
  TContext
> => {
  const mutationOptions = getAuthControllerLoginV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerChildLoginV1 = (
  childLoginDto: ChildLoginDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SessionResponse>(
    {
      url: `/v1/auth/child-login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: childLoginDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerChildLoginV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerChildLoginV1>>,
    TError,
    { data: ChildLoginDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerChildLoginV1>>,
  TError,
  { data: ChildLoginDto },
  TContext
> => {
  const mutationKey = ['authControllerChildLoginV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerChildLoginV1>>,
    { data: ChildLoginDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerChildLoginV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerChildLoginV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerChildLoginV1>>
>;
export type AuthControllerChildLoginV1MutationBody = ChildLoginDto;
export type AuthControllerChildLoginV1MutationError = ProblemDetailsResponse;

export const useAuthControllerChildLoginV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerChildLoginV1>>,
      TError,
      { data: ChildLoginDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerChildLoginV1>>,
  TError,
  { data: ChildLoginDto },
  TContext
> => {
  const mutationOptions = getAuthControllerChildLoginV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerRefreshV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<AuthTokenResponse>({ url: `/v1/auth/refresh`, method: 'POST', signal }, options);
};

export const getAuthControllerRefreshV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRefreshV1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRefreshV1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authControllerRefreshV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRefreshV1>>,
    void
  > = () => {
    return authControllerRefreshV1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRefreshV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRefreshV1>>
>;

export type AuthControllerRefreshV1MutationError = ProblemDetailsResponse;

export const useAuthControllerRefreshV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRefreshV1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRefreshV1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAuthControllerRefreshV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerInvitationContextV1 = (
  token: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<InvitationContextResponse>(
    { url: `/v1/auth/invitations/${token}`, method: 'GET', signal },
    options,
  );
};

export const getAuthControllerInvitationContextV1QueryKey = (token?: string) => {
  return [`/v1/auth/invitations/${token}`] as const;
};

export const getAuthControllerInvitationContextV1QueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
  TError = ProblemDetailsResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerInvitationContextV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerInvitationContextV1QueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerInvitationContextV1>>> = ({
    signal,
  }) => authControllerInvitationContextV1(token, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!token, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerInvitationContextV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerInvitationContextV1>>
>;
export type AuthControllerInvitationContextV1QueryError = ProblemDetailsResponse;

export function useAuthControllerInvitationContextV1<
  TData = Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
  TError = ProblemDetailsResponse,
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerInvitationContextV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerInvitationContextV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerInvitationContextV1<
  TData = Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
  TError = ProblemDetailsResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerInvitationContextV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerInvitationContextV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerInvitationContextV1<
  TData = Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
  TError = ProblemDetailsResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerInvitationContextV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAuthControllerInvitationContextV1<
  TData = Awaited<ReturnType<typeof authControllerInvitationContextV1>>,
  TError = ProblemDetailsResponse,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerInvitationContextV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerInvitationContextV1QueryOptions(token, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerAcceptInvitationV1 = (
  token: string,
  acceptInvitationDto: AcceptInvitationDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<AcceptInvitationResponse>(
    {
      url: `/v1/auth/invitations/${token}/accept`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: acceptInvitationDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerAcceptInvitationV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerAcceptInvitationV1>>,
    TError,
    { token: string; data: AcceptInvitationDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerAcceptInvitationV1>>,
  TError,
  { token: string; data: AcceptInvitationDto },
  TContext
> => {
  const mutationKey = ['authControllerAcceptInvitationV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerAcceptInvitationV1>>,
    { token: string; data: AcceptInvitationDto }
  > = (props) => {
    const { token, data } = props ?? {};

    return authControllerAcceptInvitationV1(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerAcceptInvitationV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerAcceptInvitationV1>>
>;
export type AuthControllerAcceptInvitationV1MutationBody = AcceptInvitationDto;
export type AuthControllerAcceptInvitationV1MutationError = ProblemDetailsResponse;

export const useAuthControllerAcceptInvitationV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerAcceptInvitationV1>>,
      TError,
      { token: string; data: AcceptInvitationDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerAcceptInvitationV1>>,
  TError,
  { token: string; data: AcceptInvitationDto },
  TContext
> => {
  const mutationOptions = getAuthControllerAcceptInvitationV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerRequestPasswordResetV1 = (
  requestPasswordResetDto: RequestPasswordResetDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/auth/password-reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestPasswordResetDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerRequestPasswordResetV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRequestPasswordResetV1>>,
    TError,
    { data: RequestPasswordResetDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRequestPasswordResetV1>>,
  TError,
  { data: RequestPasswordResetDto },
  TContext
> => {
  const mutationKey = ['authControllerRequestPasswordResetV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRequestPasswordResetV1>>,
    { data: RequestPasswordResetDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerRequestPasswordResetV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRequestPasswordResetV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRequestPasswordResetV1>>
>;
export type AuthControllerRequestPasswordResetV1MutationBody = RequestPasswordResetDto;
export type AuthControllerRequestPasswordResetV1MutationError = ProblemDetailsResponse;

export const useAuthControllerRequestPasswordResetV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRequestPasswordResetV1>>,
      TError,
      { data: RequestPasswordResetDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRequestPasswordResetV1>>,
  TError,
  { data: RequestPasswordResetDto },
  TContext
> => {
  const mutationOptions = getAuthControllerRequestPasswordResetV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerResetPasswordV1 = (
  token: string,
  resetPasswordDto: ResetPasswordDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/auth/password-reset/${token}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerResetPasswordV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResetPasswordV1>>,
    TError,
    { token: string; data: ResetPasswordDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResetPasswordV1>>,
  TError,
  { token: string; data: ResetPasswordDto },
  TContext
> => {
  const mutationKey = ['authControllerResetPasswordV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResetPasswordV1>>,
    { token: string; data: ResetPasswordDto }
  > = (props) => {
    const { token, data } = props ?? {};

    return authControllerResetPasswordV1(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerResetPasswordV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResetPasswordV1>>
>;
export type AuthControllerResetPasswordV1MutationBody = ResetPasswordDto;
export type AuthControllerResetPasswordV1MutationError = ProblemDetailsResponse;

export const useAuthControllerResetPasswordV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResetPasswordV1>>,
      TError,
      { token: string; data: ResetPasswordDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResetPasswordV1>>,
  TError,
  { token: string; data: ResetPasswordDto },
  TContext
> => {
  const mutationOptions = getAuthControllerResetPasswordV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerVerifyEmailV1 = (
  token: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/auth/verify-email/${token}`, method: 'POST', signal }, options);
};

export const getAuthControllerVerifyEmailV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerVerifyEmailV1>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerVerifyEmailV1>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ['authControllerVerifyEmailV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerVerifyEmailV1>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return authControllerVerifyEmailV1(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerVerifyEmailV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerVerifyEmailV1>>
>;

export type AuthControllerVerifyEmailV1MutationError = ProblemDetailsResponse;

export const useAuthControllerVerifyEmailV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerVerifyEmailV1>>,
      TError,
      { token: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerVerifyEmailV1>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationOptions = getAuthControllerVerifyEmailV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerCsrfTokenV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CsrfResponse>({ url: `/v1/auth/csrf`, method: 'GET', signal }, options);
};

export const getAuthControllerCsrfTokenV1QueryKey = () => {
  return [`/v1/auth/csrf`] as const;
};

export const getAuthControllerCsrfTokenV1QueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerCsrfTokenV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerCsrfTokenV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerCsrfTokenV1>>> = ({
    signal,
  }) => authControllerCsrfTokenV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerCsrfTokenV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCsrfTokenV1>>
>;
export type AuthControllerCsrfTokenV1QueryError = ProblemDetailsResponse;

export function useAuthControllerCsrfTokenV1<
  TData = Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerCsrfTokenV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerCsrfTokenV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerCsrfTokenV1<
  TData = Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerCsrfTokenV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerCsrfTokenV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerCsrfTokenV1<
  TData = Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerCsrfTokenV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAuthControllerCsrfTokenV1<
  TData = Awaited<ReturnType<typeof authControllerCsrfTokenV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerCsrfTokenV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerCsrfTokenV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerMeV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<MeResponse>({ url: `/v1/auth/me`, method: 'GET', signal }, options);
};

export const getAuthControllerMeV1QueryKey = () => {
  return [`/v1/auth/me`] as const;
};

export const getAuthControllerMeV1QueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerMeV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerMeV1>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerMeV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerMeV1>>> = ({ signal }) =>
    authControllerMeV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerMeV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerMeV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerMeV1>>
>;
export type AuthControllerMeV1QueryError = ProblemDetailsResponse;

export function useAuthControllerMeV1<
  TData = Awaited<ReturnType<typeof authControllerMeV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerMeV1>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerMeV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerMeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerMeV1<
  TData = Awaited<ReturnType<typeof authControllerMeV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerMeV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerMeV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerMeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerMeV1<
  TData = Awaited<ReturnType<typeof authControllerMeV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerMeV1>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAuthControllerMeV1<
  TData = Awaited<ReturnType<typeof authControllerMeV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerMeV1>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerMeV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerSetMyLocaleV1 = (
  setMemberLocaleDto: SetMemberLocaleDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/auth/me/locale`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setMemberLocaleDto,
    },
    options,
  );
};

export const getAuthControllerSetMyLocaleV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSetMyLocaleV1>>,
    TError,
    { data: SetMemberLocaleDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSetMyLocaleV1>>,
  TError,
  { data: SetMemberLocaleDto },
  TContext
> => {
  const mutationKey = ['authControllerSetMyLocaleV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSetMyLocaleV1>>,
    { data: SetMemberLocaleDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerSetMyLocaleV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSetMyLocaleV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSetMyLocaleV1>>
>;
export type AuthControllerSetMyLocaleV1MutationBody = SetMemberLocaleDto;
export type AuthControllerSetMyLocaleV1MutationError = ProblemDetailsResponse;

export const useAuthControllerSetMyLocaleV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSetMyLocaleV1>>,
      TError,
      { data: SetMemberLocaleDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSetMyLocaleV1>>,
  TError,
  { data: SetMemberLocaleDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSetMyLocaleV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerLogoutV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/auth/logout`, method: 'POST', signal }, options);
};

export const getAuthControllerLogoutV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerLogoutV1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerLogoutV1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authControllerLogoutV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerLogoutV1>>,
    void
  > = () => {
    return authControllerLogoutV1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLogoutV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerLogoutV1>>
>;

export type AuthControllerLogoutV1MutationError = ProblemDetailsResponse;

export const useAuthControllerLogoutV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerLogoutV1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerLogoutV1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAuthControllerLogoutV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerResendVerificationV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/auth/resend-verification`, method: 'POST', signal }, options);
};

export const getAuthControllerResendVerificationV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResendVerificationV1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResendVerificationV1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authControllerResendVerificationV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResendVerificationV1>>,
    void
  > = () => {
    return authControllerResendVerificationV1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerResendVerificationV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResendVerificationV1>>
>;

export type AuthControllerResendVerificationV1MutationError = ProblemDetailsResponse;

export const useAuthControllerResendVerificationV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResendVerificationV1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResendVerificationV1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAuthControllerResendVerificationV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerChangePasswordV1 = (
  changePasswordDto: ChangePasswordDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/auth/change-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changePasswordDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerChangePasswordV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerChangePasswordV1>>,
    TError,
    { data: ChangePasswordDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerChangePasswordV1>>,
  TError,
  { data: ChangePasswordDto },
  TContext
> => {
  const mutationKey = ['authControllerChangePasswordV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerChangePasswordV1>>,
    { data: ChangePasswordDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerChangePasswordV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerChangePasswordV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerChangePasswordV1>>
>;
export type AuthControllerChangePasswordV1MutationBody = ChangePasswordDto;
export type AuthControllerChangePasswordV1MutationError = ProblemDetailsResponse;

export const useAuthControllerChangePasswordV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerChangePasswordV1>>,
      TError,
      { data: ChangePasswordDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerChangePasswordV1>>,
  TError,
  { data: ChangePasswordDto },
  TContext
> => {
  const mutationOptions = getAuthControllerChangePasswordV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerSetChildPinV1 = (
  childId: string,
  setChildPinDto: SetChildPinDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/auth/children/${childId}/pin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setChildPinDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerSetChildPinV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSetChildPinV1>>,
    TError,
    { childId: string; data: SetChildPinDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSetChildPinV1>>,
  TError,
  { childId: string; data: SetChildPinDto },
  TContext
> => {
  const mutationKey = ['authControllerSetChildPinV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSetChildPinV1>>,
    { childId: string; data: SetChildPinDto }
  > = (props) => {
    const { childId, data } = props ?? {};

    return authControllerSetChildPinV1(childId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSetChildPinV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSetChildPinV1>>
>;
export type AuthControllerSetChildPinV1MutationBody = SetChildPinDto;
export type AuthControllerSetChildPinV1MutationError = ProblemDetailsResponse;

export const useAuthControllerSetChildPinV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSetChildPinV1>>,
      TError,
      { childId: string; data: SetChildPinDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSetChildPinV1>>,
  TError,
  { childId: string; data: SetChildPinDto },
  TContext
> => {
  const mutationOptions = getAuthControllerSetChildPinV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerInviteMemberV1 = (
  inviteMemberDto: InviteMemberDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<InviteMemberResponse>(
    {
      url: `/v1/auth/members`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteMemberDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerInviteMemberV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerInviteMemberV1>>,
    TError,
    { data: InviteMemberDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerInviteMemberV1>>,
  TError,
  { data: InviteMemberDto },
  TContext
> => {
  const mutationKey = ['authControllerInviteMemberV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerInviteMemberV1>>,
    { data: InviteMemberDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerInviteMemberV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerInviteMemberV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerInviteMemberV1>>
>;
export type AuthControllerInviteMemberV1MutationBody = InviteMemberDto;
export type AuthControllerInviteMemberV1MutationError = ProblemDetailsResponse;

export const useAuthControllerInviteMemberV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerInviteMemberV1>>,
      TError,
      { data: InviteMemberDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerInviteMemberV1>>,
  TError,
  { data: InviteMemberDto },
  TContext
> => {
  const mutationOptions = getAuthControllerInviteMemberV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerListInvitationsV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<InvitationListItemResponse[]>(
    { url: `/v1/auth/members/invitations`, method: 'GET', signal },
    options,
  );
};

export const getAuthControllerListInvitationsV1QueryKey = () => {
  return [`/v1/auth/members/invitations`] as const;
};

export const getAuthControllerListInvitationsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof authControllerListInvitationsV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerListInvitationsV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerListInvitationsV1>>> = ({
    signal,
  }) => authControllerListInvitationsV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerListInvitationsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerListInvitationsV1>>
>;
export type AuthControllerListInvitationsV1QueryError = ProblemDetailsResponse;

export function useAuthControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerListInvitationsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerListInvitationsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerListInvitationsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
          TError,
          Awaited<ReturnType<typeof authControllerListInvitationsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerListInvitationsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAuthControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof authControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof authControllerListInvitationsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAuthControllerListInvitationsV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerResendInvitationV1 = (
  id: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ResendInvitationResponse>(
    { url: `/v1/auth/invitations/${id}/resend`, method: 'POST', signal },
    options,
  );
};

export const getAuthControllerResendInvitationV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerResendInvitationV1>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerResendInvitationV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['authControllerResendInvitationV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerResendInvitationV1>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return authControllerResendInvitationV1(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerResendInvitationV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerResendInvitationV1>>
>;

export type AuthControllerResendInvitationV1MutationError = ProblemDetailsResponse;

export const useAuthControllerResendInvitationV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerResendInvitationV1>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerResendInvitationV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAuthControllerResendInvitationV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const authControllerRevokeInvitationV1 = (
  id: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/auth/invitations/${id}/revoke`, method: 'POST', signal },
    options,
  );
};

export const getAuthControllerRevokeInvitationV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerRevokeInvitationV1>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerRevokeInvitationV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['authControllerRevokeInvitationV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerRevokeInvitationV1>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return authControllerRevokeInvitationV1(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRevokeInvitationV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerRevokeInvitationV1>>
>;

export type AuthControllerRevokeInvitationV1MutationError = ProblemDetailsResponse;

export const useAuthControllerRevokeInvitationV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerRevokeInvitationV1>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerRevokeInvitationV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAuthControllerRevokeInvitationV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerCreateV1 = (
  createTemplateDto: CreateTemplateDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateTemplateResponse>(
    {
      url: `/v1/tasks/templates`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTemplateDto,
      signal,
    },
    options,
  );
};

export const getTemplatesControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerCreateV1>>,
    TError,
    { data: CreateTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerCreateV1>>,
  TError,
  { data: CreateTemplateDto },
  TContext
> => {
  const mutationKey = ['templatesControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerCreateV1>>,
    { data: CreateTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return templatesControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerCreateV1>>
>;
export type TemplatesControllerCreateV1MutationBody = CreateTemplateDto;
export type TemplatesControllerCreateV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerCreateV1>>,
      TError,
      { data: CreateTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerCreateV1>>,
  TError,
  { data: CreateTemplateDto },
  TContext
> => {
  const mutationOptions = getTemplatesControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerListV1 = (
  params?: TemplatesControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<TemplatesControllerListV1200>(
    { url: `/v1/tasks/templates`, method: 'GET', params, signal },
    options,
  );
};

export const getTemplatesControllerListV1QueryKey = (params?: TemplatesControllerListV1Params) => {
  return [`/v1/tasks/templates`, ...(params ? [params] : [])] as const;
};

export const getTemplatesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof templatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemplatesControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesControllerListV1>>> = ({
    signal,
  }) => templatesControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templatesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplatesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerListV1>>
>;
export type TemplatesControllerListV1QueryError = ProblemDetailsResponse;

export function useTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof templatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | TemplatesControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof templatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof templatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof templatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplatesControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const templatesControllerGetV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<TemplateResponse>(
    { url: `/v1/tasks/templates/${templateId}`, method: 'GET', signal },
    options,
  );
};

export const getTemplatesControllerGetV1QueryKey = (templateId?: string) => {
  return [`/v1/tasks/templates/${templateId}`] as const;
};

export const getTemplatesControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof templatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemplatesControllerGetV1QueryKey(templateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof templatesControllerGetV1>>> = ({
    signal,
  }) => templatesControllerGetV1(templateId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!templateId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templatesControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplatesControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerGetV1>>
>;
export type TemplatesControllerGetV1QueryError = ProblemDetailsResponse;

export function useTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof templatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof templatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templatesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof templatesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof templatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof templatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templatesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplatesControllerGetV1QueryOptions(templateId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const templatesControllerUpdateV1 = (
  templateId: string,
  updateTemplateDto: UpdateTemplateDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/templates/${templateId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateTemplateDto,
    },
    options,
  );
};

export const getTemplatesControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerUpdateV1>>,
    TError,
    { templateId: string; data: UpdateTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerUpdateV1>>,
  TError,
  { templateId: string; data: UpdateTemplateDto },
  TContext
> => {
  const mutationKey = ['templatesControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerUpdateV1>>,
    { templateId: string; data: UpdateTemplateDto }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return templatesControllerUpdateV1(templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerUpdateV1>>
>;
export type TemplatesControllerUpdateV1MutationBody = UpdateTemplateDto;
export type TemplatesControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerUpdateV1>>,
      TError,
      { templateId: string; data: UpdateTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerUpdateV1>>,
  TError,
  { templateId: string; data: UpdateTemplateDto },
  TContext
> => {
  const mutationOptions = getTemplatesControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerRemoveV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>({ url: `/v1/tasks/templates/${templateId}`, method: 'DELETE' }, options);
};

export const getTemplatesControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerRemoveV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['templatesControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerRemoveV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return templatesControllerRemoveV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerRemoveV1>>
>;

export type TemplatesControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerRemoveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerRemoveV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getTemplatesControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerPauseV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/tasks/templates/${templateId}/pause`, method: 'POST', signal },
    options,
  );
};

export const getTemplatesControllerPauseV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerPauseV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerPauseV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['templatesControllerPauseV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerPauseV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return templatesControllerPauseV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerPauseV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerPauseV1>>
>;

export type TemplatesControllerPauseV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerPauseV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerPauseV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerPauseV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getTemplatesControllerPauseV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerResumeV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/tasks/templates/${templateId}/resume`, method: 'POST', signal },
    options,
  );
};

export const getTemplatesControllerResumeV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerResumeV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerResumeV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['templatesControllerResumeV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerResumeV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return templatesControllerResumeV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerResumeV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerResumeV1>>
>;

export type TemplatesControllerResumeV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerResumeV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerResumeV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerResumeV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getTemplatesControllerResumeV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerArchiveV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/tasks/templates/${templateId}/archive`, method: 'POST', signal },
    options,
  );
};

export const getTemplatesControllerArchiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerArchiveV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerArchiveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['templatesControllerArchiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerArchiveV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return templatesControllerArchiveV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerArchiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerArchiveV1>>
>;

export type TemplatesControllerArchiveV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerArchiveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerArchiveV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerArchiveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getTemplatesControllerArchiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templatesControllerRestoreV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/tasks/templates/${templateId}/restore`, method: 'POST', signal },
    options,
  );
};

export const getTemplatesControllerRestoreV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templatesControllerRestoreV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templatesControllerRestoreV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['templatesControllerRestoreV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templatesControllerRestoreV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return templatesControllerRestoreV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplatesControllerRestoreV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templatesControllerRestoreV1>>
>;

export type TemplatesControllerRestoreV1MutationError = ProblemDetailsResponse;

export const useTemplatesControllerRestoreV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templatesControllerRestoreV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templatesControllerRestoreV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getTemplatesControllerRestoreV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const occurrencesControllerGetV1 = (
  occurrenceId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<OccurrenceResponse>(
    { url: `/v1/tasks/occurrences/${occurrenceId}`, method: 'GET', signal },
    options,
  );
};

export const getOccurrencesControllerGetV1QueryKey = (occurrenceId?: string) => {
  return [`/v1/tasks/occurrences/${occurrenceId}`] as const;
};

export const getOccurrencesControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  occurrenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof occurrencesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOccurrencesControllerGetV1QueryKey(occurrenceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof occurrencesControllerGetV1>>> = ({
    signal,
  }) => occurrencesControllerGetV1(occurrenceId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!occurrenceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OccurrencesControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof occurrencesControllerGetV1>>
>;
export type OccurrencesControllerGetV1QueryError = ProblemDetailsResponse;

export function useOccurrencesControllerGetV1<
  TData = Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  occurrenceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof occurrencesControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof occurrencesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOccurrencesControllerGetV1<
  TData = Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  occurrenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof occurrencesControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof occurrencesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOccurrencesControllerGetV1<
  TData = Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  occurrenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof occurrencesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useOccurrencesControllerGetV1<
  TData = Awaited<ReturnType<typeof occurrencesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  occurrenceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof occurrencesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOccurrencesControllerGetV1QueryOptions(occurrenceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const occurrencesControllerBackfillV1 = (
  occurrenceId: string,
  backfillOccurrenceDto: BackfillOccurrenceDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/occurrences/${occurrenceId}/backfill`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: backfillOccurrenceDto,
      signal,
    },
    options,
  );
};

export const getOccurrencesControllerBackfillV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof occurrencesControllerBackfillV1>>,
    TError,
    { occurrenceId: string; data: BackfillOccurrenceDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof occurrencesControllerBackfillV1>>,
  TError,
  { occurrenceId: string; data: BackfillOccurrenceDto },
  TContext
> => {
  const mutationKey = ['occurrencesControllerBackfillV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof occurrencesControllerBackfillV1>>,
    { occurrenceId: string; data: BackfillOccurrenceDto }
  > = (props) => {
    const { occurrenceId, data } = props ?? {};

    return occurrencesControllerBackfillV1(occurrenceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OccurrencesControllerBackfillV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof occurrencesControllerBackfillV1>>
>;
export type OccurrencesControllerBackfillV1MutationBody = BackfillOccurrenceDto;
export type OccurrencesControllerBackfillV1MutationError = ProblemDetailsResponse;

export const useOccurrencesControllerBackfillV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof occurrencesControllerBackfillV1>>,
      TError,
      { occurrenceId: string; data: BackfillOccurrenceDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof occurrencesControllerBackfillV1>>,
  TError,
  { occurrenceId: string; data: BackfillOccurrenceDto },
  TContext
> => {
  const mutationOptions = getOccurrencesControllerBackfillV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const occurrencesControllerRedoV1 = (
  occurrenceId: string,
  redoOccurrenceDto: RedoOccurrenceDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/occurrences/${occurrenceId}/redo`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: redoOccurrenceDto,
      signal,
    },
    options,
  );
};

export const getOccurrencesControllerRedoV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof occurrencesControllerRedoV1>>,
    TError,
    { occurrenceId: string; data: RedoOccurrenceDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof occurrencesControllerRedoV1>>,
  TError,
  { occurrenceId: string; data: RedoOccurrenceDto },
  TContext
> => {
  const mutationKey = ['occurrencesControllerRedoV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof occurrencesControllerRedoV1>>,
    { occurrenceId: string; data: RedoOccurrenceDto }
  > = (props) => {
    const { occurrenceId, data } = props ?? {};

    return occurrencesControllerRedoV1(occurrenceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OccurrencesControllerRedoV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof occurrencesControllerRedoV1>>
>;
export type OccurrencesControllerRedoV1MutationBody = RedoOccurrenceDto;
export type OccurrencesControllerRedoV1MutationError = ProblemDetailsResponse;

export const useOccurrencesControllerRedoV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof occurrencesControllerRedoV1>>,
      TError,
      { occurrenceId: string; data: RedoOccurrenceDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof occurrencesControllerRedoV1>>,
  TError,
  { occurrenceId: string; data: RedoOccurrenceDto },
  TContext
> => {
  const mutationOptions = getOccurrencesControllerRedoV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const occurrencesControllerApproveV1 = (
  occurrenceId: string,
  approveOccurrenceDto: ApproveOccurrenceDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/occurrences/${occurrenceId}/approve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: approveOccurrenceDto,
      signal,
    },
    options,
  );
};

export const getOccurrencesControllerApproveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof occurrencesControllerApproveV1>>,
    TError,
    { occurrenceId: string; data: ApproveOccurrenceDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof occurrencesControllerApproveV1>>,
  TError,
  { occurrenceId: string; data: ApproveOccurrenceDto },
  TContext
> => {
  const mutationKey = ['occurrencesControllerApproveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof occurrencesControllerApproveV1>>,
    { occurrenceId: string; data: ApproveOccurrenceDto }
  > = (props) => {
    const { occurrenceId, data } = props ?? {};

    return occurrencesControllerApproveV1(occurrenceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OccurrencesControllerApproveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof occurrencesControllerApproveV1>>
>;
export type OccurrencesControllerApproveV1MutationBody = ApproveOccurrenceDto;
export type OccurrencesControllerApproveV1MutationError = ProblemDetailsResponse;

export const useOccurrencesControllerApproveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof occurrencesControllerApproveV1>>,
      TError,
      { occurrenceId: string; data: ApproveOccurrenceDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof occurrencesControllerApproveV1>>,
  TError,
  { occurrenceId: string; data: ApproveOccurrenceDto },
  TContext
> => {
  const mutationOptions = getOccurrencesControllerApproveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const occurrencesControllerRejectV1 = (
  occurrenceId: string,
  rejectOccurrenceDto: RejectOccurrenceDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/occurrences/${occurrenceId}/reject`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: rejectOccurrenceDto,
      signal,
    },
    options,
  );
};

export const getOccurrencesControllerRejectV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof occurrencesControllerRejectV1>>,
    TError,
    { occurrenceId: string; data: RejectOccurrenceDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof occurrencesControllerRejectV1>>,
  TError,
  { occurrenceId: string; data: RejectOccurrenceDto },
  TContext
> => {
  const mutationKey = ['occurrencesControllerRejectV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof occurrencesControllerRejectV1>>,
    { occurrenceId: string; data: RejectOccurrenceDto }
  > = (props) => {
    const { occurrenceId, data } = props ?? {};

    return occurrencesControllerRejectV1(occurrenceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OccurrencesControllerRejectV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof occurrencesControllerRejectV1>>
>;
export type OccurrencesControllerRejectV1MutationBody = RejectOccurrenceDto;
export type OccurrencesControllerRejectV1MutationError = ProblemDetailsResponse;

export const useOccurrencesControllerRejectV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof occurrencesControllerRejectV1>>,
      TError,
      { occurrenceId: string; data: RejectOccurrenceDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof occurrencesControllerRejectV1>>,
  TError,
  { occurrenceId: string; data: RejectOccurrenceDto },
  TContext
> => {
  const mutationOptions = getOccurrencesControllerRejectV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const choreActionsControllerCompleteV1 = (
  choreActionDto: ChoreActionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: choreActionDto,
      signal,
    },
    options,
  );
};

export const getChoreActionsControllerCompleteV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof choreActionsControllerCompleteV1>>,
    TError,
    { data: ChoreActionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof choreActionsControllerCompleteV1>>,
  TError,
  { data: ChoreActionDto },
  TContext
> => {
  const mutationKey = ['choreActionsControllerCompleteV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof choreActionsControllerCompleteV1>>,
    { data: ChoreActionDto }
  > = (props) => {
    const { data } = props ?? {};

    return choreActionsControllerCompleteV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChoreActionsControllerCompleteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof choreActionsControllerCompleteV1>>
>;
export type ChoreActionsControllerCompleteV1MutationBody = ChoreActionDto;
export type ChoreActionsControllerCompleteV1MutationError = ProblemDetailsResponse;

export const useChoreActionsControllerCompleteV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof choreActionsControllerCompleteV1>>,
      TError,
      { data: ChoreActionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof choreActionsControllerCompleteV1>>,
  TError,
  { data: ChoreActionDto },
  TContext
> => {
  const mutationOptions = getChoreActionsControllerCompleteV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const choreActionsControllerSkipV1 = (
  choreActionDto: ChoreActionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/skip`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: choreActionDto,
      signal,
    },
    options,
  );
};

export const getChoreActionsControllerSkipV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof choreActionsControllerSkipV1>>,
    TError,
    { data: ChoreActionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof choreActionsControllerSkipV1>>,
  TError,
  { data: ChoreActionDto },
  TContext
> => {
  const mutationKey = ['choreActionsControllerSkipV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof choreActionsControllerSkipV1>>,
    { data: ChoreActionDto }
  > = (props) => {
    const { data } = props ?? {};

    return choreActionsControllerSkipV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChoreActionsControllerSkipV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof choreActionsControllerSkipV1>>
>;
export type ChoreActionsControllerSkipV1MutationBody = ChoreActionDto;
export type ChoreActionsControllerSkipV1MutationError = ProblemDetailsResponse;

export const useChoreActionsControllerSkipV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof choreActionsControllerSkipV1>>,
      TError,
      { data: ChoreActionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof choreActionsControllerSkipV1>>,
  TError,
  { data: ChoreActionDto },
  TContext
> => {
  const mutationOptions = getChoreActionsControllerSkipV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const choreActionsControllerUncompleteV1 = (
  choreActionDto: ChoreActionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/tasks/uncomplete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: choreActionDto,
      signal,
    },
    options,
  );
};

export const getChoreActionsControllerUncompleteV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof choreActionsControllerUncompleteV1>>,
    TError,
    { data: ChoreActionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof choreActionsControllerUncompleteV1>>,
  TError,
  { data: ChoreActionDto },
  TContext
> => {
  const mutationKey = ['choreActionsControllerUncompleteV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof choreActionsControllerUncompleteV1>>,
    { data: ChoreActionDto }
  > = (props) => {
    const { data } = props ?? {};

    return choreActionsControllerUncompleteV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChoreActionsControllerUncompleteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof choreActionsControllerUncompleteV1>>
>;
export type ChoreActionsControllerUncompleteV1MutationBody = ChoreActionDto;
export type ChoreActionsControllerUncompleteV1MutationError = ProblemDetailsResponse;

export const useChoreActionsControllerUncompleteV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof choreActionsControllerUncompleteV1>>,
      TError,
      { data: ChoreActionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof choreActionsControllerUncompleteV1>>,
  TError,
  { data: ChoreActionDto },
  TContext
> => {
  const mutationOptions = getChoreActionsControllerUncompleteV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const tasksControllerDayV1 = (
  params: TasksControllerDayV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<DayTasksResponse>(
    { url: `/v1/tasks/day`, method: 'GET', params, signal },
    options,
  );
};

export const getTasksControllerDayV1QueryKey = (params?: TasksControllerDayV1Params) => {
  return [`/v1/tasks/day`, ...(params ? [params] : [])] as const;
};

export const getTasksControllerDayV1QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerDayV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerDayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDayV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerDayV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerDayV1>>> = ({ signal }) =>
    tasksControllerDayV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerDayV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TasksControllerDayV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerDayV1>>
>;
export type TasksControllerDayV1QueryError = ProblemDetailsResponse;

export function useTasksControllerDayV1<
  TData = Awaited<ReturnType<typeof tasksControllerDayV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerDayV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDayV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerDayV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerDayV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerDayV1<
  TData = Awaited<ReturnType<typeof tasksControllerDayV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerDayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDayV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerDayV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerDayV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerDayV1<
  TData = Awaited<ReturnType<typeof tasksControllerDayV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerDayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDayV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTasksControllerDayV1<
  TData = Awaited<ReturnType<typeof tasksControllerDayV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerDayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDayV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTasksControllerDayV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tasksControllerMissionsV1 = (
  params?: TasksControllerMissionsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<MissionsResponse>(
    { url: `/v1/tasks/missions`, method: 'GET', params, signal },
    options,
  );
};

export const getTasksControllerMissionsV1QueryKey = (params?: TasksControllerMissionsV1Params) => {
  return [`/v1/tasks/missions`, ...(params ? [params] : [])] as const;
};

export const getTasksControllerMissionsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMissionsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerMissionsV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerMissionsV1>>> = ({
    signal,
  }) => tasksControllerMissionsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TasksControllerMissionsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerMissionsV1>>
>;
export type TasksControllerMissionsV1QueryError = ProblemDetailsResponse;

export function useTasksControllerMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | TasksControllerMissionsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMissionsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerMissionsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMissionsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerMissionsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMissionsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTasksControllerMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMissionsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTasksControllerMissionsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tasksControllerFinishedMissionsV1 = (
  params?: TasksControllerFinishedMissionsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<MissionsResponse>(
    { url: `/v1/tasks/missions/finished`, method: 'GET', params, signal },
    options,
  );
};

export const getTasksControllerFinishedMissionsV1QueryKey = (
  params?: TasksControllerFinishedMissionsV1Params,
) => {
  return [`/v1/tasks/missions/finished`, ...(params ? [params] : [])] as const;
};

export const getTasksControllerFinishedMissionsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerFinishedMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerFinishedMissionsV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>> = ({
    signal,
  }) => tasksControllerFinishedMissionsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TasksControllerFinishedMissionsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>
>;
export type TasksControllerFinishedMissionsV1QueryError = ProblemDetailsResponse;

export function useTasksControllerFinishedMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | TasksControllerFinishedMissionsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerFinishedMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerFinishedMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerFinishedMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerFinishedMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTasksControllerFinishedMissionsV1<
  TData = Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: TasksControllerFinishedMissionsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerFinishedMissionsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTasksControllerFinishedMissionsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tasksControllerWeekV1 = (
  params: TasksControllerWeekV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<WeekAgendaResponse>(
    { url: `/v1/tasks/week`, method: 'GET', params, signal },
    options,
  );
};

export const getTasksControllerWeekV1QueryKey = (params?: TasksControllerWeekV1Params) => {
  return [`/v1/tasks/week`, ...(params ? [params] : [])] as const;
};

export const getTasksControllerWeekV1QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerWeekV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerWeekV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerWeekV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerWeekV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerWeekV1>>> = ({ signal }) =>
    tasksControllerWeekV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerWeekV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TasksControllerWeekV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerWeekV1>>
>;
export type TasksControllerWeekV1QueryError = ProblemDetailsResponse;

export function useTasksControllerWeekV1<
  TData = Awaited<ReturnType<typeof tasksControllerWeekV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerWeekV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerWeekV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerWeekV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerWeekV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerWeekV1<
  TData = Awaited<ReturnType<typeof tasksControllerWeekV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerWeekV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerWeekV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerWeekV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerWeekV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerWeekV1<
  TData = Awaited<ReturnType<typeof tasksControllerWeekV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerWeekV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerWeekV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTasksControllerWeekV1<
  TData = Awaited<ReturnType<typeof tasksControllerWeekV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerWeekV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerWeekV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTasksControllerWeekV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tasksControllerCompletionTrendV1 = (
  params: TasksControllerCompletionTrendV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CompletionTrendResponse>(
    { url: `/v1/tasks/completion-trend`, method: 'GET', params, signal },
    options,
  );
};

export const getTasksControllerCompletionTrendV1QueryKey = (
  params?: TasksControllerCompletionTrendV1Params,
) => {
  return [`/v1/tasks/completion-trend`, ...(params ? [params] : [])] as const;
};

export const getTasksControllerCompletionTrendV1QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerCompletionTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerCompletionTrendV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>> = ({
    signal,
  }) => tasksControllerCompletionTrendV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TasksControllerCompletionTrendV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>
>;
export type TasksControllerCompletionTrendV1QueryError = ProblemDetailsResponse;

export function useTasksControllerCompletionTrendV1<
  TData = Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerCompletionTrendV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerCompletionTrendV1<
  TData = Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerCompletionTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerCompletionTrendV1<
  TData = Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerCompletionTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTasksControllerCompletionTrendV1<
  TData = Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TasksControllerCompletionTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCompletionTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTasksControllerCompletionTrendV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const tasksControllerApprovalsV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ApprovalItemResponse[]>(
    { url: `/v1/tasks/approvals`, method: 'GET', signal },
    options,
  );
};

export const getTasksControllerApprovalsV1QueryKey = () => {
  return [`/v1/tasks/approvals`] as const;
};

export const getTasksControllerApprovalsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof tasksControllerApprovalsV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerApprovalsV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerApprovalsV1>>> = ({
    signal,
  }) => tasksControllerApprovalsV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TasksControllerApprovalsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerApprovalsV1>>
>;
export type TasksControllerApprovalsV1QueryError = ProblemDetailsResponse;

export function useTasksControllerApprovalsV1<
  TData = Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerApprovalsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerApprovalsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerApprovalsV1<
  TData = Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerApprovalsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerApprovalsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTasksControllerApprovalsV1<
  TData = Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerApprovalsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTasksControllerApprovalsV1<
  TData = Awaited<ReturnType<typeof tasksControllerApprovalsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof tasksControllerApprovalsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTasksControllerApprovalsV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const photoProofControllerUploadV1 = (
  occurrenceId: string,
  photoProofControllerUploadV1Body: PhotoProofControllerUploadV1Body,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, photoProofControllerUploadV1Body.file);

  return apiFetch<UploadPhotoProofResponse>(
    {
      url: `/v1/tasks/occurrences/${occurrenceId}/photo-proof`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPhotoProofControllerUploadV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof photoProofControllerUploadV1>>,
    TError,
    { occurrenceId: string; data: PhotoProofControllerUploadV1Body },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof photoProofControllerUploadV1>>,
  TError,
  { occurrenceId: string; data: PhotoProofControllerUploadV1Body },
  TContext
> => {
  const mutationKey = ['photoProofControllerUploadV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof photoProofControllerUploadV1>>,
    { occurrenceId: string; data: PhotoProofControllerUploadV1Body }
  > = (props) => {
    const { occurrenceId, data } = props ?? {};

    return photoProofControllerUploadV1(occurrenceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PhotoProofControllerUploadV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof photoProofControllerUploadV1>>
>;
export type PhotoProofControllerUploadV1MutationBody = PhotoProofControllerUploadV1Body;
export type PhotoProofControllerUploadV1MutationError = ProblemDetailsResponse;

export const usePhotoProofControllerUploadV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof photoProofControllerUploadV1>>,
      TError,
      { occurrenceId: string; data: PhotoProofControllerUploadV1Body },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof photoProofControllerUploadV1>>,
  TError,
  { occurrenceId: string; data: PhotoProofControllerUploadV1Body },
  TContext
> => {
  const mutationOptions = getPhotoProofControllerUploadV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const photoProofControllerPhotoCompleteV1 = (
  photoProofControllerPhotoCompleteV1Body: PhotoProofControllerPhotoCompleteV1Body,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, photoProofControllerPhotoCompleteV1Body.file);
  formData.append(`templateId`, photoProofControllerPhotoCompleteV1Body.templateId);
  formData.append(`localDate`, photoProofControllerPhotoCompleteV1Body.localDate);
  if (photoProofControllerPhotoCompleteV1Body.assigneeId !== undefined) {
    formData.append(`assigneeId`, photoProofControllerPhotoCompleteV1Body.assigneeId);
  }

  return apiFetch<void>(
    {
      url: `/v1/tasks/photo-proof-complete`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPhotoProofControllerPhotoCompleteV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof photoProofControllerPhotoCompleteV1>>,
    TError,
    { data: PhotoProofControllerPhotoCompleteV1Body },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof photoProofControllerPhotoCompleteV1>>,
  TError,
  { data: PhotoProofControllerPhotoCompleteV1Body },
  TContext
> => {
  const mutationKey = ['photoProofControllerPhotoCompleteV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof photoProofControllerPhotoCompleteV1>>,
    { data: PhotoProofControllerPhotoCompleteV1Body }
  > = (props) => {
    const { data } = props ?? {};

    return photoProofControllerPhotoCompleteV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PhotoProofControllerPhotoCompleteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof photoProofControllerPhotoCompleteV1>>
>;
export type PhotoProofControllerPhotoCompleteV1MutationBody =
  PhotoProofControllerPhotoCompleteV1Body;
export type PhotoProofControllerPhotoCompleteV1MutationError = ProblemDetailsResponse;

export const usePhotoProofControllerPhotoCompleteV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof photoProofControllerPhotoCompleteV1>>,
      TError,
      { data: PhotoProofControllerPhotoCompleteV1Body },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof photoProofControllerPhotoCompleteV1>>,
  TError,
  { data: PhotoProofControllerPhotoCompleteV1Body },
  TContext
> => {
  const mutationOptions = getPhotoProofControllerPhotoCompleteV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const photoProofControllerServeV1 = (
  key: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<Blob>(
    { url: `/v1/tasks/photo-proof/${key}`, method: 'GET', responseType: 'blob', signal },
    options,
  );
};

export const getPhotoProofControllerServeV1QueryKey = (key?: string) => {
  return [`/v1/tasks/photo-proof/${key}`] as const;
};

export const getPhotoProofControllerServeV1QueryOptions = <
  TData = Awaited<ReturnType<typeof photoProofControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof photoProofControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPhotoProofControllerServeV1QueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof photoProofControllerServeV1>>> = ({
    signal,
  }) => photoProofControllerServeV1(key, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof photoProofControllerServeV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PhotoProofControllerServeV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof photoProofControllerServeV1>>
>;
export type PhotoProofControllerServeV1QueryError = ProblemDetailsResponse;

export function usePhotoProofControllerServeV1<
  TData = Awaited<ReturnType<typeof photoProofControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof photoProofControllerServeV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof photoProofControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof photoProofControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePhotoProofControllerServeV1<
  TData = Awaited<ReturnType<typeof photoProofControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof photoProofControllerServeV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof photoProofControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof photoProofControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePhotoProofControllerServeV1<
  TData = Awaited<ReturnType<typeof photoProofControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof photoProofControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePhotoProofControllerServeV1<
  TData = Awaited<ReturnType<typeof photoProofControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof photoProofControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPhotoProofControllerServeV1QueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const templateCoverControllerUploadV1 = (
  templateId: string,
  templateCoverControllerUploadV1Body: TemplateCoverControllerUploadV1Body,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, templateCoverControllerUploadV1Body.file);

  return apiFetch<TemplateResponse>(
    {
      url: `/v1/tasks/templates/${templateId}/photo`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getTemplateCoverControllerUploadV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateCoverControllerUploadV1>>,
    TError,
    { templateId: string; data: TemplateCoverControllerUploadV1Body },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateCoverControllerUploadV1>>,
  TError,
  { templateId: string; data: TemplateCoverControllerUploadV1Body },
  TContext
> => {
  const mutationKey = ['templateCoverControllerUploadV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateCoverControllerUploadV1>>,
    { templateId: string; data: TemplateCoverControllerUploadV1Body }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return templateCoverControllerUploadV1(templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateCoverControllerUploadV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templateCoverControllerUploadV1>>
>;
export type TemplateCoverControllerUploadV1MutationBody = TemplateCoverControllerUploadV1Body;
export type TemplateCoverControllerUploadV1MutationError = ProblemDetailsResponse;

export const useTemplateCoverControllerUploadV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateCoverControllerUploadV1>>,
      TError,
      { templateId: string; data: TemplateCoverControllerUploadV1Body },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templateCoverControllerUploadV1>>,
  TError,
  { templateId: string; data: TemplateCoverControllerUploadV1Body },
  TContext
> => {
  const mutationOptions = getTemplateCoverControllerUploadV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templateCoverControllerRemoveV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/tasks/templates/${templateId}/photo`, method: 'DELETE' },
    options,
  );
};

export const getTemplateCoverControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof templateCoverControllerRemoveV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof templateCoverControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['templateCoverControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof templateCoverControllerRemoveV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return templateCoverControllerRemoveV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TemplateCoverControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof templateCoverControllerRemoveV1>>
>;

export type TemplateCoverControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useTemplateCoverControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof templateCoverControllerRemoveV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof templateCoverControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getTemplateCoverControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templateCoverControllerServeV1 = (
  key: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<Blob>(
    { url: `/v1/tasks/templates/photo/${key}`, method: 'GET', responseType: 'blob', signal },
    options,
  );
};

export const getTemplateCoverControllerServeV1QueryKey = (key?: string) => {
  return [`/v1/tasks/templates/photo/${key}`] as const;
};

export const getTemplateCoverControllerServeV1QueryOptions = <
  TData = Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCoverControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemplateCoverControllerServeV1QueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof templateCoverControllerServeV1>>> = ({
    signal,
  }) => templateCoverControllerServeV1(key, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateCoverControllerServeV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof templateCoverControllerServeV1>>
>;
export type TemplateCoverControllerServeV1QueryError = ProblemDetailsResponse;

export function useTemplateCoverControllerServeV1<
  TData = Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCoverControllerServeV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof templateCoverControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateCoverControllerServeV1<
  TData = Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCoverControllerServeV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof templateCoverControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateCoverControllerServeV1<
  TData = Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCoverControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTemplateCoverControllerServeV1<
  TData = Awaited<ReturnType<typeof templateCoverControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCoverControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateCoverControllerServeV1QueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rewardGoalControllerGetV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RewardGoalResponse>(
    { url: `/v1/economy/children/${childId}/reward-goal`, method: 'GET', signal },
    options,
  );
};

export const getRewardGoalControllerGetV1QueryKey = (childId?: string) => {
  return [`/v1/economy/children/${childId}/reward-goal`] as const;
};

export const getRewardGoalControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardGoalControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRewardGoalControllerGetV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rewardGoalControllerGetV1>>> = ({
    signal,
  }) => rewardGoalControllerGetV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RewardGoalControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof rewardGoalControllerGetV1>>
>;
export type RewardGoalControllerGetV1QueryError = ProblemDetailsResponse;

export function useRewardGoalControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardGoalControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof rewardGoalControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardGoalControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardGoalControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof rewardGoalControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardGoalControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardGoalControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRewardGoalControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardGoalControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardGoalControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRewardGoalControllerGetV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rewardGoalControllerSetV1 = (
  childId: string,
  setRewardGoalDto: SetRewardGoalDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/children/${childId}/reward-goal`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setRewardGoalDto,
    },
    options,
  );
};

export const getRewardGoalControllerSetV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardGoalControllerSetV1>>,
    TError,
    { childId: string; data: SetRewardGoalDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardGoalControllerSetV1>>,
  TError,
  { childId: string; data: SetRewardGoalDto },
  TContext
> => {
  const mutationKey = ['rewardGoalControllerSetV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardGoalControllerSetV1>>,
    { childId: string; data: SetRewardGoalDto }
  > = (props) => {
    const { childId, data } = props ?? {};

    return rewardGoalControllerSetV1(childId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardGoalControllerSetV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardGoalControllerSetV1>>
>;
export type RewardGoalControllerSetV1MutationBody = SetRewardGoalDto;
export type RewardGoalControllerSetV1MutationError = ProblemDetailsResponse;

export const useRewardGoalControllerSetV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardGoalControllerSetV1>>,
      TError,
      { childId: string; data: SetRewardGoalDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardGoalControllerSetV1>>,
  TError,
  { childId: string; data: SetRewardGoalDto },
  TContext
> => {
  const mutationOptions = getRewardGoalControllerSetV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardGoalControllerClearV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/children/${childId}/reward-goal`, method: 'DELETE' },
    options,
  );
};

export const getRewardGoalControllerClearV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardGoalControllerClearV1>>,
    TError,
    { childId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardGoalControllerClearV1>>,
  TError,
  { childId: string },
  TContext
> => {
  const mutationKey = ['rewardGoalControllerClearV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardGoalControllerClearV1>>,
    { childId: string }
  > = (props) => {
    const { childId } = props ?? {};

    return rewardGoalControllerClearV1(childId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardGoalControllerClearV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardGoalControllerClearV1>>
>;

export type RewardGoalControllerClearV1MutationError = ProblemDetailsResponse;

export const useRewardGoalControllerClearV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardGoalControllerClearV1>>,
      TError,
      { childId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardGoalControllerClearV1>>,
  TError,
  { childId: string },
  TContext
> => {
  const mutationOptions = getRewardGoalControllerClearV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const childRewardOverridesControllerListV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ChildRewardOverrideResponse[]>(
    { url: `/v1/economy/rewards/${rewardId}/overrides`, method: 'GET', signal },
    options,
  );
};

export const getChildRewardOverridesControllerListV1QueryKey = (rewardId?: string) => {
  return [`/v1/economy/rewards/${rewardId}/overrides`] as const;
};

export const getChildRewardOverridesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChildRewardOverridesControllerListV1QueryKey(rewardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>
  > = ({ signal }) => childRewardOverridesControllerListV1(rewardId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!rewardId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChildRewardOverridesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>
>;
export type ChildRewardOverridesControllerListV1QueryError = ProblemDetailsResponse;

export function useChildRewardOverridesControllerListV1<
  TData = Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChildRewardOverridesControllerListV1<
  TData = Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useChildRewardOverridesControllerListV1<
  TData = Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useChildRewardOverridesControllerListV1<
  TData = Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof childRewardOverridesControllerListV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getChildRewardOverridesControllerListV1QueryOptions(rewardId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const childRewardOverridesControllerSetV1 = (
  rewardId: string,
  childId: string,
  setChildRewardOverrideDto: SetChildRewardOverrideDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/rewards/${rewardId}/overrides/${childId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setChildRewardOverrideDto,
    },
    options,
  );
};

export const getChildRewardOverridesControllerSetV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof childRewardOverridesControllerSetV1>>,
    TError,
    { rewardId: string; childId: string; data: SetChildRewardOverrideDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof childRewardOverridesControllerSetV1>>,
  TError,
  { rewardId: string; childId: string; data: SetChildRewardOverrideDto },
  TContext
> => {
  const mutationKey = ['childRewardOverridesControllerSetV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof childRewardOverridesControllerSetV1>>,
    { rewardId: string; childId: string; data: SetChildRewardOverrideDto }
  > = (props) => {
    const { rewardId, childId, data } = props ?? {};

    return childRewardOverridesControllerSetV1(rewardId, childId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChildRewardOverridesControllerSetV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof childRewardOverridesControllerSetV1>>
>;
export type ChildRewardOverridesControllerSetV1MutationBody = SetChildRewardOverrideDto;
export type ChildRewardOverridesControllerSetV1MutationError = ProblemDetailsResponse;

export const useChildRewardOverridesControllerSetV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof childRewardOverridesControllerSetV1>>,
      TError,
      { rewardId: string; childId: string; data: SetChildRewardOverrideDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof childRewardOverridesControllerSetV1>>,
  TError,
  { rewardId: string; childId: string; data: SetChildRewardOverrideDto },
  TContext
> => {
  const mutationOptions = getChildRewardOverridesControllerSetV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const childRewardOverridesControllerRemoveV1 = (
  rewardId: string,
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/overrides/${childId}`, method: 'DELETE' },
    options,
  );
};

export const getChildRewardOverridesControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof childRewardOverridesControllerRemoveV1>>,
    TError,
    { rewardId: string; childId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof childRewardOverridesControllerRemoveV1>>,
  TError,
  { rewardId: string; childId: string },
  TContext
> => {
  const mutationKey = ['childRewardOverridesControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof childRewardOverridesControllerRemoveV1>>,
    { rewardId: string; childId: string }
  > = (props) => {
    const { rewardId, childId } = props ?? {};

    return childRewardOverridesControllerRemoveV1(rewardId, childId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChildRewardOverridesControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof childRewardOverridesControllerRemoveV1>>
>;

export type ChildRewardOverridesControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useChildRewardOverridesControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof childRewardOverridesControllerRemoveV1>>,
      TError,
      { rewardId: string; childId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof childRewardOverridesControllerRemoveV1>>,
  TError,
  { rewardId: string; childId: string },
  TContext
> => {
  const mutationOptions = getChildRewardOverridesControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerCreateV1 = (
  createRewardDto: CreateRewardDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateRewardResponse>(
    {
      url: `/v1/economy/rewards`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRewardDto,
      signal,
    },
    options,
  );
};

export const getRewardsControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerCreateV1>>,
    TError,
    { data: CreateRewardDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerCreateV1>>,
  TError,
  { data: CreateRewardDto },
  TContext
> => {
  const mutationKey = ['rewardsControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerCreateV1>>,
    { data: CreateRewardDto }
  > = (props) => {
    const { data } = props ?? {};

    return rewardsControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerCreateV1>>
>;
export type RewardsControllerCreateV1MutationBody = CreateRewardDto;
export type RewardsControllerCreateV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerCreateV1>>,
      TError,
      { data: CreateRewardDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerCreateV1>>,
  TError,
  { data: CreateRewardDto },
  TContext
> => {
  const mutationOptions = getRewardsControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerListV1 = (
  params?: RewardsControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RewardResponse[]>(
    { url: `/v1/economy/rewards`, method: 'GET', params, signal },
    options,
  );
};

export const getRewardsControllerListV1QueryKey = (params?: RewardsControllerListV1Params) => {
  return [`/v1/economy/rewards`, ...(params ? [params] : [])] as const;
};

export const getRewardsControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof rewardsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RewardsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRewardsControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rewardsControllerListV1>>> = ({
    signal,
  }) => rewardsControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardsControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RewardsControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerListV1>>
>;
export type RewardsControllerListV1QueryError = ProblemDetailsResponse;

export function useRewardsControllerListV1<
  TData = Awaited<ReturnType<typeof rewardsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | RewardsControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof rewardsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardsControllerListV1<
  TData = Awaited<ReturnType<typeof rewardsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RewardsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof rewardsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardsControllerListV1<
  TData = Awaited<ReturnType<typeof rewardsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RewardsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRewardsControllerListV1<
  TData = Awaited<ReturnType<typeof rewardsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RewardsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRewardsControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rewardsControllerGetV1 = (
  rewardId: string,
  params?: RewardsControllerGetV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RewardResponse>(
    { url: `/v1/economy/rewards/${rewardId}`, method: 'GET', params, signal },
    options,
  );
};

export const getRewardsControllerGetV1QueryKey = (
  rewardId?: string,
  params?: RewardsControllerGetV1Params,
) => {
  return [`/v1/economy/rewards/${rewardId}`, ...(params ? [params] : [])] as const;
};

export const getRewardsControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof rewardsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  params?: RewardsControllerGetV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRewardsControllerGetV1QueryKey(rewardId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rewardsControllerGetV1>>> = ({ signal }) =>
    rewardsControllerGetV1(rewardId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!rewardId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardsControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RewardsControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerGetV1>>
>;
export type RewardsControllerGetV1QueryError = ProblemDetailsResponse;

export function useRewardsControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  params: undefined | RewardsControllerGetV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardsControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof rewardsControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardsControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  params?: RewardsControllerGetV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardsControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof rewardsControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardsControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  params?: RewardsControllerGetV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRewardsControllerGetV1<
  TData = Awaited<ReturnType<typeof rewardsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  rewardId: string,
  params?: RewardsControllerGetV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardsControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRewardsControllerGetV1QueryOptions(rewardId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const rewardsControllerUpdateV1 = (
  rewardId: string,
  updateRewardDto: UpdateRewardDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/rewards/${rewardId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateRewardDto,
    },
    options,
  );
};

export const getRewardsControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerUpdateV1>>,
    TError,
    { rewardId: string; data: UpdateRewardDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerUpdateV1>>,
  TError,
  { rewardId: string; data: UpdateRewardDto },
  TContext
> => {
  const mutationKey = ['rewardsControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerUpdateV1>>,
    { rewardId: string; data: UpdateRewardDto }
  > = (props) => {
    const { rewardId, data } = props ?? {};

    return rewardsControllerUpdateV1(rewardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerUpdateV1>>
>;
export type RewardsControllerUpdateV1MutationBody = UpdateRewardDto;
export type RewardsControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerUpdateV1>>,
      TError,
      { rewardId: string; data: UpdateRewardDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerUpdateV1>>,
  TError,
  { rewardId: string; data: UpdateRewardDto },
  TContext
> => {
  const mutationOptions = getRewardsControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerRemoveV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>({ url: `/v1/economy/rewards/${rewardId}`, method: 'DELETE' }, options);
};

export const getRewardsControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerRemoveV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerRemoveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardsControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerRemoveV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardsControllerRemoveV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerRemoveV1>>
>;

export type RewardsControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerRemoveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerRemoveV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerRemoveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardsControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerArchiveV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/archive`, method: 'POST', signal },
    options,
  );
};

export const getRewardsControllerArchiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerArchiveV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerArchiveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardsControllerArchiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerArchiveV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardsControllerArchiveV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerArchiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerArchiveV1>>
>;

export type RewardsControllerArchiveV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerArchiveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerArchiveV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerArchiveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardsControllerArchiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerRestoreV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/restore`, method: 'POST', signal },
    options,
  );
};

export const getRewardsControllerRestoreV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerRestoreV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerRestoreV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardsControllerRestoreV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerRestoreV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardsControllerRestoreV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerRestoreV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerRestoreV1>>
>;

export type RewardsControllerRestoreV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerRestoreV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerRestoreV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerRestoreV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardsControllerRestoreV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerApproveV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/approve`, method: 'POST', signal },
    options,
  );
};

export const getRewardsControllerApproveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerApproveV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerApproveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardsControllerApproveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerApproveV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardsControllerApproveV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerApproveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerApproveV1>>
>;

export type RewardsControllerApproveV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerApproveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerApproveV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerApproveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardsControllerApproveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerFavoriteV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/favorite`, method: 'POST', signal },
    options,
  );
};

export const getRewardsControllerFavoriteV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerFavoriteV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerFavoriteV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardsControllerFavoriteV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerFavoriteV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardsControllerFavoriteV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerFavoriteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerFavoriteV1>>
>;

export type RewardsControllerFavoriteV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerFavoriteV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerFavoriteV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerFavoriteV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardsControllerFavoriteV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardsControllerUnfavoriteV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/favorite`, method: 'DELETE' },
    options,
  );
};

export const getRewardsControllerUnfavoriteV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardsControllerUnfavoriteV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardsControllerUnfavoriteV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardsControllerUnfavoriteV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardsControllerUnfavoriteV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardsControllerUnfavoriteV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardsControllerUnfavoriteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardsControllerUnfavoriteV1>>
>;

export type RewardsControllerUnfavoriteV1MutationError = ProblemDetailsResponse;

export const useRewardsControllerUnfavoriteV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardsControllerUnfavoriteV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardsControllerUnfavoriteV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardsControllerUnfavoriteV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const bonusesControllerListV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<AchievementBonusResponse[]>(
    { url: `/v1/economy/bonuses`, method: 'GET', signal },
    options,
  );
};

export const getBonusesControllerListV1QueryKey = () => {
  return [`/v1/economy/bonuses`] as const;
};

export const getBonusesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof bonusesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof bonusesControllerListV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBonusesControllerListV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bonusesControllerListV1>>> = ({
    signal,
  }) => bonusesControllerListV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bonusesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BonusesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof bonusesControllerListV1>>
>;
export type BonusesControllerListV1QueryError = ProblemDetailsResponse;

export function useBonusesControllerListV1<
  TData = Awaited<ReturnType<typeof bonusesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bonusesControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bonusesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof bonusesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBonusesControllerListV1<
  TData = Awaited<ReturnType<typeof bonusesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bonusesControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bonusesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof bonusesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBonusesControllerListV1<
  TData = Awaited<ReturnType<typeof bonusesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bonusesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBonusesControllerListV1<
  TData = Awaited<ReturnType<typeof bonusesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bonusesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBonusesControllerListV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const bonusesControllerCreateV1 = (
  createBonusDto: CreateBonusDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateBonusResponse>(
    {
      url: `/v1/economy/bonuses`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBonusDto,
      signal,
    },
    options,
  );
};

export const getBonusesControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bonusesControllerCreateV1>>,
    TError,
    { data: CreateBonusDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bonusesControllerCreateV1>>,
  TError,
  { data: CreateBonusDto },
  TContext
> => {
  const mutationKey = ['bonusesControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bonusesControllerCreateV1>>,
    { data: CreateBonusDto }
  > = (props) => {
    const { data } = props ?? {};

    return bonusesControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BonusesControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof bonusesControllerCreateV1>>
>;
export type BonusesControllerCreateV1MutationBody = CreateBonusDto;
export type BonusesControllerCreateV1MutationError = ProblemDetailsResponse;

export const useBonusesControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bonusesControllerCreateV1>>,
      TError,
      { data: CreateBonusDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bonusesControllerCreateV1>>,
  TError,
  { data: CreateBonusDto },
  TContext
> => {
  const mutationOptions = getBonusesControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const bonusesControllerUpdateV1 = (
  bonusId: string,
  updateBonusDto: UpdateBonusDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/bonuses/${bonusId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBonusDto,
    },
    options,
  );
};

export const getBonusesControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bonusesControllerUpdateV1>>,
    TError,
    { bonusId: string; data: UpdateBonusDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bonusesControllerUpdateV1>>,
  TError,
  { bonusId: string; data: UpdateBonusDto },
  TContext
> => {
  const mutationKey = ['bonusesControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bonusesControllerUpdateV1>>,
    { bonusId: string; data: UpdateBonusDto }
  > = (props) => {
    const { bonusId, data } = props ?? {};

    return bonusesControllerUpdateV1(bonusId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BonusesControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof bonusesControllerUpdateV1>>
>;
export type BonusesControllerUpdateV1MutationBody = UpdateBonusDto;
export type BonusesControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useBonusesControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bonusesControllerUpdateV1>>,
      TError,
      { bonusId: string; data: UpdateBonusDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bonusesControllerUpdateV1>>,
  TError,
  { bonusId: string; data: UpdateBonusDto },
  TContext
> => {
  const mutationOptions = getBonusesControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const bonusesControllerRemoveV1 = (
  bonusId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>({ url: `/v1/economy/bonuses/${bonusId}`, method: 'DELETE' }, options);
};

export const getBonusesControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bonusesControllerRemoveV1>>,
    TError,
    { bonusId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bonusesControllerRemoveV1>>,
  TError,
  { bonusId: string },
  TContext
> => {
  const mutationKey = ['bonusesControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bonusesControllerRemoveV1>>,
    { bonusId: string }
  > = (props) => {
    const { bonusId } = props ?? {};

    return bonusesControllerRemoveV1(bonusId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BonusesControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof bonusesControllerRemoveV1>>
>;

export type BonusesControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useBonusesControllerRemoveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bonusesControllerRemoveV1>>,
      TError,
      { bonusId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bonusesControllerRemoveV1>>,
  TError,
  { bonusId: string },
  TContext
> => {
  const mutationOptions = getBonusesControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardPhotosControllerUploadV1 = (
  rewardId: string,
  rewardPhotosControllerUploadV1Body: RewardPhotosControllerUploadV1Body,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, rewardPhotosControllerUploadV1Body.file);

  return apiFetch<RewardResponse>(
    {
      url: `/v1/economy/rewards/${rewardId}/photo`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getRewardPhotosControllerUploadV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardPhotosControllerUploadV1>>,
    TError,
    { rewardId: string; data: RewardPhotosControllerUploadV1Body },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardPhotosControllerUploadV1>>,
  TError,
  { rewardId: string; data: RewardPhotosControllerUploadV1Body },
  TContext
> => {
  const mutationKey = ['rewardPhotosControllerUploadV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardPhotosControllerUploadV1>>,
    { rewardId: string; data: RewardPhotosControllerUploadV1Body }
  > = (props) => {
    const { rewardId, data } = props ?? {};

    return rewardPhotosControllerUploadV1(rewardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardPhotosControllerUploadV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardPhotosControllerUploadV1>>
>;
export type RewardPhotosControllerUploadV1MutationBody = RewardPhotosControllerUploadV1Body;
export type RewardPhotosControllerUploadV1MutationError = ProblemDetailsResponse;

export const useRewardPhotosControllerUploadV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardPhotosControllerUploadV1>>,
      TError,
      { rewardId: string; data: RewardPhotosControllerUploadV1Body },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardPhotosControllerUploadV1>>,
  TError,
  { rewardId: string; data: RewardPhotosControllerUploadV1Body },
  TContext
> => {
  const mutationOptions = getRewardPhotosControllerUploadV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardPhotosControllerRemoveV1 = (
  rewardId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/rewards/${rewardId}/photo`, method: 'DELETE' },
    options,
  );
};

export const getRewardPhotosControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardPhotosControllerRemoveV1>>,
    TError,
    { rewardId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardPhotosControllerRemoveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationKey = ['rewardPhotosControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardPhotosControllerRemoveV1>>,
    { rewardId: string }
  > = (props) => {
    const { rewardId } = props ?? {};

    return rewardPhotosControllerRemoveV1(rewardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardPhotosControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardPhotosControllerRemoveV1>>
>;

export type RewardPhotosControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useRewardPhotosControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewardPhotosControllerRemoveV1>>,
      TError,
      { rewardId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewardPhotosControllerRemoveV1>>,
  TError,
  { rewardId: string },
  TContext
> => {
  const mutationOptions = getRewardPhotosControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const rewardPhotosControllerServeV1 = (
  key: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<Blob>(
    { url: `/v1/economy/rewards/photo/${key}`, method: 'GET', responseType: 'blob', signal },
    options,
  );
};

export const getRewardPhotosControllerServeV1QueryKey = (key?: string) => {
  return [`/v1/economy/rewards/photo/${key}`] as const;
};

export const getRewardPhotosControllerServeV1QueryOptions = <
  TData = Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRewardPhotosControllerServeV1QueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>> = ({
    signal,
  }) => rewardPhotosControllerServeV1(key, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RewardPhotosControllerServeV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>
>;
export type RewardPhotosControllerServeV1QueryError = ProblemDetailsResponse;

export function useRewardPhotosControllerServeV1<
  TData = Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardPhotosControllerServeV1<
  TData = Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
          TError,
          Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRewardPhotosControllerServeV1<
  TData = Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRewardPhotosControllerServeV1<
  TData = Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>,
  TError = ProblemDetailsResponse,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof rewardPhotosControllerServeV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRewardPhotosControllerServeV1QueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const categoriesControllerListV1 = (
  params?: CategoriesControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CategoryResponse[]>(
    { url: `/v1/economy/categories`, method: 'GET', params, signal },
    options,
  );
};

export const getCategoriesControllerListV1QueryKey = (
  params?: CategoriesControllerListV1Params,
) => {
  return [`/v1/economy/categories`, ...(params ? [params] : [])] as const;
};

export const getCategoriesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof categoriesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CategoriesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoriesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCategoriesControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof categoriesControllerListV1>>> = ({
    signal,
  }) => categoriesControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof categoriesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CategoriesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof categoriesControllerListV1>>
>;
export type CategoriesControllerListV1QueryError = ProblemDetailsResponse;

export function useCategoriesControllerListV1<
  TData = Awaited<ReturnType<typeof categoriesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | CategoriesControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoriesControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoriesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof categoriesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategoriesControllerListV1<
  TData = Awaited<ReturnType<typeof categoriesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CategoriesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoriesControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoriesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof categoriesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCategoriesControllerListV1<
  TData = Awaited<ReturnType<typeof categoriesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CategoriesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoriesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCategoriesControllerListV1<
  TData = Awaited<ReturnType<typeof categoriesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CategoriesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof categoriesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCategoriesControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const categoriesControllerCreateV1 = (
  createCategoryDto: CreateCategoryDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateCategoryResponse>(
    {
      url: `/v1/economy/categories`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCategoryDto,
      signal,
    },
    options,
  );
};

export const getCategoriesControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof categoriesControllerCreateV1>>,
    TError,
    { data: CreateCategoryDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof categoriesControllerCreateV1>>,
  TError,
  { data: CreateCategoryDto },
  TContext
> => {
  const mutationKey = ['categoriesControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof categoriesControllerCreateV1>>,
    { data: CreateCategoryDto }
  > = (props) => {
    const { data } = props ?? {};

    return categoriesControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CategoriesControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof categoriesControllerCreateV1>>
>;
export type CategoriesControllerCreateV1MutationBody = CreateCategoryDto;
export type CategoriesControllerCreateV1MutationError = ProblemDetailsResponse;

export const useCategoriesControllerCreateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof categoriesControllerCreateV1>>,
      TError,
      { data: CreateCategoryDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof categoriesControllerCreateV1>>,
  TError,
  { data: CreateCategoryDto },
  TContext
> => {
  const mutationOptions = getCategoriesControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const categoriesControllerUpdateV1 = (
  categoryId: string,
  updateCategoryDto: UpdateCategoryDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/categories/${categoryId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCategoryDto,
    },
    options,
  );
};

export const getCategoriesControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof categoriesControllerUpdateV1>>,
    TError,
    { categoryId: string; data: UpdateCategoryDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof categoriesControllerUpdateV1>>,
  TError,
  { categoryId: string; data: UpdateCategoryDto },
  TContext
> => {
  const mutationKey = ['categoriesControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof categoriesControllerUpdateV1>>,
    { categoryId: string; data: UpdateCategoryDto }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return categoriesControllerUpdateV1(categoryId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CategoriesControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof categoriesControllerUpdateV1>>
>;
export type CategoriesControllerUpdateV1MutationBody = UpdateCategoryDto;
export type CategoriesControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useCategoriesControllerUpdateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof categoriesControllerUpdateV1>>,
      TError,
      { categoryId: string; data: UpdateCategoryDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof categoriesControllerUpdateV1>>,
  TError,
  { categoryId: string; data: UpdateCategoryDto },
  TContext
> => {
  const mutationOptions = getCategoriesControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const categoriesControllerArchiveV1 = (
  categoryId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/categories/${categoryId}/archive`, method: 'POST', signal },
    options,
  );
};

export const getCategoriesControllerArchiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof categoriesControllerArchiveV1>>,
    TError,
    { categoryId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof categoriesControllerArchiveV1>>,
  TError,
  { categoryId: string },
  TContext
> => {
  const mutationKey = ['categoriesControllerArchiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof categoriesControllerArchiveV1>>,
    { categoryId: string }
  > = (props) => {
    const { categoryId } = props ?? {};

    return categoriesControllerArchiveV1(categoryId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CategoriesControllerArchiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof categoriesControllerArchiveV1>>
>;

export type CategoriesControllerArchiveV1MutationError = ProblemDetailsResponse;

export const useCategoriesControllerArchiveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof categoriesControllerArchiveV1>>,
      TError,
      { categoryId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof categoriesControllerArchiveV1>>,
  TError,
  { categoryId: string },
  TContext
> => {
  const mutationOptions = getCategoriesControllerArchiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const categoriesControllerRestoreV1 = (
  categoryId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/categories/${categoryId}/restore`, method: 'POST', signal },
    options,
  );
};

export const getCategoriesControllerRestoreV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof categoriesControllerRestoreV1>>,
    TError,
    { categoryId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof categoriesControllerRestoreV1>>,
  TError,
  { categoryId: string },
  TContext
> => {
  const mutationKey = ['categoriesControllerRestoreV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof categoriesControllerRestoreV1>>,
    { categoryId: string }
  > = (props) => {
    const { categoryId } = props ?? {};

    return categoriesControllerRestoreV1(categoryId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CategoriesControllerRestoreV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof categoriesControllerRestoreV1>>
>;

export type CategoriesControllerRestoreV1MutationError = ProblemDetailsResponse;

export const useCategoriesControllerRestoreV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof categoriesControllerRestoreV1>>,
      TError,
      { categoryId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof categoriesControllerRestoreV1>>,
  TError,
  { categoryId: string },
  TContext
> => {
  const mutationOptions = getCategoriesControllerRestoreV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const redemptionsControllerRequestV1 = (
  createRedemptionDto: CreateRedemptionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RequestRedemptionResponse>(
    {
      url: `/v1/economy/redemptions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRedemptionDto,
      signal,
    },
    options,
  );
};

export const getRedemptionsControllerRequestV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsControllerRequestV1>>,
    TError,
    { data: CreateRedemptionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsControllerRequestV1>>,
  TError,
  { data: CreateRedemptionDto },
  TContext
> => {
  const mutationKey = ['redemptionsControllerRequestV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsControllerRequestV1>>,
    { data: CreateRedemptionDto }
  > = (props) => {
    const { data } = props ?? {};

    return redemptionsControllerRequestV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedemptionsControllerRequestV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsControllerRequestV1>>
>;
export type RedemptionsControllerRequestV1MutationBody = CreateRedemptionDto;
export type RedemptionsControllerRequestV1MutationError = ProblemDetailsResponse;

export const useRedemptionsControllerRequestV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redemptionsControllerRequestV1>>,
      TError,
      { data: CreateRedemptionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsControllerRequestV1>>,
  TError,
  { data: CreateRedemptionDto },
  TContext
> => {
  const mutationOptions = getRedemptionsControllerRequestV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const redemptionsControllerListV1 = (
  params?: RedemptionsControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RedemptionsControllerListV1200>(
    { url: `/v1/economy/redemptions`, method: 'GET', params, signal },
    options,
  );
};

export const getRedemptionsControllerListV1QueryKey = (
  params?: RedemptionsControllerListV1Params,
) => {
  return [`/v1/economy/redemptions`, ...(params ? [params] : [])] as const;
};

export const getRedemptionsControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof redemptionsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RedemptionsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof redemptionsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRedemptionsControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof redemptionsControllerListV1>>> = ({
    signal,
  }) => redemptionsControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof redemptionsControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RedemptionsControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsControllerListV1>>
>;
export type RedemptionsControllerListV1QueryError = ProblemDetailsResponse;

export function useRedemptionsControllerListV1<
  TData = Awaited<ReturnType<typeof redemptionsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | RedemptionsControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof redemptionsControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof redemptionsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof redemptionsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRedemptionsControllerListV1<
  TData = Awaited<ReturnType<typeof redemptionsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RedemptionsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof redemptionsControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof redemptionsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof redemptionsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRedemptionsControllerListV1<
  TData = Awaited<ReturnType<typeof redemptionsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RedemptionsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof redemptionsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRedemptionsControllerListV1<
  TData = Awaited<ReturnType<typeof redemptionsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: RedemptionsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof redemptionsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRedemptionsControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const redemptionsControllerGrantV1 = (
  redemptionId: string,
  decideRedemptionDto: DecideRedemptionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/redemptions/${redemptionId}/grant`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: decideRedemptionDto,
      signal,
    },
    options,
  );
};

export const getRedemptionsControllerGrantV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsControllerGrantV1>>,
    TError,
    { redemptionId: string; data: DecideRedemptionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsControllerGrantV1>>,
  TError,
  { redemptionId: string; data: DecideRedemptionDto },
  TContext
> => {
  const mutationKey = ['redemptionsControllerGrantV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsControllerGrantV1>>,
    { redemptionId: string; data: DecideRedemptionDto }
  > = (props) => {
    const { redemptionId, data } = props ?? {};

    return redemptionsControllerGrantV1(redemptionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedemptionsControllerGrantV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsControllerGrantV1>>
>;
export type RedemptionsControllerGrantV1MutationBody = DecideRedemptionDto;
export type RedemptionsControllerGrantV1MutationError = ProblemDetailsResponse;

export const useRedemptionsControllerGrantV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redemptionsControllerGrantV1>>,
      TError,
      { redemptionId: string; data: DecideRedemptionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsControllerGrantV1>>,
  TError,
  { redemptionId: string; data: DecideRedemptionDto },
  TContext
> => {
  const mutationOptions = getRedemptionsControllerGrantV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const redemptionsControllerDenyV1 = (
  redemptionId: string,
  decideRedemptionDto: DecideRedemptionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/redemptions/${redemptionId}/deny`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: decideRedemptionDto,
      signal,
    },
    options,
  );
};

export const getRedemptionsControllerDenyV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsControllerDenyV1>>,
    TError,
    { redemptionId: string; data: DecideRedemptionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsControllerDenyV1>>,
  TError,
  { redemptionId: string; data: DecideRedemptionDto },
  TContext
> => {
  const mutationKey = ['redemptionsControllerDenyV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsControllerDenyV1>>,
    { redemptionId: string; data: DecideRedemptionDto }
  > = (props) => {
    const { redemptionId, data } = props ?? {};

    return redemptionsControllerDenyV1(redemptionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedemptionsControllerDenyV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsControllerDenyV1>>
>;
export type RedemptionsControllerDenyV1MutationBody = DecideRedemptionDto;
export type RedemptionsControllerDenyV1MutationError = ProblemDetailsResponse;

export const useRedemptionsControllerDenyV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redemptionsControllerDenyV1>>,
      TError,
      { redemptionId: string; data: DecideRedemptionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsControllerDenyV1>>,
  TError,
  { redemptionId: string; data: DecideRedemptionDto },
  TContext
> => {
  const mutationOptions = getRedemptionsControllerDenyV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const redemptionsControllerCancelV1 = (
  redemptionId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/redemptions/${redemptionId}/cancel`, method: 'POST', signal },
    options,
  );
};

export const getRedemptionsControllerCancelV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsControllerCancelV1>>,
    TError,
    { redemptionId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsControllerCancelV1>>,
  TError,
  { redemptionId: string },
  TContext
> => {
  const mutationKey = ['redemptionsControllerCancelV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsControllerCancelV1>>,
    { redemptionId: string }
  > = (props) => {
    const { redemptionId } = props ?? {};

    return redemptionsControllerCancelV1(redemptionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedemptionsControllerCancelV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsControllerCancelV1>>
>;

export type RedemptionsControllerCancelV1MutationError = ProblemDetailsResponse;

export const useRedemptionsControllerCancelV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redemptionsControllerCancelV1>>,
      TError,
      { redemptionId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsControllerCancelV1>>,
  TError,
  { redemptionId: string },
  TContext
> => {
  const mutationOptions = getRedemptionsControllerCancelV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const redemptionsControllerCollectV1 = (
  redemptionId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/redemptions/${redemptionId}/collect`, method: 'POST', signal },
    options,
  );
};

export const getRedemptionsControllerCollectV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redemptionsControllerCollectV1>>,
    TError,
    { redemptionId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redemptionsControllerCollectV1>>,
  TError,
  { redemptionId: string },
  TContext
> => {
  const mutationKey = ['redemptionsControllerCollectV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redemptionsControllerCollectV1>>,
    { redemptionId: string }
  > = (props) => {
    const { redemptionId } = props ?? {};

    return redemptionsControllerCollectV1(redemptionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedemptionsControllerCollectV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof redemptionsControllerCollectV1>>
>;

export type RedemptionsControllerCollectV1MutationError = ProblemDetailsResponse;

export const useRedemptionsControllerCollectV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redemptionsControllerCollectV1>>,
      TError,
      { redemptionId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof redemptionsControllerCollectV1>>,
  TError,
  { redemptionId: string },
  TContext
> => {
  const mutationOptions = getRedemptionsControllerCollectV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const holdsControllerPlaceV1 = (
  placeHoldDto: PlaceHoldDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlaceHoldResponse>(
    {
      url: `/v1/economy/holds`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: placeHoldDto,
      signal,
    },
    options,
  );
};

export const getHoldsControllerPlaceV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof holdsControllerPlaceV1>>,
    TError,
    { data: PlaceHoldDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof holdsControllerPlaceV1>>,
  TError,
  { data: PlaceHoldDto },
  TContext
> => {
  const mutationKey = ['holdsControllerPlaceV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof holdsControllerPlaceV1>>,
    { data: PlaceHoldDto }
  > = (props) => {
    const { data } = props ?? {};

    return holdsControllerPlaceV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldsControllerPlaceV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof holdsControllerPlaceV1>>
>;
export type HoldsControllerPlaceV1MutationBody = PlaceHoldDto;
export type HoldsControllerPlaceV1MutationError = ProblemDetailsResponse;

export const useHoldsControllerPlaceV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof holdsControllerPlaceV1>>,
      TError,
      { data: PlaceHoldDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof holdsControllerPlaceV1>>,
  TError,
  { data: PlaceHoldDto },
  TContext
> => {
  const mutationOptions = getHoldsControllerPlaceV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const holdsControllerListActiveV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdHoldResponse[]>(
    { url: `/v1/economy/holds/active`, method: 'GET', signal },
    options,
  );
};

export const getHoldsControllerListActiveV1QueryKey = () => {
  return [`/v1/economy/holds/active`] as const;
};

export const getHoldsControllerListActiveV1QueryOptions = <
  TData = Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListActiveV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHoldsControllerListActiveV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof holdsControllerListActiveV1>>> = ({
    signal,
  }) => holdsControllerListActiveV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HoldsControllerListActiveV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof holdsControllerListActiveV1>>
>;
export type HoldsControllerListActiveV1QueryError = ProblemDetailsResponse;

export function useHoldsControllerListActiveV1<
  TData = Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListActiveV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
          TError,
          Awaited<ReturnType<typeof holdsControllerListActiveV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHoldsControllerListActiveV1<
  TData = Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListActiveV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
          TError,
          Awaited<ReturnType<typeof holdsControllerListActiveV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHoldsControllerListActiveV1<
  TData = Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListActiveV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHoldsControllerListActiveV1<
  TData = Awaited<ReturnType<typeof holdsControllerListActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListActiveV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHoldsControllerListActiveV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const holdsControllerListForChildV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HoldResponse[]>(
    { url: `/v1/economy/holds/children/${childId}`, method: 'GET', signal },
    options,
  );
};

export const getHoldsControllerListForChildV1QueryKey = (childId?: string) => {
  return [`/v1/economy/holds/children/${childId}`] as const;
};

export const getHoldsControllerListForChildV1QueryOptions = <
  TData = Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListForChildV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHoldsControllerListForChildV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof holdsControllerListForChildV1>>> = ({
    signal,
  }) => holdsControllerListForChildV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HoldsControllerListForChildV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof holdsControllerListForChildV1>>
>;
export type HoldsControllerListForChildV1QueryError = ProblemDetailsResponse;

export function useHoldsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListForChildV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
          TError,
          Awaited<ReturnType<typeof holdsControllerListForChildV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHoldsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListForChildV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
          TError,
          Awaited<ReturnType<typeof holdsControllerListForChildV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHoldsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListForChildV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHoldsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof holdsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof holdsControllerListForChildV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHoldsControllerListForChildV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const holdsControllerLiftV1 = (
  holdId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/holds/${holdId}/lift`, method: 'POST', signal },
    options,
  );
};

export const getHoldsControllerLiftV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof holdsControllerLiftV1>>,
    TError,
    { holdId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof holdsControllerLiftV1>>,
  TError,
  { holdId: string },
  TContext
> => {
  const mutationKey = ['holdsControllerLiftV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof holdsControllerLiftV1>>,
    { holdId: string }
  > = (props) => {
    const { holdId } = props ?? {};

    return holdsControllerLiftV1(holdId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HoldsControllerLiftV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof holdsControllerLiftV1>>
>;

export type HoldsControllerLiftV1MutationError = ProblemDetailsResponse;

export const useHoldsControllerLiftV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof holdsControllerLiftV1>>,
      TError,
      { holdId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof holdsControllerLiftV1>>,
  TError,
  { holdId: string },
  TContext
> => {
  const mutationOptions = getHoldsControllerLiftV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const savingsControllerCreateV1 = (
  createSavingsGoalDto: CreateSavingsGoalDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateSavingsGoalResponse>(
    {
      url: `/v1/economy/savings`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSavingsGoalDto,
      signal,
    },
    options,
  );
};

export const getSavingsControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savingsControllerCreateV1>>,
    TError,
    { data: CreateSavingsGoalDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savingsControllerCreateV1>>,
  TError,
  { data: CreateSavingsGoalDto },
  TContext
> => {
  const mutationKey = ['savingsControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savingsControllerCreateV1>>,
    { data: CreateSavingsGoalDto }
  > = (props) => {
    const { data } = props ?? {};

    return savingsControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavingsControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerCreateV1>>
>;
export type SavingsControllerCreateV1MutationBody = CreateSavingsGoalDto;
export type SavingsControllerCreateV1MutationError = ProblemDetailsResponse;

export const useSavingsControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savingsControllerCreateV1>>,
      TError,
      { data: CreateSavingsGoalDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savingsControllerCreateV1>>,
  TError,
  { data: CreateSavingsGoalDto },
  TContext
> => {
  const mutationOptions = getSavingsControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const savingsControllerListForChildV1 = (
  childId: string,
  params?: SavingsControllerListForChildV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SavingsGoalResponse[]>(
    { url: `/v1/economy/savings/children/${childId}`, method: 'GET', params, signal },
    options,
  );
};

export const getSavingsControllerListForChildV1QueryKey = (
  childId?: string,
  params?: SavingsControllerListForChildV1Params,
) => {
  return [`/v1/economy/savings/children/${childId}`, ...(params ? [params] : [])] as const;
};

export const getSavingsControllerListForChildV1QueryOptions = <
  TData = Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: SavingsControllerListForChildV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof savingsControllerListForChildV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSavingsControllerListForChildV1QueryKey(childId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof savingsControllerListForChildV1>>> = ({
    signal,
  }) => savingsControllerListForChildV1(childId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SavingsControllerListForChildV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerListForChildV1>>
>;
export type SavingsControllerListForChildV1QueryError = ProblemDetailsResponse;

export function useSavingsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: undefined | SavingsControllerListForChildV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof savingsControllerListForChildV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
          TError,
          Awaited<ReturnType<typeof savingsControllerListForChildV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSavingsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: SavingsControllerListForChildV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof savingsControllerListForChildV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
          TError,
          Awaited<ReturnType<typeof savingsControllerListForChildV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSavingsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: SavingsControllerListForChildV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof savingsControllerListForChildV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useSavingsControllerListForChildV1<
  TData = Awaited<ReturnType<typeof savingsControllerListForChildV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: SavingsControllerListForChildV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof savingsControllerListForChildV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSavingsControllerListForChildV1QueryOptions(childId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const savingsControllerUpdateV1 = (
  savingsGoalId: string,
  updateSavingsGoalDto: UpdateSavingsGoalDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/savings/${savingsGoalId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateSavingsGoalDto,
    },
    options,
  );
};

export const getSavingsControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savingsControllerUpdateV1>>,
    TError,
    { savingsGoalId: string; data: UpdateSavingsGoalDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savingsControllerUpdateV1>>,
  TError,
  { savingsGoalId: string; data: UpdateSavingsGoalDto },
  TContext
> => {
  const mutationKey = ['savingsControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savingsControllerUpdateV1>>,
    { savingsGoalId: string; data: UpdateSavingsGoalDto }
  > = (props) => {
    const { savingsGoalId, data } = props ?? {};

    return savingsControllerUpdateV1(savingsGoalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavingsControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerUpdateV1>>
>;
export type SavingsControllerUpdateV1MutationBody = UpdateSavingsGoalDto;
export type SavingsControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useSavingsControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savingsControllerUpdateV1>>,
      TError,
      { savingsGoalId: string; data: UpdateSavingsGoalDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savingsControllerUpdateV1>>,
  TError,
  { savingsGoalId: string; data: UpdateSavingsGoalDto },
  TContext
> => {
  const mutationOptions = getSavingsControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const savingsControllerArchiveV1 = (
  savingsGoalId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/savings/${savingsGoalId}/archive`, method: 'POST', signal },
    options,
  );
};

export const getSavingsControllerArchiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savingsControllerArchiveV1>>,
    TError,
    { savingsGoalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savingsControllerArchiveV1>>,
  TError,
  { savingsGoalId: string },
  TContext
> => {
  const mutationKey = ['savingsControllerArchiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savingsControllerArchiveV1>>,
    { savingsGoalId: string }
  > = (props) => {
    const { savingsGoalId } = props ?? {};

    return savingsControllerArchiveV1(savingsGoalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavingsControllerArchiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerArchiveV1>>
>;

export type SavingsControllerArchiveV1MutationError = ProblemDetailsResponse;

export const useSavingsControllerArchiveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savingsControllerArchiveV1>>,
      TError,
      { savingsGoalId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savingsControllerArchiveV1>>,
  TError,
  { savingsGoalId: string },
  TContext
> => {
  const mutationOptions = getSavingsControllerArchiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const savingsControllerCompleteV1 = (
  savingsGoalId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/economy/savings/${savingsGoalId}/complete`, method: 'POST', signal },
    options,
  );
};

export const getSavingsControllerCompleteV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savingsControllerCompleteV1>>,
    TError,
    { savingsGoalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savingsControllerCompleteV1>>,
  TError,
  { savingsGoalId: string },
  TContext
> => {
  const mutationKey = ['savingsControllerCompleteV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savingsControllerCompleteV1>>,
    { savingsGoalId: string }
  > = (props) => {
    const { savingsGoalId } = props ?? {};

    return savingsControllerCompleteV1(savingsGoalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavingsControllerCompleteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerCompleteV1>>
>;

export type SavingsControllerCompleteV1MutationError = ProblemDetailsResponse;

export const useSavingsControllerCompleteV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savingsControllerCompleteV1>>,
      TError,
      { savingsGoalId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savingsControllerCompleteV1>>,
  TError,
  { savingsGoalId: string },
  TContext
> => {
  const mutationOptions = getSavingsControllerCompleteV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const savingsControllerDepositV1 = (
  savingsGoalId: string,
  savingsMovementDto: SavingsMovementDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/savings/${savingsGoalId}/deposit`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: savingsMovementDto,
      signal,
    },
    options,
  );
};

export const getSavingsControllerDepositV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savingsControllerDepositV1>>,
    TError,
    { savingsGoalId: string; data: SavingsMovementDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savingsControllerDepositV1>>,
  TError,
  { savingsGoalId: string; data: SavingsMovementDto },
  TContext
> => {
  const mutationKey = ['savingsControllerDepositV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savingsControllerDepositV1>>,
    { savingsGoalId: string; data: SavingsMovementDto }
  > = (props) => {
    const { savingsGoalId, data } = props ?? {};

    return savingsControllerDepositV1(savingsGoalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavingsControllerDepositV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerDepositV1>>
>;
export type SavingsControllerDepositV1MutationBody = SavingsMovementDto;
export type SavingsControllerDepositV1MutationError = ProblemDetailsResponse;

export const useSavingsControllerDepositV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savingsControllerDepositV1>>,
      TError,
      { savingsGoalId: string; data: SavingsMovementDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savingsControllerDepositV1>>,
  TError,
  { savingsGoalId: string; data: SavingsMovementDto },
  TContext
> => {
  const mutationOptions = getSavingsControllerDepositV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const savingsControllerWithdrawV1 = (
  savingsGoalId: string,
  savingsMovementDto: SavingsMovementDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/savings/${savingsGoalId}/withdraw`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: savingsMovementDto,
      signal,
    },
    options,
  );
};

export const getSavingsControllerWithdrawV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savingsControllerWithdrawV1>>,
    TError,
    { savingsGoalId: string; data: SavingsMovementDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savingsControllerWithdrawV1>>,
  TError,
  { savingsGoalId: string; data: SavingsMovementDto },
  TContext
> => {
  const mutationKey = ['savingsControllerWithdrawV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savingsControllerWithdrawV1>>,
    { savingsGoalId: string; data: SavingsMovementDto }
  > = (props) => {
    const { savingsGoalId, data } = props ?? {};

    return savingsControllerWithdrawV1(savingsGoalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavingsControllerWithdrawV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof savingsControllerWithdrawV1>>
>;
export type SavingsControllerWithdrawV1MutationBody = SavingsMovementDto;
export type SavingsControllerWithdrawV1MutationError = ProblemDetailsResponse;

export const useSavingsControllerWithdrawV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof savingsControllerWithdrawV1>>,
      TError,
      { savingsGoalId: string; data: SavingsMovementDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof savingsControllerWithdrawV1>>,
  TError,
  { savingsGoalId: string; data: SavingsMovementDto },
  TContext
> => {
  const mutationOptions = getSavingsControllerWithdrawV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const balancesControllerBalanceV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ChildBalanceResponse>(
    { url: `/v1/economy/children/${childId}/balance`, method: 'GET', signal },
    options,
  );
};

export const getBalancesControllerBalanceV1QueryKey = (childId?: string) => {
  return [`/v1/economy/children/${childId}/balance`] as const;
};

export const getBalancesControllerBalanceV1QueryOptions = <
  TData = Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesControllerBalanceV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesControllerBalanceV1>>> = ({
    signal,
  }) => balancesControllerBalanceV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BalancesControllerBalanceV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesControllerBalanceV1>>
>;
export type BalancesControllerBalanceV1QueryError = ProblemDetailsResponse;

export function useBalancesControllerBalanceV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerBalanceV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerBalanceV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerBalanceV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerBalanceV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBalancesControllerBalanceV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBalancesControllerBalanceV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const balancesControllerWaysToEarnV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<WaysToEarnResponse>(
    { url: `/v1/economy/children/${childId}/ways-to-earn`, method: 'GET', signal },
    options,
  );
};

export const getBalancesControllerWaysToEarnV1QueryKey = (childId?: string) => {
  return [`/v1/economy/children/${childId}/ways-to-earn`] as const;
};

export const getBalancesControllerWaysToEarnV1QueryOptions = <
  TData = Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesControllerWaysToEarnV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>> = ({
    signal,
  }) => balancesControllerWaysToEarnV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BalancesControllerWaysToEarnV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>
>;
export type BalancesControllerWaysToEarnV1QueryError = ProblemDetailsResponse;

export function useBalancesControllerWaysToEarnV1<
  TData = Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerWaysToEarnV1<
  TData = Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerWaysToEarnV1<
  TData = Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBalancesControllerWaysToEarnV1<
  TData = Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerWaysToEarnV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBalancesControllerWaysToEarnV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const balancesControllerStreaksV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ChildStreaksResponse>(
    { url: `/v1/economy/children/${childId}/streaks`, method: 'GET', signal },
    options,
  );
};

export const getBalancesControllerStreaksV1QueryKey = (childId?: string) => {
  return [`/v1/economy/children/${childId}/streaks`] as const;
};

export const getBalancesControllerStreaksV1QueryOptions = <
  TData = Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerStreaksV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesControllerStreaksV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesControllerStreaksV1>>> = ({
    signal,
  }) => balancesControllerStreaksV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BalancesControllerStreaksV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesControllerStreaksV1>>
>;
export type BalancesControllerStreaksV1QueryError = ProblemDetailsResponse;

export function useBalancesControllerStreaksV1<
  TData = Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerStreaksV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerStreaksV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerStreaksV1<
  TData = Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerStreaksV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerStreaksV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerStreaksV1<
  TData = Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerStreaksV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBalancesControllerStreaksV1<
  TData = Awaited<ReturnType<typeof balancesControllerStreaksV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerStreaksV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBalancesControllerStreaksV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const balancesControllerIncomeForecastV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<IncomeForecastResponse>(
    { url: `/v1/economy/children/${childId}/income-forecast`, method: 'GET', signal },
    options,
  );
};

export const getBalancesControllerIncomeForecastV1QueryKey = (childId?: string) => {
  return [`/v1/economy/children/${childId}/income-forecast`] as const;
};

export const getBalancesControllerIncomeForecastV1QueryOptions = <
  TData = Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesControllerIncomeForecastV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>> = ({
    signal,
  }) => balancesControllerIncomeForecastV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BalancesControllerIncomeForecastV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>
>;
export type BalancesControllerIncomeForecastV1QueryError = ProblemDetailsResponse;

export function useBalancesControllerIncomeForecastV1<
  TData = Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerIncomeForecastV1<
  TData = Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerIncomeForecastV1<
  TData = Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBalancesControllerIncomeForecastV1<
  TData = Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerIncomeForecastV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBalancesControllerIncomeForecastV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const balancesControllerBalanceTrendV1 = (
  childId: string,
  params: BalancesControllerBalanceTrendV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ChildBalanceTrendResponse>(
    { url: `/v1/economy/children/${childId}/balance-trend`, method: 'GET', params, signal },
    options,
  );
};

export const getBalancesControllerBalanceTrendV1QueryKey = (
  childId?: string,
  params?: BalancesControllerBalanceTrendV1Params,
) => {
  return [`/v1/economy/children/${childId}/balance-trend`, ...(params ? [params] : [])] as const;
};

export const getBalancesControllerBalanceTrendV1QueryOptions = <
  TData = Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: BalancesControllerBalanceTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBalancesControllerBalanceTrendV1QueryKey(childId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>> = ({
    signal,
  }) => balancesControllerBalanceTrendV1(childId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BalancesControllerBalanceTrendV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>
>;
export type BalancesControllerBalanceTrendV1QueryError = ProblemDetailsResponse;

export function useBalancesControllerBalanceTrendV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: BalancesControllerBalanceTrendV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerBalanceTrendV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: BalancesControllerBalanceTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerBalanceTrendV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: BalancesControllerBalanceTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBalancesControllerBalanceTrendV1<
  TData = Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: BalancesControllerBalanceTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerBalanceTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBalancesControllerBalanceTrendV1QueryOptions(childId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const balancesControllerLedgerV1 = (
  childId: string,
  params?: BalancesControllerLedgerV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<BalancesControllerLedgerV1200>(
    { url: `/v1/economy/children/${childId}/ledger`, method: 'GET', params, signal },
    options,
  );
};

export const getBalancesControllerLedgerV1QueryKey = (
  childId?: string,
  params?: BalancesControllerLedgerV1Params,
) => {
  return [`/v1/economy/children/${childId}/ledger`, ...(params ? [params] : [])] as const;
};

export const getBalancesControllerLedgerV1QueryOptions = <
  TData = Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: BalancesControllerLedgerV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerLedgerV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBalancesControllerLedgerV1QueryKey(childId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof balancesControllerLedgerV1>>> = ({
    signal,
  }) => balancesControllerLedgerV1(childId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BalancesControllerLedgerV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof balancesControllerLedgerV1>>
>;
export type BalancesControllerLedgerV1QueryError = ProblemDetailsResponse;

export function useBalancesControllerLedgerV1<
  TData = Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params: undefined | BalancesControllerLedgerV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerLedgerV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerLedgerV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerLedgerV1<
  TData = Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: BalancesControllerLedgerV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerLedgerV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
          TError,
          Awaited<ReturnType<typeof balancesControllerLedgerV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBalancesControllerLedgerV1<
  TData = Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: BalancesControllerLedgerV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerLedgerV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useBalancesControllerLedgerV1<
  TData = Awaited<ReturnType<typeof balancesControllerLedgerV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  params?: BalancesControllerLedgerV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof balancesControllerLedgerV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBalancesControllerLedgerV1QueryOptions(childId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const economyAdminControllerConfigV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<EconomyConfigResponse>(
    { url: `/v1/economy/config`, method: 'GET', signal },
    options,
  );
};

export const getEconomyAdminControllerConfigV1QueryKey = () => {
  return [`/v1/economy/config`] as const;
};

export const getEconomyAdminControllerConfigV1QueryOptions = <
  TData = Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerConfigV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEconomyAdminControllerConfigV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof economyAdminControllerConfigV1>>> = ({
    signal,
  }) => economyAdminControllerConfigV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EconomyAdminControllerConfigV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof economyAdminControllerConfigV1>>
>;
export type EconomyAdminControllerConfigV1QueryError = ProblemDetailsResponse;

export function useEconomyAdminControllerConfigV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerConfigV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
          TError,
          Awaited<ReturnType<typeof economyAdminControllerConfigV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEconomyAdminControllerConfigV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerConfigV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
          TError,
          Awaited<ReturnType<typeof economyAdminControllerConfigV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEconomyAdminControllerConfigV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerConfigV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEconomyAdminControllerConfigV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerConfigV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerConfigV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEconomyAdminControllerConfigV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const economyAdminControllerConfigureV1 = (
  configureEconomyDto: ConfigureEconomyDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/config`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: configureEconomyDto,
    },
    options,
  );
};

export const getEconomyAdminControllerConfigureV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof economyAdminControllerConfigureV1>>,
    TError,
    { data: ConfigureEconomyDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof economyAdminControllerConfigureV1>>,
  TError,
  { data: ConfigureEconomyDto },
  TContext
> => {
  const mutationKey = ['economyAdminControllerConfigureV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof economyAdminControllerConfigureV1>>,
    { data: ConfigureEconomyDto }
  > = (props) => {
    const { data } = props ?? {};

    return economyAdminControllerConfigureV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EconomyAdminControllerConfigureV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof economyAdminControllerConfigureV1>>
>;
export type EconomyAdminControllerConfigureV1MutationBody = ConfigureEconomyDto;
export type EconomyAdminControllerConfigureV1MutationError = ProblemDetailsResponse;

export const useEconomyAdminControllerConfigureV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof economyAdminControllerConfigureV1>>,
      TError,
      { data: ConfigureEconomyDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof economyAdminControllerConfigureV1>>,
  TError,
  { data: ConfigureEconomyDto },
  TContext
> => {
  const mutationOptions = getEconomyAdminControllerConfigureV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const economyAdminControllerAdjustV1 = (
  adjustBalanceDto: AdjustBalanceDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/economy/adjustments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: adjustBalanceDto,
      signal,
    },
    options,
  );
};

export const getEconomyAdminControllerAdjustV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof economyAdminControllerAdjustV1>>,
    TError,
    { data: AdjustBalanceDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof economyAdminControllerAdjustV1>>,
  TError,
  { data: AdjustBalanceDto },
  TContext
> => {
  const mutationKey = ['economyAdminControllerAdjustV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof economyAdminControllerAdjustV1>>,
    { data: AdjustBalanceDto }
  > = (props) => {
    const { data } = props ?? {};

    return economyAdminControllerAdjustV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EconomyAdminControllerAdjustV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof economyAdminControllerAdjustV1>>
>;
export type EconomyAdminControllerAdjustV1MutationBody = AdjustBalanceDto;
export type EconomyAdminControllerAdjustV1MutationError = ProblemDetailsResponse;

export const useEconomyAdminControllerAdjustV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof economyAdminControllerAdjustV1>>,
      TError,
      { data: AdjustBalanceDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof economyAdminControllerAdjustV1>>,
  TError,
  { data: AdjustBalanceDto },
  TContext
> => {
  const mutationOptions = getEconomyAdminControllerAdjustV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const economyAdminControllerAnalyticsV1 = (
  params?: EconomyAdminControllerAnalyticsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<EconomyAnalyticsResponse>(
    { url: `/v1/economy/analytics`, method: 'GET', params, signal },
    options,
  );
};

export const getEconomyAdminControllerAnalyticsV1QueryKey = (
  params?: EconomyAdminControllerAnalyticsV1Params,
) => {
  return [`/v1/economy/analytics`, ...(params ? [params] : [])] as const;
};

export const getEconomyAdminControllerAnalyticsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: EconomyAdminControllerAnalyticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEconomyAdminControllerAnalyticsV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>> = ({
    signal,
  }) => economyAdminControllerAnalyticsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EconomyAdminControllerAnalyticsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>
>;
export type EconomyAdminControllerAnalyticsV1QueryError = ProblemDetailsResponse;

export function useEconomyAdminControllerAnalyticsV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | EconomyAdminControllerAnalyticsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
          TError,
          Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEconomyAdminControllerAnalyticsV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: EconomyAdminControllerAnalyticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
          TError,
          Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEconomyAdminControllerAnalyticsV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: EconomyAdminControllerAnalyticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEconomyAdminControllerAnalyticsV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: EconomyAdminControllerAnalyticsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAnalyticsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEconomyAdminControllerAnalyticsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const economyAdminControllerAutomationV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<EconomyAutomationResponse>(
    { url: `/v1/economy/automation`, method: 'GET', signal },
    options,
  );
};

export const getEconomyAdminControllerAutomationV1QueryKey = () => {
  return [`/v1/economy/automation`] as const;
};

export const getEconomyAdminControllerAutomationV1QueryOptions = <
  TData = Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEconomyAdminControllerAutomationV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>> = ({
    signal,
  }) => economyAdminControllerAutomationV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type EconomyAdminControllerAutomationV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>
>;
export type EconomyAdminControllerAutomationV1QueryError = ProblemDetailsResponse;

export function useEconomyAdminControllerAutomationV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
          TError,
          Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEconomyAdminControllerAutomationV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
          TError,
          Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useEconomyAdminControllerAutomationV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useEconomyAdminControllerAutomationV1<
  TData = Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof economyAdminControllerAutomationV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getEconomyAdminControllerAutomationV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const habitsControllerTodayV1 = (
  params?: HabitsControllerTodayV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<TodayHabitsResponse>(
    { url: `/v1/habits/today`, method: 'GET', params, signal },
    options,
  );
};

export const getHabitsControllerTodayV1QueryKey = (params?: HabitsControllerTodayV1Params) => {
  return [`/v1/habits/today`, ...(params ? [params] : [])] as const;
};

export const getHabitsControllerTodayV1QueryOptions = <
  TData = Awaited<ReturnType<typeof habitsControllerTodayV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerTodayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerTodayV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHabitsControllerTodayV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof habitsControllerTodayV1>>> = ({
    signal,
  }) => habitsControllerTodayV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof habitsControllerTodayV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HabitsControllerTodayV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerTodayV1>>
>;
export type HabitsControllerTodayV1QueryError = ProblemDetailsResponse;

export function useHabitsControllerTodayV1<
  TData = Awaited<ReturnType<typeof habitsControllerTodayV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | HabitsControllerTodayV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerTodayV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerTodayV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerTodayV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerTodayV1<
  TData = Awaited<ReturnType<typeof habitsControllerTodayV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerTodayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerTodayV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerTodayV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerTodayV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerTodayV1<
  TData = Awaited<ReturnType<typeof habitsControllerTodayV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerTodayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerTodayV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHabitsControllerTodayV1<
  TData = Awaited<ReturnType<typeof habitsControllerTodayV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerTodayV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerTodayV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHabitsControllerTodayV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const habitsControllerListV1 = (
  params?: HabitsControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HabitsControllerListV1200>(
    { url: `/v1/habits`, method: 'GET', params, signal },
    options,
  );
};

export const getHabitsControllerListV1QueryKey = (params?: HabitsControllerListV1Params) => {
  return [`/v1/habits`, ...(params ? [params] : [])] as const;
};

export const getHabitsControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof habitsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHabitsControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof habitsControllerListV1>>> = ({ signal }) =>
    habitsControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof habitsControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HabitsControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerListV1>>
>;
export type HabitsControllerListV1QueryError = ProblemDetailsResponse;

export function useHabitsControllerListV1<
  TData = Awaited<ReturnType<typeof habitsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | HabitsControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerListV1<
  TData = Awaited<ReturnType<typeof habitsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerListV1<
  TData = Awaited<ReturnType<typeof habitsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHabitsControllerListV1<
  TData = Awaited<ReturnType<typeof habitsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: HabitsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHabitsControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const habitsControllerCreateV1 = (
  createHabitDto: CreateHabitDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateHabitResponse>(
    {
      url: `/v1/habits`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createHabitDto,
      signal,
    },
    options,
  );
};

export const getHabitsControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerCreateV1>>,
    TError,
    { data: CreateHabitDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerCreateV1>>,
  TError,
  { data: CreateHabitDto },
  TContext
> => {
  const mutationKey = ['habitsControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerCreateV1>>,
    { data: CreateHabitDto }
  > = (props) => {
    const { data } = props ?? {};

    return habitsControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerCreateV1>>
>;
export type HabitsControllerCreateV1MutationBody = CreateHabitDto;
export type HabitsControllerCreateV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerCreateV1>>,
      TError,
      { data: CreateHabitDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerCreateV1>>,
  TError,
  { data: CreateHabitDto },
  TContext
> => {
  const mutationOptions = getHabitsControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerGetV1 = (
  habitId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HabitDetailResponse>(
    { url: `/v1/habits/${habitId}`, method: 'GET', signal },
    options,
  );
};

export const getHabitsControllerGetV1QueryKey = (habitId?: string) => {
  return [`/v1/habits/${habitId}`] as const;
};

export const getHabitsControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof habitsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHabitsControllerGetV1QueryKey(habitId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof habitsControllerGetV1>>> = ({ signal }) =>
    habitsControllerGetV1(habitId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!habitId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof habitsControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HabitsControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerGetV1>>
>;
export type HabitsControllerGetV1QueryError = ProblemDetailsResponse;

export function useHabitsControllerGetV1<
  TData = Awaited<ReturnType<typeof habitsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerGetV1<
  TData = Awaited<ReturnType<typeof habitsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerGetV1<
  TData = Awaited<ReturnType<typeof habitsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHabitsControllerGetV1<
  TData = Awaited<ReturnType<typeof habitsControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHabitsControllerGetV1QueryOptions(habitId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const habitsControllerUpdateV1 = (
  habitId: string,
  updateHabitDto: UpdateHabitDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/habits/${habitId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateHabitDto,
    },
    options,
  );
};

export const getHabitsControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerUpdateV1>>,
    TError,
    { habitId: string; data: UpdateHabitDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerUpdateV1>>,
  TError,
  { habitId: string; data: UpdateHabitDto },
  TContext
> => {
  const mutationKey = ['habitsControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerUpdateV1>>,
    { habitId: string; data: UpdateHabitDto }
  > = (props) => {
    const { habitId, data } = props ?? {};

    return habitsControllerUpdateV1(habitId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerUpdateV1>>
>;
export type HabitsControllerUpdateV1MutationBody = UpdateHabitDto;
export type HabitsControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerUpdateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerUpdateV1>>,
      TError,
      { habitId: string; data: UpdateHabitDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerUpdateV1>>,
  TError,
  { habitId: string; data: UpdateHabitDto },
  TContext
> => {
  const mutationOptions = getHabitsControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerRemoveV1 = (
  habitId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>({ url: `/v1/habits/${habitId}`, method: 'DELETE' }, options);
};

export const getHabitsControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerRemoveV1>>,
    TError,
    { habitId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerRemoveV1>>,
  TError,
  { habitId: string },
  TContext
> => {
  const mutationKey = ['habitsControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerRemoveV1>>,
    { habitId: string }
  > = (props) => {
    const { habitId } = props ?? {};

    return habitsControllerRemoveV1(habitId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerRemoveV1>>
>;

export type HabitsControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerRemoveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerRemoveV1>>,
      TError,
      { habitId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerRemoveV1>>,
  TError,
  { habitId: string },
  TContext
> => {
  const mutationOptions = getHabitsControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerHistoryV1 = (
  habitId: string,
  params: HabitsControllerHistoryV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HabitHistoryResponse>(
    { url: `/v1/habits/${habitId}/history`, method: 'GET', params, signal },
    options,
  );
};

export const getHabitsControllerHistoryV1QueryKey = (
  habitId?: string,
  params?: HabitsControllerHistoryV1Params,
) => {
  return [`/v1/habits/${habitId}/history`, ...(params ? [params] : [])] as const;
};

export const getHabitsControllerHistoryV1QueryOptions = <
  TData = Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  params: HabitsControllerHistoryV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerHistoryV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHabitsControllerHistoryV1QueryKey(habitId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof habitsControllerHistoryV1>>> = ({
    signal,
  }) => habitsControllerHistoryV1(habitId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!habitId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HabitsControllerHistoryV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerHistoryV1>>
>;
export type HabitsControllerHistoryV1QueryError = ProblemDetailsResponse;

export function useHabitsControllerHistoryV1<
  TData = Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  params: HabitsControllerHistoryV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerHistoryV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerHistoryV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerHistoryV1<
  TData = Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  params: HabitsControllerHistoryV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerHistoryV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
          TError,
          Awaited<ReturnType<typeof habitsControllerHistoryV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHabitsControllerHistoryV1<
  TData = Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  params: HabitsControllerHistoryV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerHistoryV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useHabitsControllerHistoryV1<
  TData = Awaited<ReturnType<typeof habitsControllerHistoryV1>>,
  TError = ProblemDetailsResponse,
>(
  habitId: string,
  params: HabitsControllerHistoryV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof habitsControllerHistoryV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHabitsControllerHistoryV1QueryOptions(habitId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const habitsControllerArchiveV1 = (
  habitId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/habits/${habitId}/archive`, method: 'POST', signal }, options);
};

export const getHabitsControllerArchiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerArchiveV1>>,
    TError,
    { habitId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerArchiveV1>>,
  TError,
  { habitId: string },
  TContext
> => {
  const mutationKey = ['habitsControllerArchiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerArchiveV1>>,
    { habitId: string }
  > = (props) => {
    const { habitId } = props ?? {};

    return habitsControllerArchiveV1(habitId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerArchiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerArchiveV1>>
>;

export type HabitsControllerArchiveV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerArchiveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerArchiveV1>>,
      TError,
      { habitId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerArchiveV1>>,
  TError,
  { habitId: string },
  TContext
> => {
  const mutationOptions = getHabitsControllerArchiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerCheckInV1 = (
  habitId: string,
  checkInHabitDto: CheckInHabitDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CheckInHabitResponse>(
    {
      url: `/v1/habits/${habitId}/check-in`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkInHabitDto,
      signal,
    },
    options,
  );
};

export const getHabitsControllerCheckInV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerCheckInV1>>,
    TError,
    { habitId: string; data: CheckInHabitDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerCheckInV1>>,
  TError,
  { habitId: string; data: CheckInHabitDto },
  TContext
> => {
  const mutationKey = ['habitsControllerCheckInV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerCheckInV1>>,
    { habitId: string; data: CheckInHabitDto }
  > = (props) => {
    const { habitId, data } = props ?? {};

    return habitsControllerCheckInV1(habitId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerCheckInV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerCheckInV1>>
>;
export type HabitsControllerCheckInV1MutationBody = CheckInHabitDto;
export type HabitsControllerCheckInV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerCheckInV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerCheckInV1>>,
      TError,
      { habitId: string; data: CheckInHabitDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerCheckInV1>>,
  TError,
  { habitId: string; data: CheckInHabitDto },
  TContext
> => {
  const mutationOptions = getHabitsControllerCheckInV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerUncheckV1 = (
  habitId: string,
  uncheckHabitDto: UncheckHabitDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<UncheckHabitResponse>(
    {
      url: `/v1/habits/${habitId}/uncheck`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uncheckHabitDto,
      signal,
    },
    options,
  );
};

export const getHabitsControllerUncheckV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerUncheckV1>>,
    TError,
    { habitId: string; data: UncheckHabitDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerUncheckV1>>,
  TError,
  { habitId: string; data: UncheckHabitDto },
  TContext
> => {
  const mutationKey = ['habitsControllerUncheckV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerUncheckV1>>,
    { habitId: string; data: UncheckHabitDto }
  > = (props) => {
    const { habitId, data } = props ?? {};

    return habitsControllerUncheckV1(habitId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerUncheckV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerUncheckV1>>
>;
export type HabitsControllerUncheckV1MutationBody = UncheckHabitDto;
export type HabitsControllerUncheckV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerUncheckV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerUncheckV1>>,
      TError,
      { habitId: string; data: UncheckHabitDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerUncheckV1>>,
  TError,
  { habitId: string; data: UncheckHabitDto },
  TContext
> => {
  const mutationOptions = getHabitsControllerUncheckV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerExcuseV1 = (
  habitId: string,
  excuseHabitDayDto: ExcuseHabitDayDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ExcuseHabitDayResponse>(
    {
      url: `/v1/habits/${habitId}/excuse`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: excuseHabitDayDto,
      signal,
    },
    options,
  );
};

export const getHabitsControllerExcuseV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerExcuseV1>>,
    TError,
    { habitId: string; data: ExcuseHabitDayDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerExcuseV1>>,
  TError,
  { habitId: string; data: ExcuseHabitDayDto },
  TContext
> => {
  const mutationKey = ['habitsControllerExcuseV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerExcuseV1>>,
    { habitId: string; data: ExcuseHabitDayDto }
  > = (props) => {
    const { habitId, data } = props ?? {};

    return habitsControllerExcuseV1(habitId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerExcuseV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerExcuseV1>>
>;
export type HabitsControllerExcuseV1MutationBody = ExcuseHabitDayDto;
export type HabitsControllerExcuseV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerExcuseV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerExcuseV1>>,
      TError,
      { habitId: string; data: ExcuseHabitDayDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerExcuseV1>>,
  TError,
  { habitId: string; data: ExcuseHabitDayDto },
  TContext
> => {
  const mutationOptions = getHabitsControllerExcuseV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const habitsControllerUnexcuseV1 = (
  habitId: string,
  date: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<UnexcuseHabitDayResponse>(
    { url: `/v1/habits/${habitId}/excuse/${date}`, method: 'DELETE' },
    options,
  );
};

export const getHabitsControllerUnexcuseV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof habitsControllerUnexcuseV1>>,
    TError,
    { habitId: string; date: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof habitsControllerUnexcuseV1>>,
  TError,
  { habitId: string; date: string },
  TContext
> => {
  const mutationKey = ['habitsControllerUnexcuseV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof habitsControllerUnexcuseV1>>,
    { habitId: string; date: string }
  > = (props) => {
    const { habitId, date } = props ?? {};

    return habitsControllerUnexcuseV1(habitId, date, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HabitsControllerUnexcuseV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof habitsControllerUnexcuseV1>>
>;

export type HabitsControllerUnexcuseV1MutationError = ProblemDetailsResponse;

export const useHabitsControllerUnexcuseV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof habitsControllerUnexcuseV1>>,
      TError,
      { habitId: string; date: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof habitsControllerUnexcuseV1>>,
  TError,
  { habitId: string; date: string },
  TContext
> => {
  const mutationOptions = getHabitsControllerUnexcuseV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerStateV1 = (
  params?: PlayControllerStateV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlayStateResponse>(
    { url: `/v1/play/state`, method: 'GET', params, signal },
    options,
  );
};

export const getPlayControllerStateV1QueryKey = (params?: PlayControllerStateV1Params) => {
  return [`/v1/play/state`, ...(params ? [params] : [])] as const;
};

export const getPlayControllerStateV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerStateV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerStateV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerStateV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerStateV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerStateV1>>> = ({ signal }) =>
    playControllerStateV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerStateV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerStateV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerStateV1>>
>;
export type PlayControllerStateV1QueryError = ProblemDetailsResponse;

export function usePlayControllerStateV1<
  TData = Awaited<ReturnType<typeof playControllerStateV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlayControllerStateV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerStateV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerStateV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerStateV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerStateV1<
  TData = Awaited<ReturnType<typeof playControllerStateV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerStateV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerStateV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerStateV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerStateV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerStateV1<
  TData = Awaited<ReturnType<typeof playControllerStateV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerStateV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerStateV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerStateV1<
  TData = Awaited<ReturnType<typeof playControllerStateV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerStateV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerStateV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerStateV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerHeroV1 = (
  params?: PlayControllerHeroV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HeroEnvelopeResponse>(
    { url: `/v1/play/hero`, method: 'GET', params, signal },
    options,
  );
};

export const getPlayControllerHeroV1QueryKey = (params?: PlayControllerHeroV1Params) => {
  return [`/v1/play/hero`, ...(params ? [params] : [])] as const;
};

export const getPlayControllerHeroV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerHeroV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerHeroV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerHeroV1>>> = ({ signal }) =>
    playControllerHeroV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerHeroV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerHeroV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerHeroV1>>
>;
export type PlayControllerHeroV1QueryError = ProblemDetailsResponse;

export function usePlayControllerHeroV1<
  TData = Awaited<ReturnType<typeof playControllerHeroV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlayControllerHeroV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerHeroV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerHeroV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerHeroV1<
  TData = Awaited<ReturnType<typeof playControllerHeroV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerHeroV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerHeroV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerHeroV1<
  TData = Awaited<ReturnType<typeof playControllerHeroV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerHeroV1<
  TData = Awaited<ReturnType<typeof playControllerHeroV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerHeroV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerChooseHeroV1 = (
  chooseHeroDto: ChooseHeroDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ChooseHeroResponse>(
    {
      url: `/v1/play/hero`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: chooseHeroDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerChooseHeroV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerChooseHeroV1>>,
    TError,
    { data: ChooseHeroDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerChooseHeroV1>>,
  TError,
  { data: ChooseHeroDto },
  TContext
> => {
  const mutationKey = ['playControllerChooseHeroV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerChooseHeroV1>>,
    { data: ChooseHeroDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerChooseHeroV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerChooseHeroV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerChooseHeroV1>>
>;
export type PlayControllerChooseHeroV1MutationBody = ChooseHeroDto;
export type PlayControllerChooseHeroV1MutationError = ProblemDetailsResponse;

export const usePlayControllerChooseHeroV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerChooseHeroV1>>,
      TError,
      { data: ChooseHeroDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerChooseHeroV1>>,
  TError,
  { data: ChooseHeroDto },
  TContext
> => {
  const mutationOptions = getPlayControllerChooseHeroV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerArchetypesV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ArchetypeResponse[]>(
    { url: `/v1/play/archetypes`, method: 'GET', signal },
    options,
  );
};

export const getPlayControllerArchetypesV1QueryKey = () => {
  return [`/v1/play/archetypes`] as const;
};

export const getPlayControllerArchetypesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerArchetypesV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof playControllerArchetypesV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerArchetypesV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerArchetypesV1>>> = ({
    signal,
  }) => playControllerArchetypesV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerArchetypesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerArchetypesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerArchetypesV1>>
>;
export type PlayControllerArchetypesV1QueryError = ProblemDetailsResponse;

export function usePlayControllerArchetypesV1<
  TData = Awaited<ReturnType<typeof playControllerArchetypesV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerArchetypesV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerArchetypesV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerArchetypesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerArchetypesV1<
  TData = Awaited<ReturnType<typeof playControllerArchetypesV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerArchetypesV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerArchetypesV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerArchetypesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerArchetypesV1<
  TData = Awaited<ReturnType<typeof playControllerArchetypesV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerArchetypesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerArchetypesV1<
  TData = Awaited<ReturnType<typeof playControllerArchetypesV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerArchetypesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerArchetypesV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerHeroesV1 = (
  params?: PlayControllerHeroesV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HeroChoicesResponse>(
    { url: `/v1/play/heroes`, method: 'GET', params, signal },
    options,
  );
};

export const getPlayControllerHeroesV1QueryKey = (params?: PlayControllerHeroesV1Params) => {
  return [`/v1/play/heroes`, ...(params ? [params] : [])] as const;
};

export const getPlayControllerHeroesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerHeroesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerHeroesV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerHeroesV1>>> = ({ signal }) =>
    playControllerHeroesV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerHeroesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerHeroesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerHeroesV1>>
>;
export type PlayControllerHeroesV1QueryError = ProblemDetailsResponse;

export function usePlayControllerHeroesV1<
  TData = Awaited<ReturnType<typeof playControllerHeroesV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlayControllerHeroesV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroesV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerHeroesV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerHeroesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerHeroesV1<
  TData = Awaited<ReturnType<typeof playControllerHeroesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroesV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerHeroesV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerHeroesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerHeroesV1<
  TData = Awaited<ReturnType<typeof playControllerHeroesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerHeroesV1<
  TData = Awaited<ReturnType<typeof playControllerHeroesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerHeroesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerHeroesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerHeroesV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerUnlockHeroV1 = (
  unlockHeroDto: UnlockHeroDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<UnlockHeroResponse>(
    {
      url: `/v1/play/hero/unlock`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: unlockHeroDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerUnlockHeroV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerUnlockHeroV1>>,
    TError,
    { data: UnlockHeroDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerUnlockHeroV1>>,
  TError,
  { data: UnlockHeroDto },
  TContext
> => {
  const mutationKey = ['playControllerUnlockHeroV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerUnlockHeroV1>>,
    { data: UnlockHeroDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerUnlockHeroV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerUnlockHeroV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerUnlockHeroV1>>
>;
export type PlayControllerUnlockHeroV1MutationBody = UnlockHeroDto;
export type PlayControllerUnlockHeroV1MutationError = ProblemDetailsResponse;

export const usePlayControllerUnlockHeroV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerUnlockHeroV1>>,
      TError,
      { data: UnlockHeroDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerUnlockHeroV1>>,
  TError,
  { data: UnlockHeroDto },
  TContext
> => {
  const mutationOptions = getPlayControllerUnlockHeroV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerPetsV1 = (
  params?: PlayControllerPetsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PetChoicesResponse>(
    { url: `/v1/play/pets`, method: 'GET', params, signal },
    options,
  );
};

export const getPlayControllerPetsV1QueryKey = (params?: PlayControllerPetsV1Params) => {
  return [`/v1/play/pets`, ...(params ? [params] : [])] as const;
};

export const getPlayControllerPetsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerPetsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerPetsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerPetsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerPetsV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerPetsV1>>> = ({ signal }) =>
    playControllerPetsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerPetsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerPetsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerPetsV1>>
>;
export type PlayControllerPetsV1QueryError = ProblemDetailsResponse;

export function usePlayControllerPetsV1<
  TData = Awaited<ReturnType<typeof playControllerPetsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlayControllerPetsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerPetsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerPetsV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerPetsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerPetsV1<
  TData = Awaited<ReturnType<typeof playControllerPetsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerPetsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerPetsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerPetsV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerPetsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerPetsV1<
  TData = Awaited<ReturnType<typeof playControllerPetsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerPetsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerPetsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerPetsV1<
  TData = Awaited<ReturnType<typeof playControllerPetsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerPetsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerPetsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerPetsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerUnlockPetV1 = (
  unlockPetDto: UnlockPetDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<UnlockPetResponse>(
    {
      url: `/v1/play/pet/unlock`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: unlockPetDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerUnlockPetV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerUnlockPetV1>>,
    TError,
    { data: UnlockPetDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerUnlockPetV1>>,
  TError,
  { data: UnlockPetDto },
  TContext
> => {
  const mutationKey = ['playControllerUnlockPetV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerUnlockPetV1>>,
    { data: UnlockPetDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerUnlockPetV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerUnlockPetV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerUnlockPetV1>>
>;
export type PlayControllerUnlockPetV1MutationBody = UnlockPetDto;
export type PlayControllerUnlockPetV1MutationError = ProblemDetailsResponse;

export const usePlayControllerUnlockPetV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerUnlockPetV1>>,
      TError,
      { data: UnlockPetDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerUnlockPetV1>>,
  TError,
  { data: UnlockPetDto },
  TContext
> => {
  const mutationOptions = getPlayControllerUnlockPetV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerEquipPetV1 = (
  equipPetDto: EquipPetDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<EquipPetResponse>(
    {
      url: `/v1/play/pet`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: equipPetDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerEquipPetV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerEquipPetV1>>,
    TError,
    { data: EquipPetDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerEquipPetV1>>,
  TError,
  { data: EquipPetDto },
  TContext
> => {
  const mutationKey = ['playControllerEquipPetV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerEquipPetV1>>,
    { data: EquipPetDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerEquipPetV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerEquipPetV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerEquipPetV1>>
>;
export type PlayControllerEquipPetV1MutationBody = EquipPetDto;
export type PlayControllerEquipPetV1MutationError = ProblemDetailsResponse;

export const usePlayControllerEquipPetV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerEquipPetV1>>,
      TError,
      { data: EquipPetDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerEquipPetV1>>,
  TError,
  { data: EquipPetDto },
  TContext
> => {
  const mutationOptions = getPlayControllerEquipPetV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerBackgroundsV1 = (
  params?: PlayControllerBackgroundsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<BackgroundChoicesResponse>(
    { url: `/v1/play/backgrounds`, method: 'GET', params, signal },
    options,
  );
};

export const getPlayControllerBackgroundsV1QueryKey = (
  params?: PlayControllerBackgroundsV1Params,
) => {
  return [`/v1/play/backgrounds`, ...(params ? [params] : [])] as const;
};

export const getPlayControllerBackgroundsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerBackgroundsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerBackgroundsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerBackgroundsV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerBackgroundsV1>>> = ({
    signal,
  }) => playControllerBackgroundsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerBackgroundsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerBackgroundsV1>>
>;
export type PlayControllerBackgroundsV1QueryError = ProblemDetailsResponse;

export function usePlayControllerBackgroundsV1<
  TData = Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlayControllerBackgroundsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerBackgroundsV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerBackgroundsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerBackgroundsV1<
  TData = Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerBackgroundsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerBackgroundsV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerBackgroundsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerBackgroundsV1<
  TData = Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerBackgroundsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerBackgroundsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerBackgroundsV1<
  TData = Awaited<ReturnType<typeof playControllerBackgroundsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerBackgroundsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerBackgroundsV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerBackgroundsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerUnlockBackgroundV1 = (
  unlockBackgroundDto: UnlockBackgroundDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<UnlockBackgroundResponse>(
    {
      url: `/v1/play/background/unlock`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: unlockBackgroundDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerUnlockBackgroundV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerUnlockBackgroundV1>>,
    TError,
    { data: UnlockBackgroundDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerUnlockBackgroundV1>>,
  TError,
  { data: UnlockBackgroundDto },
  TContext
> => {
  const mutationKey = ['playControllerUnlockBackgroundV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerUnlockBackgroundV1>>,
    { data: UnlockBackgroundDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerUnlockBackgroundV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerUnlockBackgroundV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerUnlockBackgroundV1>>
>;
export type PlayControllerUnlockBackgroundV1MutationBody = UnlockBackgroundDto;
export type PlayControllerUnlockBackgroundV1MutationError = ProblemDetailsResponse;

export const usePlayControllerUnlockBackgroundV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerUnlockBackgroundV1>>,
      TError,
      { data: UnlockBackgroundDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerUnlockBackgroundV1>>,
  TError,
  { data: UnlockBackgroundDto },
  TContext
> => {
  const mutationOptions = getPlayControllerUnlockBackgroundV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerEquipBackgroundV1 = (
  equipBackgroundDto: EquipBackgroundDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<EquipBackgroundResponse>(
    {
      url: `/v1/play/background`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: equipBackgroundDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerEquipBackgroundV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerEquipBackgroundV1>>,
    TError,
    { data: EquipBackgroundDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerEquipBackgroundV1>>,
  TError,
  { data: EquipBackgroundDto },
  TContext
> => {
  const mutationKey = ['playControllerEquipBackgroundV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerEquipBackgroundV1>>,
    { data: EquipBackgroundDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerEquipBackgroundV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerEquipBackgroundV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerEquipBackgroundV1>>
>;
export type PlayControllerEquipBackgroundV1MutationBody = EquipBackgroundDto;
export type PlayControllerEquipBackgroundV1MutationError = ProblemDetailsResponse;

export const usePlayControllerEquipBackgroundV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerEquipBackgroundV1>>,
      TError,
      { data: EquipBackgroundDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerEquipBackgroundV1>>,
  TError,
  { data: EquipBackgroundDto },
  TContext
> => {
  const mutationOptions = getPlayControllerEquipBackgroundV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerRenameHeroV1 = (
  renameHeroDto: RenameHeroDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<RenameHeroResponse>(
    {
      url: `/v1/play/hero/name`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: renameHeroDto,
    },
    options,
  );
};

export const getPlayControllerRenameHeroV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerRenameHeroV1>>,
    TError,
    { data: RenameHeroDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerRenameHeroV1>>,
  TError,
  { data: RenameHeroDto },
  TContext
> => {
  const mutationKey = ['playControllerRenameHeroV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerRenameHeroV1>>,
    { data: RenameHeroDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerRenameHeroV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerRenameHeroV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerRenameHeroV1>>
>;
export type PlayControllerRenameHeroV1MutationBody = RenameHeroDto;
export type PlayControllerRenameHeroV1MutationError = ProblemDetailsResponse;

export const usePlayControllerRenameHeroV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerRenameHeroV1>>,
      TError,
      { data: RenameHeroDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerRenameHeroV1>>,
  TError,
  { data: RenameHeroDto },
  TContext
> => {
  const mutationOptions = getPlayControllerRenameHeroV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const playControllerVoiceV1 = (
  params?: PlayControllerVoiceV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<VoiceFeedResponse>(
    { url: `/v1/play/voice`, method: 'GET', params, signal },
    options,
  );
};

export const getPlayControllerVoiceV1QueryKey = (params?: PlayControllerVoiceV1Params) => {
  return [`/v1/play/voice`, ...(params ? [params] : [])] as const;
};

export const getPlayControllerVoiceV1QueryOptions = <
  TData = Awaited<ReturnType<typeof playControllerVoiceV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerVoiceV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerVoiceV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlayControllerVoiceV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof playControllerVoiceV1>>> = ({ signal }) =>
    playControllerVoiceV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof playControllerVoiceV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlayControllerVoiceV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof playControllerVoiceV1>>
>;
export type PlayControllerVoiceV1QueryError = ProblemDetailsResponse;

export function usePlayControllerVoiceV1<
  TData = Awaited<ReturnType<typeof playControllerVoiceV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlayControllerVoiceV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerVoiceV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerVoiceV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerVoiceV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerVoiceV1<
  TData = Awaited<ReturnType<typeof playControllerVoiceV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerVoiceV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerVoiceV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playControllerVoiceV1>>,
          TError,
          Awaited<ReturnType<typeof playControllerVoiceV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlayControllerVoiceV1<
  TData = Awaited<ReturnType<typeof playControllerVoiceV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerVoiceV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerVoiceV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlayControllerVoiceV1<
  TData = Awaited<ReturnType<typeof playControllerVoiceV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlayControllerVoiceV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof playControllerVoiceV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlayControllerVoiceV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const playControllerMarkVoiceSeenV1 = (
  markVoiceSeenDto: MarkVoiceSeenDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/play/voice/seen`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: markVoiceSeenDto,
      signal,
    },
    options,
  );
};

export const getPlayControllerMarkVoiceSeenV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playControllerMarkVoiceSeenV1>>,
    TError,
    { data: MarkVoiceSeenDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playControllerMarkVoiceSeenV1>>,
  TError,
  { data: MarkVoiceSeenDto },
  TContext
> => {
  const mutationKey = ['playControllerMarkVoiceSeenV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playControllerMarkVoiceSeenV1>>,
    { data: MarkVoiceSeenDto }
  > = (props) => {
    const { data } = props ?? {};

    return playControllerMarkVoiceSeenV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayControllerMarkVoiceSeenV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof playControllerMarkVoiceSeenV1>>
>;
export type PlayControllerMarkVoiceSeenV1MutationBody = MarkVoiceSeenDto;
export type PlayControllerMarkVoiceSeenV1MutationError = ProblemDetailsResponse;

export const usePlayControllerMarkVoiceSeenV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof playControllerMarkVoiceSeenV1>>,
      TError,
      { data: MarkVoiceSeenDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof playControllerMarkVoiceSeenV1>>,
  TError,
  { data: MarkVoiceSeenDto },
  TContext
> => {
  const mutationOptions = getPlayControllerMarkVoiceSeenV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const cosmeticsControllerPurchaseV1 = (
  cosmeticItemDto: CosmeticItemDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PurchaseCosmeticResponse>(
    {
      url: `/v1/cosmetics/purchase`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cosmeticItemDto,
      signal,
    },
    options,
  );
};

export const getCosmeticsControllerPurchaseV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cosmeticsControllerPurchaseV1>>,
    TError,
    { data: CosmeticItemDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cosmeticsControllerPurchaseV1>>,
  TError,
  { data: CosmeticItemDto },
  TContext
> => {
  const mutationKey = ['cosmeticsControllerPurchaseV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cosmeticsControllerPurchaseV1>>,
    { data: CosmeticItemDto }
  > = (props) => {
    const { data } = props ?? {};

    return cosmeticsControllerPurchaseV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CosmeticsControllerPurchaseV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof cosmeticsControllerPurchaseV1>>
>;
export type CosmeticsControllerPurchaseV1MutationBody = CosmeticItemDto;
export type CosmeticsControllerPurchaseV1MutationError = ProblemDetailsResponse;

export const useCosmeticsControllerPurchaseV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cosmeticsControllerPurchaseV1>>,
      TError,
      { data: CosmeticItemDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cosmeticsControllerPurchaseV1>>,
  TError,
  { data: CosmeticItemDto },
  TContext
> => {
  const mutationOptions = getCosmeticsControllerPurchaseV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const cosmeticsControllerEquipV1 = (
  cosmeticItemDto: CosmeticItemDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/cosmetics/equip`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cosmeticItemDto,
      signal,
    },
    options,
  );
};

export const getCosmeticsControllerEquipV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cosmeticsControllerEquipV1>>,
    TError,
    { data: CosmeticItemDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cosmeticsControllerEquipV1>>,
  TError,
  { data: CosmeticItemDto },
  TContext
> => {
  const mutationKey = ['cosmeticsControllerEquipV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cosmeticsControllerEquipV1>>,
    { data: CosmeticItemDto }
  > = (props) => {
    const { data } = props ?? {};

    return cosmeticsControllerEquipV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CosmeticsControllerEquipV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof cosmeticsControllerEquipV1>>
>;
export type CosmeticsControllerEquipV1MutationBody = CosmeticItemDto;
export type CosmeticsControllerEquipV1MutationError = ProblemDetailsResponse;

export const useCosmeticsControllerEquipV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cosmeticsControllerEquipV1>>,
      TError,
      { data: CosmeticItemDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cosmeticsControllerEquipV1>>,
  TError,
  { data: CosmeticItemDto },
  TContext
> => {
  const mutationOptions = getCosmeticsControllerEquipV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const cosmeticsControllerUnequipV1 = (
  cosmeticItemDto: CosmeticItemDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/cosmetics/unequip`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cosmeticItemDto,
      signal,
    },
    options,
  );
};

export const getCosmeticsControllerUnequipV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cosmeticsControllerUnequipV1>>,
    TError,
    { data: CosmeticItemDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cosmeticsControllerUnequipV1>>,
  TError,
  { data: CosmeticItemDto },
  TContext
> => {
  const mutationKey = ['cosmeticsControllerUnequipV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cosmeticsControllerUnequipV1>>,
    { data: CosmeticItemDto }
  > = (props) => {
    const { data } = props ?? {};

    return cosmeticsControllerUnequipV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CosmeticsControllerUnequipV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof cosmeticsControllerUnequipV1>>
>;
export type CosmeticsControllerUnequipV1MutationBody = CosmeticItemDto;
export type CosmeticsControllerUnequipV1MutationError = ProblemDetailsResponse;

export const useCosmeticsControllerUnequipV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cosmeticsControllerUnequipV1>>,
      TError,
      { data: CosmeticItemDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cosmeticsControllerUnequipV1>>,
  TError,
  { data: CosmeticItemDto },
  TContext
> => {
  const mutationOptions = getCosmeticsControllerUnequipV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const cosmeticsControllerCatalogV1 = (
  params?: CosmeticsControllerCatalogV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CosmeticCatalogResponse>(
    { url: `/v1/cosmetics/catalog`, method: 'GET', params, signal },
    options,
  );
};

export const getCosmeticsControllerCatalogV1QueryKey = (
  params?: CosmeticsControllerCatalogV1Params,
) => {
  return [`/v1/cosmetics/catalog`, ...(params ? [params] : [])] as const;
};

export const getCosmeticsControllerCatalogV1QueryOptions = <
  TData = Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerCatalogV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCosmeticsControllerCatalogV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>> = ({
    signal,
  }) => cosmeticsControllerCatalogV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CosmeticsControllerCatalogV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>
>;
export type CosmeticsControllerCatalogV1QueryError = ProblemDetailsResponse;

export function useCosmeticsControllerCatalogV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | CosmeticsControllerCatalogV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
          TError,
          Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCosmeticsControllerCatalogV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerCatalogV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
          TError,
          Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCosmeticsControllerCatalogV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerCatalogV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCosmeticsControllerCatalogV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerCatalogV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerCatalogV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCosmeticsControllerCatalogV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const cosmeticsControllerEquippedV1 = (
  params?: CosmeticsControllerEquippedV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<EquippedCosmeticsResponse>(
    { url: `/v1/cosmetics/equipped`, method: 'GET', params, signal },
    options,
  );
};

export const getCosmeticsControllerEquippedV1QueryKey = (
  params?: CosmeticsControllerEquippedV1Params,
) => {
  return [`/v1/cosmetics/equipped`, ...(params ? [params] : [])] as const;
};

export const getCosmeticsControllerEquippedV1QueryOptions = <
  TData = Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerEquippedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCosmeticsControllerEquippedV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>> = ({
    signal,
  }) => cosmeticsControllerEquippedV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CosmeticsControllerEquippedV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>
>;
export type CosmeticsControllerEquippedV1QueryError = ProblemDetailsResponse;

export function useCosmeticsControllerEquippedV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | CosmeticsControllerEquippedV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
          TError,
          Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCosmeticsControllerEquippedV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerEquippedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
          TError,
          Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCosmeticsControllerEquippedV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerEquippedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCosmeticsControllerEquippedV1<
  TData = Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: CosmeticsControllerEquippedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cosmeticsControllerEquippedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCosmeticsControllerEquippedV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const questsControllerActiveV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ActiveQuestsResponse>(
    { url: `/v1/quests/active`, method: 'GET', signal },
    options,
  );
};

export const getQuestsControllerActiveV1QueryKey = () => {
  return [`/v1/quests/active`] as const;
};

export const getQuestsControllerActiveV1QueryOptions = <
  TData = Awaited<ReturnType<typeof questsControllerActiveV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof questsControllerActiveV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getQuestsControllerActiveV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof questsControllerActiveV1>>> = ({
    signal,
  }) => questsControllerActiveV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof questsControllerActiveV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QuestsControllerActiveV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerActiveV1>>
>;
export type QuestsControllerActiveV1QueryError = ProblemDetailsResponse;

export function useQuestsControllerActiveV1<
  TData = Awaited<ReturnType<typeof questsControllerActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerActiveV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof questsControllerActiveV1>>,
          TError,
          Awaited<ReturnType<typeof questsControllerActiveV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQuestsControllerActiveV1<
  TData = Awaited<ReturnType<typeof questsControllerActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerActiveV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof questsControllerActiveV1>>,
          TError,
          Awaited<ReturnType<typeof questsControllerActiveV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQuestsControllerActiveV1<
  TData = Awaited<ReturnType<typeof questsControllerActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerActiveV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useQuestsControllerActiveV1<
  TData = Awaited<ReturnType<typeof questsControllerActiveV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerActiveV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getQuestsControllerActiveV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const questsControllerListV1 = (
  params?: QuestsControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<QuestsControllerListV1200>(
    { url: `/v1/quests`, method: 'GET', params, signal },
    options,
  );
};

export const getQuestsControllerListV1QueryKey = (params?: QuestsControllerListV1Params) => {
  return [`/v1/quests`, ...(params ? [params] : [])] as const;
};

export const getQuestsControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof questsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: QuestsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getQuestsControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof questsControllerListV1>>> = ({ signal }) =>
    questsControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof questsControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QuestsControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerListV1>>
>;
export type QuestsControllerListV1QueryError = ProblemDetailsResponse;

export function useQuestsControllerListV1<
  TData = Awaited<ReturnType<typeof questsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | QuestsControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof questsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof questsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQuestsControllerListV1<
  TData = Awaited<ReturnType<typeof questsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: QuestsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof questsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof questsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useQuestsControllerListV1<
  TData = Awaited<ReturnType<typeof questsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: QuestsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useQuestsControllerListV1<
  TData = Awaited<ReturnType<typeof questsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: QuestsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof questsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getQuestsControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const questsControllerCreateV1 = (
  createQuestDto: CreateQuestDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateQuestResponse>(
    {
      url: `/v1/quests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuestDto,
      signal,
    },
    options,
  );
};

export const getQuestsControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questsControllerCreateV1>>,
    TError,
    { data: CreateQuestDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questsControllerCreateV1>>,
  TError,
  { data: CreateQuestDto },
  TContext
> => {
  const mutationKey = ['questsControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questsControllerCreateV1>>,
    { data: CreateQuestDto }
  > = (props) => {
    const { data } = props ?? {};

    return questsControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestsControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerCreateV1>>
>;
export type QuestsControllerCreateV1MutationBody = CreateQuestDto;
export type QuestsControllerCreateV1MutationError = ProblemDetailsResponse;

export const useQuestsControllerCreateV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof questsControllerCreateV1>>,
      TError,
      { data: CreateQuestDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof questsControllerCreateV1>>,
  TError,
  { data: CreateQuestDto },
  TContext
> => {
  const mutationOptions = getQuestsControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const questsControllerUpdateMetaV1 = (
  questId: string,
  updateQuestDto: UpdateQuestDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/quests/${questId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuestDto,
    },
    options,
  );
};

export const getQuestsControllerUpdateMetaV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questsControllerUpdateMetaV1>>,
    TError,
    { questId: string; data: UpdateQuestDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questsControllerUpdateMetaV1>>,
  TError,
  { questId: string; data: UpdateQuestDto },
  TContext
> => {
  const mutationKey = ['questsControllerUpdateMetaV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questsControllerUpdateMetaV1>>,
    { questId: string; data: UpdateQuestDto }
  > = (props) => {
    const { questId, data } = props ?? {};

    return questsControllerUpdateMetaV1(questId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestsControllerUpdateMetaV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerUpdateMetaV1>>
>;
export type QuestsControllerUpdateMetaV1MutationBody = UpdateQuestDto;
export type QuestsControllerUpdateMetaV1MutationError = ProblemDetailsResponse;

export const useQuestsControllerUpdateMetaV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof questsControllerUpdateMetaV1>>,
      TError,
      { questId: string; data: UpdateQuestDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof questsControllerUpdateMetaV1>>,
  TError,
  { questId: string; data: UpdateQuestDto },
  TContext
> => {
  const mutationOptions = getQuestsControllerUpdateMetaV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const questsControllerArchiveV1 = (
  questId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/quests/${questId}/archive`, method: 'POST', signal }, options);
};

export const getQuestsControllerArchiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questsControllerArchiveV1>>,
    TError,
    { questId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questsControllerArchiveV1>>,
  TError,
  { questId: string },
  TContext
> => {
  const mutationKey = ['questsControllerArchiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questsControllerArchiveV1>>,
    { questId: string }
  > = (props) => {
    const { questId } = props ?? {};

    return questsControllerArchiveV1(questId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestsControllerArchiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerArchiveV1>>
>;

export type QuestsControllerArchiveV1MutationError = ProblemDetailsResponse;

export const useQuestsControllerArchiveV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof questsControllerArchiveV1>>,
      TError,
      { questId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof questsControllerArchiveV1>>,
  TError,
  { questId: string },
  TContext
> => {
  const mutationOptions = getQuestsControllerArchiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const questsControllerCompleteObjectiveV1 = (
  questId: string,
  objectiveId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/quests/${questId}/objectives/${objectiveId}/complete`, method: 'POST', signal },
    options,
  );
};

export const getQuestsControllerCompleteObjectiveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questsControllerCompleteObjectiveV1>>,
    TError,
    { questId: string; objectiveId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questsControllerCompleteObjectiveV1>>,
  TError,
  { questId: string; objectiveId: string },
  TContext
> => {
  const mutationKey = ['questsControllerCompleteObjectiveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questsControllerCompleteObjectiveV1>>,
    { questId: string; objectiveId: string }
  > = (props) => {
    const { questId, objectiveId } = props ?? {};

    return questsControllerCompleteObjectiveV1(questId, objectiveId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestsControllerCompleteObjectiveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerCompleteObjectiveV1>>
>;

export type QuestsControllerCompleteObjectiveV1MutationError = ProblemDetailsResponse;

export const useQuestsControllerCompleteObjectiveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof questsControllerCompleteObjectiveV1>>,
      TError,
      { questId: string; objectiveId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof questsControllerCompleteObjectiveV1>>,
  TError,
  { questId: string; objectiveId: string },
  TContext
> => {
  const mutationOptions = getQuestsControllerCompleteObjectiveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const questsControllerPitchInV1 = (
  questId: string,
  objectiveId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/quests/${questId}/objectives/${objectiveId}/pitch-in`, method: 'POST', signal },
    options,
  );
};

export const getQuestsControllerPitchInV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof questsControllerPitchInV1>>,
    TError,
    { questId: string; objectiveId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof questsControllerPitchInV1>>,
  TError,
  { questId: string; objectiveId: string },
  TContext
> => {
  const mutationKey = ['questsControllerPitchInV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof questsControllerPitchInV1>>,
    { questId: string; objectiveId: string }
  > = (props) => {
    const { questId, objectiveId } = props ?? {};

    return questsControllerPitchInV1(questId, objectiveId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuestsControllerPitchInV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof questsControllerPitchInV1>>
>;

export type QuestsControllerPitchInV1MutationError = ProblemDetailsResponse;

export const useQuestsControllerPitchInV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof questsControllerPitchInV1>>,
      TError,
      { questId: string; objectiveId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof questsControllerPitchInV1>>,
  TError,
  { questId: string; objectiveId: string },
  TContext
> => {
  const mutationOptions = getQuestsControllerPitchInV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerMapV1 = (
  params?: LearningControllerMapV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<LearningMapResponse>(
    { url: `/v1/learning/map`, method: 'GET', params, signal },
    options,
  );
};

export const getLearningControllerMapV1QueryKey = (params?: LearningControllerMapV1Params) => {
  return [`/v1/learning/map`, ...(params ? [params] : [])] as const;
};

export const getLearningControllerMapV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerMapV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerMapV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerMapV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerMapV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerMapV1>>> = ({
    signal,
  }) => learningControllerMapV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerMapV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerMapV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerMapV1>>
>;
export type LearningControllerMapV1QueryError = ProblemDetailsResponse;

export function useLearningControllerMapV1<
  TData = Awaited<ReturnType<typeof learningControllerMapV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | LearningControllerMapV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerMapV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerMapV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerMapV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerMapV1<
  TData = Awaited<ReturnType<typeof learningControllerMapV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerMapV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerMapV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerMapV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerMapV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerMapV1<
  TData = Awaited<ReturnType<typeof learningControllerMapV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerMapV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerMapV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerMapV1<
  TData = Awaited<ReturnType<typeof learningControllerMapV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerMapV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerMapV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerMapV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerGoalStatusV1 = (
  params?: LearningControllerGoalStatusV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<GoalStatusResponse>(
    { url: `/v1/learning/goal-status`, method: 'GET', params, signal },
    options,
  );
};

export const getLearningControllerGoalStatusV1QueryKey = (
  params?: LearningControllerGoalStatusV1Params,
) => {
  return [`/v1/learning/goal-status`, ...(params ? [params] : [])] as const;
};

export const getLearningControllerGoalStatusV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerGoalStatusV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalStatusV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerGoalStatusV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerGoalStatusV1>>> = ({
    signal,
  }) => learningControllerGoalStatusV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerGoalStatusV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerGoalStatusV1>>
>;
export type LearningControllerGoalStatusV1QueryError = ProblemDetailsResponse;

export function useLearningControllerGoalStatusV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | LearningControllerGoalStatusV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalStatusV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGoalStatusV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGoalStatusV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerGoalStatusV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalStatusV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGoalStatusV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGoalStatusV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerGoalStatusV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalStatusV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerGoalStatusV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerGoalStatusV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalStatusV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerGoalStatusV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerGoalTrendV1 = (
  params: LearningControllerGoalTrendV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<GoalTrendResponse>(
    { url: `/v1/learning/goal-trend`, method: 'GET', params, signal },
    options,
  );
};

export const getLearningControllerGoalTrendV1QueryKey = (
  params?: LearningControllerGoalTrendV1Params,
) => {
  return [`/v1/learning/goal-trend`, ...(params ? [params] : [])] as const;
};

export const getLearningControllerGoalTrendV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: LearningControllerGoalTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerGoalTrendV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerGoalTrendV1>>> = ({
    signal,
  }) => learningControllerGoalTrendV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerGoalTrendV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerGoalTrendV1>>
>;
export type LearningControllerGoalTrendV1QueryError = ProblemDetailsResponse;

export function useLearningControllerGoalTrendV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: LearningControllerGoalTrendV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalTrendV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGoalTrendV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGoalTrendV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: LearningControllerGoalTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalTrendV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGoalTrendV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGoalTrendV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: LearningControllerGoalTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerGoalTrendV1<
  TData = Awaited<ReturnType<typeof learningControllerGoalTrendV1>>,
  TError = ProblemDetailsResponse,
>(
  params: LearningControllerGoalTrendV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGoalTrendV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerGoalTrendV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerRulesV1 = (
  params?: LearningControllerRulesV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RulesResponse>(
    { url: `/v1/learning/rules`, method: 'GET', params, signal },
    options,
  );
};

export const getLearningControllerRulesV1QueryKey = (params?: LearningControllerRulesV1Params) => {
  return [`/v1/learning/rules`, ...(params ? [params] : [])] as const;
};

export const getLearningControllerRulesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerRulesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerRulesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerRulesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerRulesV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerRulesV1>>> = ({
    signal,
  }) => learningControllerRulesV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerRulesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerRulesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerRulesV1>>
>;
export type LearningControllerRulesV1QueryError = ProblemDetailsResponse;

export function useLearningControllerRulesV1<
  TData = Awaited<ReturnType<typeof learningControllerRulesV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | LearningControllerRulesV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerRulesV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerRulesV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerRulesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerRulesV1<
  TData = Awaited<ReturnType<typeof learningControllerRulesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerRulesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerRulesV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerRulesV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerRulesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerRulesV1<
  TData = Awaited<ReturnType<typeof learningControllerRulesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerRulesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerRulesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerRulesV1<
  TData = Awaited<ReturnType<typeof learningControllerRulesV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: LearningControllerRulesV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerRulesV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerRulesV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerCatalogV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CatalogResponse>({ url: `/v1/learning/catalog`, method: 'GET', signal }, options);
};

export const getLearningControllerCatalogV1QueryKey = () => {
  return [`/v1/learning/catalog`] as const;
};

export const getLearningControllerCatalogV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof learningControllerCatalogV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerCatalogV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerCatalogV1>>> = ({
    signal,
  }) => learningControllerCatalogV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerCatalogV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerCatalogV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerCatalogV1>>
>;
export type LearningControllerCatalogV1QueryError = ProblemDetailsResponse;

export function useLearningControllerCatalogV1<
  TData = Awaited<ReturnType<typeof learningControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerCatalogV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerCatalogV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerCatalogV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerCatalogV1<
  TData = Awaited<ReturnType<typeof learningControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerCatalogV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerCatalogV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerCatalogV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerCatalogV1<
  TData = Awaited<ReturnType<typeof learningControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerCatalogV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerCatalogV1<
  TData = Awaited<ReturnType<typeof learningControllerCatalogV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerCatalogV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerCatalogV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerPreviewTopicV1 = (
  topicId: string,
  params?: LearningControllerPreviewTopicV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<TopicPreviewResponse>(
    { url: `/v1/learning/catalog/topics/${topicId}/preview`, method: 'GET', params, signal },
    options,
  );
};

export const getLearningControllerPreviewTopicV1QueryKey = (
  topicId?: string,
  params?: LearningControllerPreviewTopicV1Params,
) => {
  return [`/v1/learning/catalog/topics/${topicId}/preview`, ...(params ? [params] : [])] as const;
};

export const getLearningControllerPreviewTopicV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  params?: LearningControllerPreviewTopicV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLearningControllerPreviewTopicV1QueryKey(topicId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>> = ({
    signal,
  }) => learningControllerPreviewTopicV1(topicId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!topicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerPreviewTopicV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>
>;
export type LearningControllerPreviewTopicV1QueryError = ProblemDetailsResponse;

export function useLearningControllerPreviewTopicV1<
  TData = Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  params: undefined | LearningControllerPreviewTopicV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerPreviewTopicV1<
  TData = Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  params?: LearningControllerPreviewTopicV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerPreviewTopicV1<
  TData = Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  params?: LearningControllerPreviewTopicV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerPreviewTopicV1<
  TData = Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  params?: LearningControllerPreviewTopicV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerPreviewTopicV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerPreviewTopicV1QueryOptions(topicId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerClearPlacementV1 = (
  params: LearningControllerClearPlacementV1Params,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<PlacementResponse>(
    { url: `/v1/learning/placement`, method: 'DELETE', params },
    options,
  );
};

export const getLearningControllerClearPlacementV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerClearPlacementV1>>,
    TError,
    { params: LearningControllerClearPlacementV1Params },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerClearPlacementV1>>,
  TError,
  { params: LearningControllerClearPlacementV1Params },
  TContext
> => {
  const mutationKey = ['learningControllerClearPlacementV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerClearPlacementV1>>,
    { params: LearningControllerClearPlacementV1Params }
  > = (props) => {
    const { params } = props ?? {};

    return learningControllerClearPlacementV1(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerClearPlacementV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerClearPlacementV1>>
>;

export type LearningControllerClearPlacementV1MutationError = ProblemDetailsResponse;

export const useLearningControllerClearPlacementV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerClearPlacementV1>>,
      TError,
      { params: LearningControllerClearPlacementV1Params },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerClearPlacementV1>>,
  TError,
  { params: LearningControllerClearPlacementV1Params },
  TContext
> => {
  const mutationOptions = getLearningControllerClearPlacementV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerSetKnownTagsV1 = (
  setKnownTagsDto: SetKnownTagsDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<PlacementResponse>(
    {
      url: `/v1/learning/known-tags`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setKnownTagsDto,
    },
    options,
  );
};

export const getLearningControllerSetKnownTagsV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerSetKnownTagsV1>>,
    TError,
    { data: SetKnownTagsDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerSetKnownTagsV1>>,
  TError,
  { data: SetKnownTagsDto },
  TContext
> => {
  const mutationKey = ['learningControllerSetKnownTagsV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerSetKnownTagsV1>>,
    { data: SetKnownTagsDto }
  > = (props) => {
    const { data } = props ?? {};

    return learningControllerSetKnownTagsV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerSetKnownTagsV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerSetKnownTagsV1>>
>;
export type LearningControllerSetKnownTagsV1MutationBody = SetKnownTagsDto;
export type LearningControllerSetKnownTagsV1MutationError = ProblemDetailsResponse;

export const useLearningControllerSetKnownTagsV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerSetKnownTagsV1>>,
      TError,
      { data: SetKnownTagsDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerSetKnownTagsV1>>,
  TError,
  { data: SetKnownTagsDto },
  TContext
> => {
  const mutationOptions = getLearningControllerSetKnownTagsV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerSetEnabledGradesV1 = (
  setEnabledGradesDto: SetEnabledGradesDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<EnabledGradesResponse>(
    {
      url: `/v1/learning/enabled-grades`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setEnabledGradesDto,
    },
    options,
  );
};

export const getLearningControllerSetEnabledGradesV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerSetEnabledGradesV1>>,
    TError,
    { data: SetEnabledGradesDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerSetEnabledGradesV1>>,
  TError,
  { data: SetEnabledGradesDto },
  TContext
> => {
  const mutationKey = ['learningControllerSetEnabledGradesV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerSetEnabledGradesV1>>,
    { data: SetEnabledGradesDto }
  > = (props) => {
    const { data } = props ?? {};

    return learningControllerSetEnabledGradesV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerSetEnabledGradesV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerSetEnabledGradesV1>>
>;
export type LearningControllerSetEnabledGradesV1MutationBody = SetEnabledGradesDto;
export type LearningControllerSetEnabledGradesV1MutationError = ProblemDetailsResponse;

export const useLearningControllerSetEnabledGradesV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerSetEnabledGradesV1>>,
      TError,
      { data: SetEnabledGradesDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerSetEnabledGradesV1>>,
  TError,
  { data: SetEnabledGradesDto },
  TContext
> => {
  const mutationOptions = getLearningControllerSetEnabledGradesV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerSetAssignmentV1 = (
  setAssignmentDto: SetAssignmentDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<AssignmentResponse>(
    {
      url: `/v1/learning/assignments`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setAssignmentDto,
    },
    options,
  );
};

export const getLearningControllerSetAssignmentV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerSetAssignmentV1>>,
    TError,
    { data: SetAssignmentDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerSetAssignmentV1>>,
  TError,
  { data: SetAssignmentDto },
  TContext
> => {
  const mutationKey = ['learningControllerSetAssignmentV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerSetAssignmentV1>>,
    { data: SetAssignmentDto }
  > = (props) => {
    const { data } = props ?? {};

    return learningControllerSetAssignmentV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerSetAssignmentV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerSetAssignmentV1>>
>;
export type LearningControllerSetAssignmentV1MutationBody = SetAssignmentDto;
export type LearningControllerSetAssignmentV1MutationError = ProblemDetailsResponse;

export const useLearningControllerSetAssignmentV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerSetAssignmentV1>>,
      TError,
      { data: SetAssignmentDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerSetAssignmentV1>>,
  TError,
  { data: SetAssignmentDto },
  TContext
> => {
  const mutationOptions = getLearningControllerSetAssignmentV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerCreatePackV1 = (
  createPackDto: CreatePackDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PackDetailResponse>(
    {
      url: `/v1/learning/packs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPackDto,
      signal,
    },
    options,
  );
};

export const getLearningControllerCreatePackV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerCreatePackV1>>,
    TError,
    { data: CreatePackDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerCreatePackV1>>,
  TError,
  { data: CreatePackDto },
  TContext
> => {
  const mutationKey = ['learningControllerCreatePackV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerCreatePackV1>>,
    { data: CreatePackDto }
  > = (props) => {
    const { data } = props ?? {};

    return learningControllerCreatePackV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerCreatePackV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerCreatePackV1>>
>;
export type LearningControllerCreatePackV1MutationBody = CreatePackDto;
export type LearningControllerCreatePackV1MutationError = ProblemDetailsResponse;

export const useLearningControllerCreatePackV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerCreatePackV1>>,
      TError,
      { data: CreatePackDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerCreatePackV1>>,
  TError,
  { data: CreatePackDto },
  TContext
> => {
  const mutationOptions = getLearningControllerCreatePackV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerListPacksV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PackListResponse>({ url: `/v1/learning/packs`, method: 'GET', signal }, options);
};

export const getLearningControllerListPacksV1QueryKey = () => {
  return [`/v1/learning/packs`] as const;
};

export const getLearningControllerListPacksV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerListPacksV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof learningControllerListPacksV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerListPacksV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerListPacksV1>>> = ({
    signal,
  }) => learningControllerListPacksV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerListPacksV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerListPacksV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerListPacksV1>>
>;
export type LearningControllerListPacksV1QueryError = ProblemDetailsResponse;

export function useLearningControllerListPacksV1<
  TData = Awaited<ReturnType<typeof learningControllerListPacksV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerListPacksV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerListPacksV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerListPacksV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerListPacksV1<
  TData = Awaited<ReturnType<typeof learningControllerListPacksV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerListPacksV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerListPacksV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerListPacksV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerListPacksV1<
  TData = Awaited<ReturnType<typeof learningControllerListPacksV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerListPacksV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerListPacksV1<
  TData = Awaited<ReturnType<typeof learningControllerListPacksV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerListPacksV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerListPacksV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerGetPackV1 = (
  id: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PackDetailResponse>(
    { url: `/v1/learning/packs/${id}`, method: 'GET', signal },
    options,
  );
};

export const getLearningControllerGetPackV1QueryKey = (id?: string) => {
  return [`/v1/learning/packs/${id}`] as const;
};

export const getLearningControllerGetPackV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerGetPackV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetPackV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerGetPackV1QueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerGetPackV1>>> = ({
    signal,
  }) => learningControllerGetPackV1(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerGetPackV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerGetPackV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerGetPackV1>>
>;
export type LearningControllerGetPackV1QueryError = ProblemDetailsResponse;

export function useLearningControllerGetPackV1<
  TData = Awaited<ReturnType<typeof learningControllerGetPackV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetPackV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGetPackV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGetPackV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGetPackV1<
  TData = Awaited<ReturnType<typeof learningControllerGetPackV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetPackV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGetPackV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGetPackV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGetPackV1<
  TData = Awaited<ReturnType<typeof learningControllerGetPackV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetPackV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerGetPackV1<
  TData = Awaited<ReturnType<typeof learningControllerGetPackV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetPackV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerGetPackV1QueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerSavePackV1 = (
  id: string,
  savePackDto: SavePackDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<PackDetailResponse>(
    {
      url: `/v1/learning/packs/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: savePackDto,
    },
    options,
  );
};

export const getLearningControllerSavePackV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerSavePackV1>>,
    TError,
    { id: string; data: SavePackDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerSavePackV1>>,
  TError,
  { id: string; data: SavePackDto },
  TContext
> => {
  const mutationKey = ['learningControllerSavePackV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerSavePackV1>>,
    { id: string; data: SavePackDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return learningControllerSavePackV1(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerSavePackV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerSavePackV1>>
>;
export type LearningControllerSavePackV1MutationBody = SavePackDto;
export type LearningControllerSavePackV1MutationError = ProblemDetailsResponse;

export const useLearningControllerSavePackV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerSavePackV1>>,
      TError,
      { id: string; data: SavePackDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerSavePackV1>>,
  TError,
  { id: string; data: SavePackDto },
  TContext
> => {
  const mutationOptions = getLearningControllerSavePackV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerArchivePackV1 = (
  id: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PackSummaryResponse>(
    { url: `/v1/learning/packs/${id}/archive`, method: 'POST', signal },
    options,
  );
};

export const getLearningControllerArchivePackV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerArchivePackV1>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerArchivePackV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['learningControllerArchivePackV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerArchivePackV1>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return learningControllerArchivePackV1(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerArchivePackV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerArchivePackV1>>
>;

export type LearningControllerArchivePackV1MutationError = ProblemDetailsResponse;

export const useLearningControllerArchivePackV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerArchivePackV1>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerArchivePackV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getLearningControllerArchivePackV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerStartSessionV1 = (
  startSessionDto: StartSessionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<StartSessionResponse>(
    {
      url: `/v1/learning/sessions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: startSessionDto,
      signal,
    },
    options,
  );
};

export const getLearningControllerStartSessionV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerStartSessionV1>>,
    TError,
    { data: StartSessionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerStartSessionV1>>,
  TError,
  { data: StartSessionDto },
  TContext
> => {
  const mutationKey = ['learningControllerStartSessionV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerStartSessionV1>>,
    { data: StartSessionDto }
  > = (props) => {
    const { data } = props ?? {};

    return learningControllerStartSessionV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerStartSessionV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerStartSessionV1>>
>;
export type LearningControllerStartSessionV1MutationBody = StartSessionDto;
export type LearningControllerStartSessionV1MutationError = ProblemDetailsResponse;

export const useLearningControllerStartSessionV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerStartSessionV1>>,
      TError,
      { data: StartSessionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerStartSessionV1>>,
  TError,
  { data: StartSessionDto },
  TContext
> => {
  const mutationOptions = getLearningControllerStartSessionV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerAnswerSessionV1 = (
  id: string,
  answerSessionDto: AnswerSessionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<AnswerSessionResponse>(
    {
      url: `/v1/learning/sessions/${id}/answer`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: answerSessionDto,
      signal,
    },
    options,
  );
};

export const getLearningControllerAnswerSessionV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerAnswerSessionV1>>,
    TError,
    { id: string; data: AnswerSessionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerAnswerSessionV1>>,
  TError,
  { id: string; data: AnswerSessionDto },
  TContext
> => {
  const mutationKey = ['learningControllerAnswerSessionV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerAnswerSessionV1>>,
    { id: string; data: AnswerSessionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return learningControllerAnswerSessionV1(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerAnswerSessionV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerAnswerSessionV1>>
>;
export type LearningControllerAnswerSessionV1MutationBody = AnswerSessionDto;
export type LearningControllerAnswerSessionV1MutationError = ProblemDetailsResponse;

export const useLearningControllerAnswerSessionV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerAnswerSessionV1>>,
      TError,
      { id: string; data: AnswerSessionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerAnswerSessionV1>>,
  TError,
  { id: string; data: AnswerSessionDto },
  TContext
> => {
  const mutationOptions = getLearningControllerAnswerSessionV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningControllerResumeSessionV1 = (
  id: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ResumeSessionResponse>(
    { url: `/v1/learning/sessions/${id}`, method: 'GET', signal },
    options,
  );
};

export const getLearningControllerResumeSessionV1QueryKey = (id?: string) => {
  return [`/v1/learning/sessions/${id}`] as const;
};

export const getLearningControllerResumeSessionV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerResumeSessionV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerResumeSessionV1QueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerResumeSessionV1>>> = ({
    signal,
  }) => learningControllerResumeSessionV1(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerResumeSessionV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerResumeSessionV1>>
>;
export type LearningControllerResumeSessionV1QueryError = ProblemDetailsResponse;

export function useLearningControllerResumeSessionV1<
  TData = Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerResumeSessionV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerResumeSessionV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerResumeSessionV1<
  TData = Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerResumeSessionV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerResumeSessionV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerResumeSessionV1<
  TData = Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerResumeSessionV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerResumeSessionV1<
  TData = Awaited<ReturnType<typeof learningControllerResumeSessionV1>>,
  TError = ProblemDetailsResponse,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerResumeSessionV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerResumeSessionV1QueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerGetLessonV1 = (
  topicId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<LessonResponse>(
    { url: `/v1/learning/topics/${topicId}/lesson`, method: 'GET', signal },
    options,
  );
};

export const getLearningControllerGetLessonV1QueryKey = (topicId?: string) => {
  return [`/v1/learning/topics/${topicId}/lesson`] as const;
};

export const getLearningControllerGetLessonV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetLessonV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningControllerGetLessonV1QueryKey(topicId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningControllerGetLessonV1>>> = ({
    signal,
  }) => learningControllerGetLessonV1(topicId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!topicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningControllerGetLessonV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerGetLessonV1>>
>;
export type LearningControllerGetLessonV1QueryError = ProblemDetailsResponse;

export function useLearningControllerGetLessonV1<
  TData = Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetLessonV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGetLessonV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGetLessonV1<
  TData = Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetLessonV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
          TError,
          Awaited<ReturnType<typeof learningControllerGetLessonV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningControllerGetLessonV1<
  TData = Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetLessonV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningControllerGetLessonV1<
  TData = Awaited<ReturnType<typeof learningControllerGetLessonV1>>,
  TError = ProblemDetailsResponse,
>(
  topicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningControllerGetLessonV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningControllerGetLessonV1QueryOptions(topicId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningControllerMarkLessonViewedV1 = (
  topicId: string,
  markLessonViewedDto: MarkLessonViewedDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<LessonViewedResponse>(
    {
      url: `/v1/learning/topics/${topicId}/lesson/viewed`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: markLessonViewedDto,
      signal,
    },
    options,
  );
};

export const getLearningControllerMarkLessonViewedV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningControllerMarkLessonViewedV1>>,
    TError,
    { topicId: string; data: MarkLessonViewedDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningControllerMarkLessonViewedV1>>,
  TError,
  { topicId: string; data: MarkLessonViewedDto },
  TContext
> => {
  const mutationKey = ['learningControllerMarkLessonViewedV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningControllerMarkLessonViewedV1>>,
    { topicId: string; data: MarkLessonViewedDto }
  > = (props) => {
    const { topicId, data } = props ?? {};

    return learningControllerMarkLessonViewedV1(topicId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningControllerMarkLessonViewedV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningControllerMarkLessonViewedV1>>
>;
export type LearningControllerMarkLessonViewedV1MutationBody = MarkLessonViewedDto;
export type LearningControllerMarkLessonViewedV1MutationError = ProblemDetailsResponse;

export const useLearningControllerMarkLessonViewedV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningControllerMarkLessonViewedV1>>,
      TError,
      { topicId: string; data: MarkLessonViewedDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningControllerMarkLessonViewedV1>>,
  TError,
  { topicId: string; data: MarkLessonViewedDto },
  TContext
> => {
  const mutationOptions = getLearningControllerMarkLessonViewedV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningGoalsControllerListV1 = (
  childId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<LearningGoalResponse[]>(
    { url: `/v1/learning/goals/child/${childId}`, method: 'GET', signal },
    options,
  );
};

export const getLearningGoalsControllerListV1QueryKey = (childId?: string) => {
  return [`/v1/learning/goals/child/${childId}`] as const;
};

export const getLearningGoalsControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningGoalsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLearningGoalsControllerListV1QueryKey(childId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof learningGoalsControllerListV1>>> = ({
    signal,
  }) => learningGoalsControllerListV1(childId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!childId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LearningGoalsControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof learningGoalsControllerListV1>>
>;
export type LearningGoalsControllerListV1QueryError = ProblemDetailsResponse;

export function useLearningGoalsControllerListV1<
  TData = Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningGoalsControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof learningGoalsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningGoalsControllerListV1<
  TData = Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningGoalsControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof learningGoalsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLearningGoalsControllerListV1<
  TData = Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningGoalsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useLearningGoalsControllerListV1<
  TData = Awaited<ReturnType<typeof learningGoalsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  childId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof learningGoalsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getLearningGoalsControllerListV1QueryOptions(childId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const learningGoalsControllerCreateV1 = (
  createLearningGoalDto: CreateLearningGoalDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateLearningGoalResponse>(
    {
      url: `/v1/learning/goals`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createLearningGoalDto,
      signal,
    },
    options,
  );
};

export const getLearningGoalsControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningGoalsControllerCreateV1>>,
    TError,
    { data: CreateLearningGoalDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningGoalsControllerCreateV1>>,
  TError,
  { data: CreateLearningGoalDto },
  TContext
> => {
  const mutationKey = ['learningGoalsControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningGoalsControllerCreateV1>>,
    { data: CreateLearningGoalDto }
  > = (props) => {
    const { data } = props ?? {};

    return learningGoalsControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningGoalsControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningGoalsControllerCreateV1>>
>;
export type LearningGoalsControllerCreateV1MutationBody = CreateLearningGoalDto;
export type LearningGoalsControllerCreateV1MutationError = ProblemDetailsResponse;

export const useLearningGoalsControllerCreateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningGoalsControllerCreateV1>>,
      TError,
      { data: CreateLearningGoalDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningGoalsControllerCreateV1>>,
  TError,
  { data: CreateLearningGoalDto },
  TContext
> => {
  const mutationOptions = getLearningGoalsControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningGoalsControllerUpdateV1 = (
  goalId: string,
  updateLearningGoalDto: UpdateLearningGoalDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/learning/goals/${goalId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateLearningGoalDto,
    },
    options,
  );
};

export const getLearningGoalsControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningGoalsControllerUpdateV1>>,
    TError,
    { goalId: string; data: UpdateLearningGoalDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningGoalsControllerUpdateV1>>,
  TError,
  { goalId: string; data: UpdateLearningGoalDto },
  TContext
> => {
  const mutationKey = ['learningGoalsControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningGoalsControllerUpdateV1>>,
    { goalId: string; data: UpdateLearningGoalDto }
  > = (props) => {
    const { goalId, data } = props ?? {};

    return learningGoalsControllerUpdateV1(goalId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningGoalsControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningGoalsControllerUpdateV1>>
>;
export type LearningGoalsControllerUpdateV1MutationBody = UpdateLearningGoalDto;
export type LearningGoalsControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useLearningGoalsControllerUpdateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningGoalsControllerUpdateV1>>,
      TError,
      { goalId: string; data: UpdateLearningGoalDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningGoalsControllerUpdateV1>>,
  TError,
  { goalId: string; data: UpdateLearningGoalDto },
  TContext
> => {
  const mutationOptions = getLearningGoalsControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const learningGoalsControllerRemoveV1 = (
  goalId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>({ url: `/v1/learning/goals/${goalId}`, method: 'DELETE' }, options);
};

export const getLearningGoalsControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof learningGoalsControllerRemoveV1>>,
    TError,
    { goalId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof learningGoalsControllerRemoveV1>>,
  TError,
  { goalId: string },
  TContext
> => {
  const mutationKey = ['learningGoalsControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof learningGoalsControllerRemoveV1>>,
    { goalId: string }
  > = (props) => {
    const { goalId } = props ?? {};

    return learningGoalsControllerRemoveV1(goalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LearningGoalsControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof learningGoalsControllerRemoveV1>>
>;

export type LearningGoalsControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useLearningGoalsControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof learningGoalsControllerRemoveV1>>,
      TError,
      { goalId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof learningGoalsControllerRemoveV1>>,
  TError,
  { goalId: string },
  TContext
> => {
  const mutationOptions = getLearningGoalsControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const activityControllerHouseholdFeedV1 = (
  householdId: string,
  params?: ActivityControllerHouseholdFeedV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ActivityControllerHouseholdFeedV1200>(
    { url: `/v1/households/${householdId}/activity`, method: 'GET', params, signal },
    options,
  );
};

export const getActivityControllerHouseholdFeedV1QueryKey = (
  householdId?: string,
  params?: ActivityControllerHouseholdFeedV1Params,
) => {
  return [`/v1/households/${householdId}/activity`, ...(params ? [params] : [])] as const;
};

export const getActivityControllerHouseholdFeedV1QueryOptions = <
  TData = Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  params?: ActivityControllerHouseholdFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getActivityControllerHouseholdFeedV1QueryKey(householdId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>> = ({
    signal,
  }) => activityControllerHouseholdFeedV1(householdId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!householdId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ActivityControllerHouseholdFeedV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>
>;
export type ActivityControllerHouseholdFeedV1QueryError = ProblemDetailsResponse;

export function useActivityControllerHouseholdFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  params: undefined | ActivityControllerHouseholdFeedV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
          TError,
          Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useActivityControllerHouseholdFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  params?: ActivityControllerHouseholdFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
          TError,
          Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useActivityControllerHouseholdFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  params?: ActivityControllerHouseholdFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useActivityControllerHouseholdFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  params?: ActivityControllerHouseholdFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerHouseholdFeedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getActivityControllerHouseholdFeedV1QueryOptions(
    householdId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const activityControllerChildFeedV1 = (
  householdId: string,
  childId: string,
  params?: ActivityControllerChildFeedV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ActivityControllerChildFeedV1200>(
    {
      url: `/v1/households/${householdId}/children/${childId}/activity`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getActivityControllerChildFeedV1QueryKey = (
  householdId?: string,
  childId?: string,
  params?: ActivityControllerChildFeedV1Params,
) => {
  return [
    `/v1/households/${householdId}/children/${childId}/activity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getActivityControllerChildFeedV1QueryOptions = <
  TData = Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  childId: string,
  params?: ActivityControllerChildFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerChildFeedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getActivityControllerChildFeedV1QueryKey(householdId, childId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof activityControllerChildFeedV1>>> = ({
    signal,
  }) => activityControllerChildFeedV1(householdId, childId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(householdId && childId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof activityControllerChildFeedV1>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ActivityControllerChildFeedV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof activityControllerChildFeedV1>>
>;
export type ActivityControllerChildFeedV1QueryError = ProblemDetailsResponse;

export function useActivityControllerChildFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  childId: string,
  params: undefined | ActivityControllerChildFeedV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerChildFeedV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
          TError,
          Awaited<ReturnType<typeof activityControllerChildFeedV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useActivityControllerChildFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  childId: string,
  params?: ActivityControllerChildFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerChildFeedV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
          TError,
          Awaited<ReturnType<typeof activityControllerChildFeedV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useActivityControllerChildFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  childId: string,
  params?: ActivityControllerChildFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerChildFeedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useActivityControllerChildFeedV1<
  TData = Awaited<ReturnType<typeof activityControllerChildFeedV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  childId: string,
  params?: ActivityControllerChildFeedV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityControllerChildFeedV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getActivityControllerChildFeedV1QueryOptions(
    householdId,
    childId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const notificationsControllerVapidPublicKeyV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<VapidPublicKeyResponse>(
    { url: `/v1/notifications/vapid-public-key`, method: 'GET', signal },
    options,
  );
};

export const getNotificationsControllerVapidPublicKeyV1QueryKey = () => {
  return [`/v1/notifications/vapid-public-key`] as const;
};

export const getNotificationsControllerVapidPublicKeyV1QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsControllerVapidPublicKeyV1QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>
  > = ({ signal }) => notificationsControllerVapidPublicKeyV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerVapidPublicKeyV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>
>;
export type NotificationsControllerVapidPublicKeyV1QueryError = ProblemDetailsResponse;

export function useNotificationsControllerVapidPublicKeyV1<
  TData = Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerVapidPublicKeyV1<
  TData = Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerVapidPublicKeyV1<
  TData = Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useNotificationsControllerVapidPublicKeyV1<
  TData = Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerVapidPublicKeyV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNotificationsControllerVapidPublicKeyV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const notificationsControllerSubscribeV1 = (
  subscribeDto: SubscribeDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SubscribeResponse>(
    {
      url: `/v1/notifications/subscribe`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: subscribeDto,
      signal,
    },
    options,
  );
};

export const getNotificationsControllerSubscribeV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerSubscribeV1>>,
    TError,
    { data: SubscribeDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerSubscribeV1>>,
  TError,
  { data: SubscribeDto },
  TContext
> => {
  const mutationKey = ['notificationsControllerSubscribeV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerSubscribeV1>>,
    { data: SubscribeDto }
  > = (props) => {
    const { data } = props ?? {};

    return notificationsControllerSubscribeV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerSubscribeV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerSubscribeV1>>
>;
export type NotificationsControllerSubscribeV1MutationBody = SubscribeDto;
export type NotificationsControllerSubscribeV1MutationError = ProblemDetailsResponse;

export const useNotificationsControllerSubscribeV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerSubscribeV1>>,
      TError,
      { data: SubscribeDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerSubscribeV1>>,
  TError,
  { data: SubscribeDto },
  TContext
> => {
  const mutationOptions = getNotificationsControllerSubscribeV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const notificationsControllerUnsubscribeV1 = (
  unsubscribeDto: UnsubscribeDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/notifications/unsubscribe`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: unsubscribeDto,
      signal,
    },
    options,
  );
};

export const getNotificationsControllerUnsubscribeV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerUnsubscribeV1>>,
    TError,
    { data: UnsubscribeDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerUnsubscribeV1>>,
  TError,
  { data: UnsubscribeDto },
  TContext
> => {
  const mutationKey = ['notificationsControllerUnsubscribeV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerUnsubscribeV1>>,
    { data: UnsubscribeDto }
  > = (props) => {
    const { data } = props ?? {};

    return notificationsControllerUnsubscribeV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerUnsubscribeV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerUnsubscribeV1>>
>;
export type NotificationsControllerUnsubscribeV1MutationBody = UnsubscribeDto;
export type NotificationsControllerUnsubscribeV1MutationError = ProblemDetailsResponse;

export const useNotificationsControllerUnsubscribeV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerUnsubscribeV1>>,
      TError,
      { data: UnsubscribeDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerUnsubscribeV1>>,
  TError,
  { data: UnsubscribeDto },
  TContext
> => {
  const mutationOptions = getNotificationsControllerUnsubscribeV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const notificationsControllerGetPreferencesV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<NotificationPreferencesResponse>(
    { url: `/v1/notifications/preferences`, method: 'GET', signal },
    options,
  );
};

export const getNotificationsControllerGetPreferencesV1QueryKey = () => {
  return [`/v1/notifications/preferences`] as const;
};

export const getNotificationsControllerGetPreferencesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsControllerGetPreferencesV1QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>
  > = ({ signal }) => notificationsControllerGetPreferencesV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerGetPreferencesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>
>;
export type NotificationsControllerGetPreferencesV1QueryError = ProblemDetailsResponse;

export function useNotificationsControllerGetPreferencesV1<
  TData = Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerGetPreferencesV1<
  TData = Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerGetPreferencesV1<
  TData = Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useNotificationsControllerGetPreferencesV1<
  TData = Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetPreferencesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNotificationsControllerGetPreferencesV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const notificationsControllerUpdatePreferencesV1 = (
  updatePreferencesDto: UpdatePreferencesDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<NotificationPreferencesResponse>(
    {
      url: `/v1/notifications/preferences`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updatePreferencesDto,
    },
    options,
  );
};

export const getNotificationsControllerUpdatePreferencesV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerUpdatePreferencesV1>>,
    TError,
    { data: UpdatePreferencesDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerUpdatePreferencesV1>>,
  TError,
  { data: UpdatePreferencesDto },
  TContext
> => {
  const mutationKey = ['notificationsControllerUpdatePreferencesV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerUpdatePreferencesV1>>,
    { data: UpdatePreferencesDto }
  > = (props) => {
    const { data } = props ?? {};

    return notificationsControllerUpdatePreferencesV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerUpdatePreferencesV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerUpdatePreferencesV1>>
>;
export type NotificationsControllerUpdatePreferencesV1MutationBody = UpdatePreferencesDto;
export type NotificationsControllerUpdatePreferencesV1MutationError = ProblemDetailsResponse;

export const useNotificationsControllerUpdatePreferencesV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerUpdatePreferencesV1>>,
      TError,
      { data: UpdatePreferencesDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerUpdatePreferencesV1>>,
  TError,
  { data: UpdatePreferencesDto },
  TContext
> => {
  const mutationOptions = getNotificationsControllerUpdatePreferencesV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const notificationsControllerListV1 = (
  params?: NotificationsControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<NotificationListResponse>(
    { url: `/v1/notifications`, method: 'GET', params, signal },
    options,
  );
};

export const getNotificationsControllerListV1QueryKey = (
  params?: NotificationsControllerListV1Params,
) => {
  return [`/v1/notifications`, ...(params ? [params] : [])] as const;
};

export const getNotificationsControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: NotificationsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerListV1>>> = ({
    signal,
  }) => notificationsControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerListV1>>
>;
export type NotificationsControllerListV1QueryError = ProblemDetailsResponse;

export function useNotificationsControllerListV1<
  TData = Awaited<ReturnType<typeof notificationsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | NotificationsControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerListV1<
  TData = Awaited<ReturnType<typeof notificationsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: NotificationsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerListV1<
  TData = Awaited<ReturnType<typeof notificationsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: NotificationsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useNotificationsControllerListV1<
  TData = Awaited<ReturnType<typeof notificationsControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: NotificationsControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNotificationsControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const notificationsControllerUnreadCountV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<UnreadCountResponse>(
    { url: `/v1/notifications/unread-count`, method: 'GET', signal },
    options,
  );
};

export const getNotificationsControllerUnreadCountV1QueryKey = () => {
  return [`/v1/notifications/unread-count`] as const;
};

export const getNotificationsControllerUnreadCountV1QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsControllerUnreadCountV1QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>
  > = ({ signal }) => notificationsControllerUnreadCountV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerUnreadCountV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>
>;
export type NotificationsControllerUnreadCountV1QueryError = ProblemDetailsResponse;

export function useNotificationsControllerUnreadCountV1<
  TData = Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerUnreadCountV1<
  TData = Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsControllerUnreadCountV1<
  TData = Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useNotificationsControllerUnreadCountV1<
  TData = Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNotificationsControllerUnreadCountV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const notificationsControllerMarkReadV1 = (
  id: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>({ url: `/v1/notifications/${id}/read`, method: 'POST', signal }, options);
};

export const getNotificationsControllerMarkReadV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['notificationsControllerMarkReadV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return notificationsControllerMarkReadV1(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerMarkReadV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>
>;

export type NotificationsControllerMarkReadV1MutationError = ProblemDetailsResponse;

export const useNotificationsControllerMarkReadV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getNotificationsControllerMarkReadV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const notificationsControllerMarkAllReadV1 = (
  markAllReadDto: MarkAllReadDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/notifications/read-all`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: markAllReadDto,
      signal,
    },
    options,
  );
};

export const getNotificationsControllerMarkAllReadV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerMarkAllReadV1>>,
    TError,
    { data: MarkAllReadDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerMarkAllReadV1>>,
  TError,
  { data: MarkAllReadDto },
  TContext
> => {
  const mutationKey = ['notificationsControllerMarkAllReadV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerMarkAllReadV1>>,
    { data: MarkAllReadDto }
  > = (props) => {
    const { data } = props ?? {};

    return notificationsControllerMarkAllReadV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerMarkAllReadV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerMarkAllReadV1>>
>;
export type NotificationsControllerMarkAllReadV1MutationBody = MarkAllReadDto;
export type NotificationsControllerMarkAllReadV1MutationError = ProblemDetailsResponse;

export const useNotificationsControllerMarkAllReadV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerMarkAllReadV1>>,
      TError,
      { data: MarkAllReadDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerMarkAllReadV1>>,
  TError,
  { data: MarkAllReadDto },
  TContext
> => {
  const mutationOptions = getNotificationsControllerMarkAllReadV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the household consent state (admin-only).
 */
export const householdDataControllerGetConsentV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ConsentStateResponse>(
    { url: `/v1/household/consent`, method: 'GET', signal },
    options,
  );
};

export const getHouseholdDataControllerGetConsentV1QueryKey = () => {
  return [`/v1/household/consent`] as const;
};

export const getHouseholdDataControllerGetConsentV1QueryOptions = <
  TData = Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHouseholdDataControllerGetConsentV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>> = ({
    signal,
  }) => householdDataControllerGetConsentV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HouseholdDataControllerGetConsentV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>
>;
export type HouseholdDataControllerGetConsentV1QueryError = ProblemDetailsResponse;

export function useHouseholdDataControllerGetConsentV1<
  TData = Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
          TError,
          Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHouseholdDataControllerGetConsentV1<
  TData = Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
          TError,
          Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHouseholdDataControllerGetConsentV1<
  TData = Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the household consent state (admin-only).
 */

export function useHouseholdDataControllerGetConsentV1<
  TData = Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof householdDataControllerGetConsentV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHouseholdDataControllerGetConsentV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Record or refresh household consent (admin-only).
 */
export const householdDataControllerRecordConsentV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RecordConsentResponse>(
    { url: `/v1/household/consent`, method: 'POST', signal },
    options,
  );
};

export const getHouseholdDataControllerRecordConsentV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof householdDataControllerRecordConsentV1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof householdDataControllerRecordConsentV1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['householdDataControllerRecordConsentV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof householdDataControllerRecordConsentV1>>,
    void
  > = () => {
    return householdDataControllerRecordConsentV1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HouseholdDataControllerRecordConsentV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof householdDataControllerRecordConsentV1>>
>;

export type HouseholdDataControllerRecordConsentV1MutationError = ProblemDetailsResponse;

/**
 * @summary Record or refresh household consent (admin-only).
 */
export const useHouseholdDataControllerRecordConsentV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof householdDataControllerRecordConsentV1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof householdDataControllerRecordConsentV1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getHouseholdDataControllerRecordConsentV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Export all household data as JSON (admin-only; no secrets).
 */
export const householdDataControllerExportV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdExportResponse>(
    { url: `/v1/household/export`, method: 'GET', signal },
    options,
  );
};

export const getHouseholdDataControllerExportV1QueryKey = () => {
  return [`/v1/household/export`] as const;
};

export const getHouseholdDataControllerExportV1QueryOptions = <
  TData = Awaited<ReturnType<typeof householdDataControllerExportV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof householdDataControllerExportV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHouseholdDataControllerExportV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof householdDataControllerExportV1>>> = ({
    signal,
  }) => householdDataControllerExportV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof householdDataControllerExportV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HouseholdDataControllerExportV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof householdDataControllerExportV1>>
>;
export type HouseholdDataControllerExportV1QueryError = ProblemDetailsResponse;

export function useHouseholdDataControllerExportV1<
  TData = Awaited<ReturnType<typeof householdDataControllerExportV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdDataControllerExportV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof householdDataControllerExportV1>>,
          TError,
          Awaited<ReturnType<typeof householdDataControllerExportV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHouseholdDataControllerExportV1<
  TData = Awaited<ReturnType<typeof householdDataControllerExportV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdDataControllerExportV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof householdDataControllerExportV1>>,
          TError,
          Awaited<ReturnType<typeof householdDataControllerExportV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHouseholdDataControllerExportV1<
  TData = Awaited<ReturnType<typeof householdDataControllerExportV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdDataControllerExportV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export all household data as JSON (admin-only; no secrets).
 */

export function useHouseholdDataControllerExportV1<
  TData = Awaited<ReturnType<typeof householdDataControllerExportV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof householdDataControllerExportV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHouseholdDataControllerExportV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Purge stale retained data (admin-only maintenance).
 */
export const complianceControllerPurgeV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PurgeResponse>({ url: `/v1/compliance/purge`, method: 'POST', signal }, options);
};

export const getComplianceControllerPurgeV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof complianceControllerPurgeV1>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof complianceControllerPurgeV1>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['complianceControllerPurgeV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof complianceControllerPurgeV1>>,
    void
  > = () => {
    return complianceControllerPurgeV1(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComplianceControllerPurgeV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof complianceControllerPurgeV1>>
>;

export type ComplianceControllerPurgeV1MutationError = ProblemDetailsResponse;

/**
 * @summary Purge stale retained data (admin-only maintenance).
 */
export const useComplianceControllerPurgeV1 = <TError = ProblemDetailsResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof complianceControllerPurgeV1>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof complianceControllerPurgeV1>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getComplianceControllerPurgeV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerListHouseholdsV1 = (
  params?: PlatformAdminControllerListHouseholdsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlatformAdminControllerListHouseholdsV1200>(
    { url: `/v1/platform-admin/households`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformAdminControllerListHouseholdsV1QueryKey = (
  params?: PlatformAdminControllerListHouseholdsV1Params,
) => {
  return [`/v1/platform-admin/households`, ...(params ? [params] : [])] as const;
};

export const getPlatformAdminControllerListHouseholdsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListHouseholdsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerListHouseholdsV1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>
  > = ({ signal }) => platformAdminControllerListHouseholdsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerListHouseholdsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>
>;
export type PlatformAdminControllerListHouseholdsV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerListHouseholdsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformAdminControllerListHouseholdsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListHouseholdsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListHouseholdsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListHouseholdsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListHouseholdsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerListHouseholdsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListHouseholdsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListHouseholdsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerListHouseholdsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerProvisionHouseholdV1 = (
  provisionHouseholdDto: ProvisionHouseholdDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<ProvisionHouseholdResponse>(
    {
      url: `/v1/platform-admin/households`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: provisionHouseholdDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerProvisionHouseholdV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerProvisionHouseholdV1>>,
    TError,
    { data: ProvisionHouseholdDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerProvisionHouseholdV1>>,
  TError,
  { data: ProvisionHouseholdDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerProvisionHouseholdV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerProvisionHouseholdV1>>,
    { data: ProvisionHouseholdDto }
  > = (props) => {
    const { data } = props ?? {};

    return platformAdminControllerProvisionHouseholdV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerProvisionHouseholdV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerProvisionHouseholdV1>>
>;
export type PlatformAdminControllerProvisionHouseholdV1MutationBody = ProvisionHouseholdDto;
export type PlatformAdminControllerProvisionHouseholdV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerProvisionHouseholdV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerProvisionHouseholdV1>>,
      TError,
      { data: ProvisionHouseholdDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerProvisionHouseholdV1>>,
  TError,
  { data: ProvisionHouseholdDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerProvisionHouseholdV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerSuspendV1 = (
  householdId: string,
  suspendHouseholdDto: SuspendHouseholdDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/households/${householdId}/suspend`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: suspendHouseholdDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerSuspendV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerSuspendV1>>,
    TError,
    { householdId: string; data: SuspendHouseholdDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerSuspendV1>>,
  TError,
  { householdId: string; data: SuspendHouseholdDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerSuspendV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerSuspendV1>>,
    { householdId: string; data: SuspendHouseholdDto }
  > = (props) => {
    const { householdId, data } = props ?? {};

    return platformAdminControllerSuspendV1(householdId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerSuspendV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerSuspendV1>>
>;
export type PlatformAdminControllerSuspendV1MutationBody = SuspendHouseholdDto;
export type PlatformAdminControllerSuspendV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerSuspendV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerSuspendV1>>,
      TError,
      { householdId: string; data: SuspendHouseholdDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerSuspendV1>>,
  TError,
  { householdId: string; data: SuspendHouseholdDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerSuspendV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerReinstateV1 = (
  householdId: string,
  reinstateHouseholdDto: ReinstateHouseholdDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/households/${householdId}/reinstate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reinstateHouseholdDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerReinstateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerReinstateV1>>,
    TError,
    { householdId: string; data: ReinstateHouseholdDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerReinstateV1>>,
  TError,
  { householdId: string; data: ReinstateHouseholdDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerReinstateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerReinstateV1>>,
    { householdId: string; data: ReinstateHouseholdDto }
  > = (props) => {
    const { householdId, data } = props ?? {};

    return platformAdminControllerReinstateV1(householdId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerReinstateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerReinstateV1>>
>;
export type PlatformAdminControllerReinstateV1MutationBody = ReinstateHouseholdDto;
export type PlatformAdminControllerReinstateV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerReinstateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerReinstateV1>>,
      TError,
      { householdId: string; data: ReinstateHouseholdDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerReinstateV1>>,
  TError,
  { householdId: string; data: ReinstateHouseholdDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerReinstateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerEnterV1 = (
  householdId: string,
  enterHouseholdDto: EnterHouseholdDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdSummaryResponse>(
    {
      url: `/v1/platform-admin/households/${householdId}/enter`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: enterHouseholdDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerEnterV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerEnterV1>>,
    TError,
    { householdId: string; data: EnterHouseholdDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerEnterV1>>,
  TError,
  { householdId: string; data: EnterHouseholdDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerEnterV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerEnterV1>>,
    { householdId: string; data: EnterHouseholdDto }
  > = (props) => {
    const { householdId, data } = props ?? {};

    return platformAdminControllerEnterV1(householdId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerEnterV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerEnterV1>>
>;
export type PlatformAdminControllerEnterV1MutationBody = EnterHouseholdDto;
export type PlatformAdminControllerEnterV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerEnterV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerEnterV1>>,
      TError,
      { householdId: string; data: EnterHouseholdDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerEnterV1>>,
  TError,
  { householdId: string; data: EnterHouseholdDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerEnterV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerGetHouseholdV1 = (
  householdId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdDetailResponse>(
    { url: `/v1/platform-admin/households/${householdId}`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerGetHouseholdV1QueryKey = (householdId?: string) => {
  return [`/v1/platform-admin/households/${householdId}`] as const;
};

export const getPlatformAdminControllerGetHouseholdV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerGetHouseholdV1QueryKey(householdId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>
  > = ({ signal }) => platformAdminControllerGetHouseholdV1(householdId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!householdId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerGetHouseholdV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>
>;
export type PlatformAdminControllerGetHouseholdV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerGetHouseholdV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetHouseholdV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetHouseholdV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerGetHouseholdV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetHouseholdV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerGetHouseholdV1QueryOptions(householdId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerGetFeaturesV1 = (
  householdId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdFeaturesResponse>(
    { url: `/v1/platform-admin/households/${householdId}/features`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerGetFeaturesV1QueryKey = (householdId?: string) => {
  return [`/v1/platform-admin/households/${householdId}/features`] as const;
};

export const getPlatformAdminControllerGetFeaturesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerGetFeaturesV1QueryKey(householdId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>
  > = ({ signal }) => platformAdminControllerGetFeaturesV1(householdId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!householdId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerGetFeaturesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>
>;
export type PlatformAdminControllerGetFeaturesV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerGetFeaturesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetFeaturesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetFeaturesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerGetFeaturesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetFeaturesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerGetFeaturesV1QueryOptions(householdId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerSetFeaturesV1 = (
  householdId: string,
  setHouseholdFeaturesDto: SetHouseholdFeaturesDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<HouseholdFeaturesResponse>(
    {
      url: `/v1/platform-admin/households/${householdId}/features`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setHouseholdFeaturesDto,
    },
    options,
  );
};

export const getPlatformAdminControllerSetFeaturesV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerSetFeaturesV1>>,
    TError,
    { householdId: string; data: SetHouseholdFeaturesDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerSetFeaturesV1>>,
  TError,
  { householdId: string; data: SetHouseholdFeaturesDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerSetFeaturesV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerSetFeaturesV1>>,
    { householdId: string; data: SetHouseholdFeaturesDto }
  > = (props) => {
    const { householdId, data } = props ?? {};

    return platformAdminControllerSetFeaturesV1(householdId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerSetFeaturesV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerSetFeaturesV1>>
>;
export type PlatformAdminControllerSetFeaturesV1MutationBody = SetHouseholdFeaturesDto;
export type PlatformAdminControllerSetFeaturesV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerSetFeaturesV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerSetFeaturesV1>>,
      TError,
      { householdId: string; data: SetHouseholdFeaturesDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerSetFeaturesV1>>,
  TError,
  { householdId: string; data: SetHouseholdFeaturesDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerSetFeaturesV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerGetBundlesV1 = (
  householdId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<HouseholdBundlesResponse>(
    { url: `/v1/platform-admin/households/${householdId}/bundles`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerGetBundlesV1QueryKey = (householdId?: string) => {
  return [`/v1/platform-admin/households/${householdId}/bundles`] as const;
};

export const getPlatformAdminControllerGetBundlesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerGetBundlesV1QueryKey(householdId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>> = ({
    signal,
  }) => platformAdminControllerGetBundlesV1(householdId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!householdId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerGetBundlesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>
>;
export type PlatformAdminControllerGetBundlesV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerGetBundlesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetBundlesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetBundlesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerGetBundlesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetBundlesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerGetBundlesV1QueryOptions(householdId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerSetBundlesV1 = (
  householdId: string,
  setHouseholdBundlesDto: SetHouseholdBundlesDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<HouseholdBundlesResponse>(
    {
      url: `/v1/platform-admin/households/${householdId}/bundles`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setHouseholdBundlesDto,
    },
    options,
  );
};

export const getPlatformAdminControllerSetBundlesV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerSetBundlesV1>>,
    TError,
    { householdId: string; data: SetHouseholdBundlesDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerSetBundlesV1>>,
  TError,
  { householdId: string; data: SetHouseholdBundlesDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerSetBundlesV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerSetBundlesV1>>,
    { householdId: string; data: SetHouseholdBundlesDto }
  > = (props) => {
    const { householdId, data } = props ?? {};

    return platformAdminControllerSetBundlesV1(householdId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerSetBundlesV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerSetBundlesV1>>
>;
export type PlatformAdminControllerSetBundlesV1MutationBody = SetHouseholdBundlesDto;
export type PlatformAdminControllerSetBundlesV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerSetBundlesV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerSetBundlesV1>>,
      TError,
      { householdId: string; data: SetHouseholdBundlesDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerSetBundlesV1>>,
  TError,
  { householdId: string; data: SetHouseholdBundlesDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerSetBundlesV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerHouseholdMembersV1 = (
  householdId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlatformAdminControllerHouseholdMembersV1200>(
    { url: `/v1/platform-admin/households/${householdId}/members`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerHouseholdMembersV1QueryKey = (householdId?: string) => {
  return [`/v1/platform-admin/households/${householdId}/members`] as const;
};

export const getPlatformAdminControllerHouseholdMembersV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerHouseholdMembersV1QueryKey(householdId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>
  > = ({ signal }) =>
    platformAdminControllerHouseholdMembersV1(householdId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!householdId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerHouseholdMembersV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>
>;
export type PlatformAdminControllerHouseholdMembersV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerHouseholdMembersV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerHouseholdMembersV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerHouseholdMembersV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerHouseholdMembersV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdMembersV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerHouseholdMembersV1QueryOptions(
    householdId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerHouseholdRolesV1 = (
  householdId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RoleResponse[]>(
    { url: `/v1/platform-admin/households/${householdId}/roles`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerHouseholdRolesV1QueryKey = (householdId?: string) => {
  return [`/v1/platform-admin/households/${householdId}/roles`] as const;
};

export const getPlatformAdminControllerHouseholdRolesV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerHouseholdRolesV1QueryKey(householdId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>
  > = ({ signal }) => platformAdminControllerHouseholdRolesV1(householdId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!householdId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerHouseholdRolesV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>
>;
export type PlatformAdminControllerHouseholdRolesV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerHouseholdRolesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerHouseholdRolesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerHouseholdRolesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerHouseholdRolesV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
  TError = ProblemDetailsResponse,
>(
  householdId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerHouseholdRolesV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerHouseholdRolesV1QueryOptions(householdId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerAssignMemberRolesV1 = (
  householdId: string,
  memberId: string,
  assignRolesDto: AssignRolesDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/households/${householdId}/members/${memberId}/roles`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: assignRolesDto,
    },
    options,
  );
};

export const getPlatformAdminControllerAssignMemberRolesV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerAssignMemberRolesV1>>,
    TError,
    { householdId: string; memberId: string; data: AssignRolesDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerAssignMemberRolesV1>>,
  TError,
  { householdId: string; memberId: string; data: AssignRolesDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerAssignMemberRolesV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerAssignMemberRolesV1>>,
    { householdId: string; memberId: string; data: AssignRolesDto }
  > = (props) => {
    const { householdId, memberId, data } = props ?? {};

    return platformAdminControllerAssignMemberRolesV1(householdId, memberId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerAssignMemberRolesV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerAssignMemberRolesV1>>
>;
export type PlatformAdminControllerAssignMemberRolesV1MutationBody = AssignRolesDto;
export type PlatformAdminControllerAssignMemberRolesV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerAssignMemberRolesV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerAssignMemberRolesV1>>,
      TError,
      { householdId: string; memberId: string; data: AssignRolesDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerAssignMemberRolesV1>>,
  TError,
  { householdId: string; memberId: string; data: AssignRolesDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerAssignMemberRolesV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerListAdminsV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlatformAdminResponse[]>(
    { url: `/v1/platform-admin/admins`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerListAdminsV1QueryKey = () => {
  return [`/v1/platform-admin/admins`] as const;
};

export const getPlatformAdminControllerListAdminsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformAdminControllerListAdminsV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>> = ({
    signal,
  }) => platformAdminControllerListAdminsV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerListAdminsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>
>;
export type PlatformAdminControllerListAdminsV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerListAdminsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListAdminsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListAdminsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerListAdminsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListAdminsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerListAdminsV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerCreateAdminV1 = (
  createPlatformAdminDto: CreatePlatformAdminDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreatePlatformAdminResponse>(
    {
      url: `/v1/platform-admin/admins`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPlatformAdminDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerCreateAdminV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerCreateAdminV1>>,
    TError,
    { data: CreatePlatformAdminDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerCreateAdminV1>>,
  TError,
  { data: CreatePlatformAdminDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerCreateAdminV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerCreateAdminV1>>,
    { data: CreatePlatformAdminDto }
  > = (props) => {
    const { data } = props ?? {};

    return platformAdminControllerCreateAdminV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerCreateAdminV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerCreateAdminV1>>
>;
export type PlatformAdminControllerCreateAdminV1MutationBody = CreatePlatformAdminDto;
export type PlatformAdminControllerCreateAdminV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerCreateAdminV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerCreateAdminV1>>,
      TError,
      { data: CreatePlatformAdminDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerCreateAdminV1>>,
  TError,
  { data: CreatePlatformAdminDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerCreateAdminV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerDisableAdminV1 = (
  adminId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/platform-admin/admins/${adminId}/disable`, method: 'POST', signal },
    options,
  );
};

export const getPlatformAdminControllerDisableAdminV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerDisableAdminV1>>,
    TError,
    { adminId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerDisableAdminV1>>,
  TError,
  { adminId: string },
  TContext
> => {
  const mutationKey = ['platformAdminControllerDisableAdminV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerDisableAdminV1>>,
    { adminId: string }
  > = (props) => {
    const { adminId } = props ?? {};

    return platformAdminControllerDisableAdminV1(adminId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerDisableAdminV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerDisableAdminV1>>
>;

export type PlatformAdminControllerDisableAdminV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerDisableAdminV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerDisableAdminV1>>,
      TError,
      { adminId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerDisableAdminV1>>,
  TError,
  { adminId: string },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerDisableAdminV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerEnableAdminV1 = (
  adminId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    { url: `/v1/platform-admin/admins/${adminId}/enable`, method: 'POST', signal },
    options,
  );
};

export const getPlatformAdminControllerEnableAdminV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerEnableAdminV1>>,
    TError,
    { adminId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerEnableAdminV1>>,
  TError,
  { adminId: string },
  TContext
> => {
  const mutationKey = ['platformAdminControllerEnableAdminV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerEnableAdminV1>>,
    { adminId: string }
  > = (props) => {
    const { adminId } = props ?? {};

    return platformAdminControllerEnableAdminV1(adminId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerEnableAdminV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerEnableAdminV1>>
>;

export type PlatformAdminControllerEnableAdminV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerEnableAdminV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerEnableAdminV1>>,
      TError,
      { adminId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerEnableAdminV1>>,
  TError,
  { adminId: string },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerEnableAdminV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerListInvitationsV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlatformInvitationResponse[]>(
    { url: `/v1/platform-admin/invitations`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerListInvitationsV1QueryKey = () => {
  return [`/v1/platform-admin/invitations`] as const;
};

export const getPlatformAdminControllerListInvitationsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformAdminControllerListInvitationsV1QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>
  > = ({ signal }) => platformAdminControllerListInvitationsV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerListInvitationsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>
>;
export type PlatformAdminControllerListInvitationsV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerListInvitationsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListInvitationsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerListInvitationsV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerResendInvitationV1 = (
  invitationId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<IssuedLinkResponse>(
    { url: `/v1/platform-admin/invitations/${invitationId}/resend`, method: 'POST', signal },
    options,
  );
};

export const getPlatformAdminControllerResendInvitationV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerResendInvitationV1>>,
    TError,
    { invitationId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerResendInvitationV1>>,
  TError,
  { invitationId: string },
  TContext
> => {
  const mutationKey = ['platformAdminControllerResendInvitationV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerResendInvitationV1>>,
    { invitationId: string }
  > = (props) => {
    const { invitationId } = props ?? {};

    return platformAdminControllerResendInvitationV1(invitationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerResendInvitationV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerResendInvitationV1>>
>;

export type PlatformAdminControllerResendInvitationV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerResendInvitationV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerResendInvitationV1>>,
      TError,
      { invitationId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerResendInvitationV1>>,
  TError,
  { invitationId: string },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerResendInvitationV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerIssueAdminResetLinkV1 = (
  adminId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<IssuedLinkResponse>(
    { url: `/v1/platform-admin/admins/${adminId}/reset-link`, method: 'POST', signal },
    options,
  );
};

export const getPlatformAdminControllerIssueAdminResetLinkV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerIssueAdminResetLinkV1>>,
    TError,
    { adminId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerIssueAdminResetLinkV1>>,
  TError,
  { adminId: string },
  TContext
> => {
  const mutationKey = ['platformAdminControllerIssueAdminResetLinkV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerIssueAdminResetLinkV1>>,
    { adminId: string }
  > = (props) => {
    const { adminId } = props ?? {};

    return platformAdminControllerIssueAdminResetLinkV1(adminId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerIssueAdminResetLinkV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerIssueAdminResetLinkV1>>
>;

export type PlatformAdminControllerIssueAdminResetLinkV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerIssueAdminResetLinkV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerIssueAdminResetLinkV1>>,
      TError,
      { adminId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerIssueAdminResetLinkV1>>,
  TError,
  { adminId: string },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerIssueAdminResetLinkV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerListAuditV1 = (
  params?: PlatformAdminControllerListAuditV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlatformAdminControllerListAuditV1200>(
    { url: `/v1/platform-admin/audit`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformAdminControllerListAuditV1QueryKey = (
  params?: PlatformAdminControllerListAuditV1Params,
) => {
  return [`/v1/platform-admin/audit`, ...(params ? [params] : [])] as const;
};

export const getPlatformAdminControllerListAuditV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListAuditV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformAdminControllerListAuditV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>> = ({
    signal,
  }) => platformAdminControllerListAuditV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerListAuditV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>
>;
export type PlatformAdminControllerListAuditV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerListAuditV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformAdminControllerListAuditV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListAuditV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListAuditV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListAuditV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListAuditV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerListAuditV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListAuditV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformAdminControllerListAuditV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerListAuditV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerListSystemEventsV1 = (
  params?: PlatformAdminControllerListSystemEventsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<PlatformAdminControllerListSystemEventsV1200>(
    { url: `/v1/platform-admin/system-events`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformAdminControllerListSystemEventsV1QueryKey = (
  params?: PlatformAdminControllerListSystemEventsV1Params,
) => {
  return [`/v1/platform-admin/system-events`, ...(params ? [params] : [])] as const;
};

export const getPlatformAdminControllerListSystemEventsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListSystemEventsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerListSystemEventsV1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>
  > = ({ signal }) => platformAdminControllerListSystemEventsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerListSystemEventsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>
>;
export type PlatformAdminControllerListSystemEventsV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerListSystemEventsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformAdminControllerListSystemEventsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListSystemEventsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListSystemEventsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerListSystemEventsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListSystemEventsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerListSystemEventsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerListSystemEventsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerListSystemEventsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerListSystemEventsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerGetSystemEventV1 = (
  eventId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SystemEventDetailResponse>(
    { url: `/v1/platform-admin/system-events/${eventId}`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerGetSystemEventV1QueryKey = (eventId?: string) => {
  return [`/v1/platform-admin/system-events/${eventId}`] as const;
};

export const getPlatformAdminControllerGetSystemEventV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
  TError = ProblemDetailsResponse,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformAdminControllerGetSystemEventV1QueryKey(eventId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>
  > = ({ signal }) => platformAdminControllerGetSystemEventV1(eventId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerGetSystemEventV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>
>;
export type PlatformAdminControllerGetSystemEventV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerGetSystemEventV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
  TError = ProblemDetailsResponse,
>(
  eventId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetSystemEventV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
  TError = ProblemDetailsResponse,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerGetSystemEventV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
  TError = ProblemDetailsResponse,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerGetSystemEventV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
  TError = ProblemDetailsResponse,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerGetSystemEventV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerGetSystemEventV1QueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerRetrySystemEventV1 = (
  eventId: string,
  systemEventActionDto: SystemEventActionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/system-events/${eventId}/retry`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: systemEventActionDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerRetrySystemEventV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerRetrySystemEventV1>>,
    TError,
    { eventId: string; data: SystemEventActionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerRetrySystemEventV1>>,
  TError,
  { eventId: string; data: SystemEventActionDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerRetrySystemEventV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerRetrySystemEventV1>>,
    { eventId: string; data: SystemEventActionDto }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return platformAdminControllerRetrySystemEventV1(eventId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerRetrySystemEventV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerRetrySystemEventV1>>
>;
export type PlatformAdminControllerRetrySystemEventV1MutationBody = SystemEventActionDto;
export type PlatformAdminControllerRetrySystemEventV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerRetrySystemEventV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerRetrySystemEventV1>>,
      TError,
      { eventId: string; data: SystemEventActionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerRetrySystemEventV1>>,
  TError,
  { eventId: string; data: SystemEventActionDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerRetrySystemEventV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerDiscardSystemEventV1 = (
  eventId: string,
  systemEventActionDto: SystemEventActionDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/system-events/${eventId}/discard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: systemEventActionDto,
      signal,
    },
    options,
  );
};

export const getPlatformAdminControllerDiscardSystemEventV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformAdminControllerDiscardSystemEventV1>>,
    TError,
    { eventId: string; data: SystemEventActionDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformAdminControllerDiscardSystemEventV1>>,
  TError,
  { eventId: string; data: SystemEventActionDto },
  TContext
> => {
  const mutationKey = ['platformAdminControllerDiscardSystemEventV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformAdminControllerDiscardSystemEventV1>>,
    { eventId: string; data: SystemEventActionDto }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return platformAdminControllerDiscardSystemEventV1(eventId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformAdminControllerDiscardSystemEventV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerDiscardSystemEventV1>>
>;
export type PlatformAdminControllerDiscardSystemEventV1MutationBody = SystemEventActionDto;
export type PlatformAdminControllerDiscardSystemEventV1MutationError = ProblemDetailsResponse;

export const usePlatformAdminControllerDiscardSystemEventV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformAdminControllerDiscardSystemEventV1>>,
      TError,
      { eventId: string; data: SystemEventActionDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformAdminControllerDiscardSystemEventV1>>,
  TError,
  { eventId: string; data: SystemEventActionDto },
  TContext
> => {
  const mutationOptions = getPlatformAdminControllerDiscardSystemEventV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformAdminControllerSystemStatusV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SystemStatusResponse>(
    { url: `/v1/platform-admin/system/status`, method: 'GET', signal },
    options,
  );
};

export const getPlatformAdminControllerSystemStatusV1QueryKey = () => {
  return [`/v1/platform-admin/system/status`] as const;
};

export const getPlatformAdminControllerSystemStatusV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformAdminControllerSystemStatusV1QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>
  > = ({ signal }) => platformAdminControllerSystemStatusV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerSystemStatusV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>
>;
export type PlatformAdminControllerSystemStatusV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerSystemStatusV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerSystemStatusV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerSystemStatusV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerSystemStatusV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemStatusV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerSystemStatusV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformAdminControllerSystemLogsV1 = (
  params?: PlatformAdminControllerSystemLogsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SystemLogResponse[]>(
    { url: `/v1/platform-admin/system/logs`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformAdminControllerSystemLogsV1QueryKey = (
  params?: PlatformAdminControllerSystemLogsV1Params,
) => {
  return [`/v1/platform-admin/system/logs`, ...(params ? [params] : [])] as const;
};

export const getPlatformAdminControllerSystemLogsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerSystemLogsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformAdminControllerSystemLogsV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>> = ({
    signal,
  }) => platformAdminControllerSystemLogsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformAdminControllerSystemLogsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>
>;
export type PlatformAdminControllerSystemLogsV1QueryError = ProblemDetailsResponse;

export function usePlatformAdminControllerSystemLogsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformAdminControllerSystemLogsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerSystemLogsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerSystemLogsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
          TError,
          Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformAdminControllerSystemLogsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerSystemLogsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformAdminControllerSystemLogsV1<
  TData = Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformAdminControllerSystemLogsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformAdminControllerSystemLogsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformAdminControllerSystemLogsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const roleTemplatesControllerListV1 = (
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RoleTemplateResponse[]>(
    { url: `/v1/platform-admin/role-templates`, method: 'GET', signal },
    options,
  );
};

export const getRoleTemplatesControllerListV1QueryKey = () => {
  return [`/v1/platform-admin/role-templates`] as const;
};

export const getRoleTemplatesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerListV1>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRoleTemplatesControllerListV1QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roleTemplatesControllerListV1>>> = ({
    signal,
  }) => roleTemplatesControllerListV1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RoleTemplatesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof roleTemplatesControllerListV1>>
>;
export type RoleTemplatesControllerListV1QueryError = ProblemDetailsResponse;

export function useRoleTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof roleTemplatesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRoleTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof roleTemplatesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRoleTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRoleTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoleTemplatesControllerListV1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const roleTemplatesControllerCreateV1 = (
  createRoleTemplateDto: CreateRoleTemplateDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateRoleTemplateResponse>(
    {
      url: `/v1/platform-admin/role-templates`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createRoleTemplateDto,
      signal,
    },
    options,
  );
};

export const getRoleTemplatesControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roleTemplatesControllerCreateV1>>,
    TError,
    { data: CreateRoleTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof roleTemplatesControllerCreateV1>>,
  TError,
  { data: CreateRoleTemplateDto },
  TContext
> => {
  const mutationKey = ['roleTemplatesControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof roleTemplatesControllerCreateV1>>,
    { data: CreateRoleTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return roleTemplatesControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoleTemplatesControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof roleTemplatesControllerCreateV1>>
>;
export type RoleTemplatesControllerCreateV1MutationBody = CreateRoleTemplateDto;
export type RoleTemplatesControllerCreateV1MutationError = ProblemDetailsResponse;

export const useRoleTemplatesControllerCreateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof roleTemplatesControllerCreateV1>>,
      TError,
      { data: CreateRoleTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof roleTemplatesControllerCreateV1>>,
  TError,
  { data: CreateRoleTemplateDto },
  TContext
> => {
  const mutationOptions = getRoleTemplatesControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const roleTemplatesControllerGetV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<RoleTemplateResponse>(
    { url: `/v1/platform-admin/role-templates/${templateId}`, method: 'GET', signal },
    options,
  );
};

export const getRoleTemplatesControllerGetV1QueryKey = (templateId?: string) => {
  return [`/v1/platform-admin/role-templates/${templateId}`] as const;
};

export const getRoleTemplatesControllerGetV1QueryOptions = <
  TData = Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRoleTemplatesControllerGetV1QueryKey(templateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>> = ({
    signal,
  }) => roleTemplatesControllerGetV1(templateId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!templateId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RoleTemplatesControllerGetV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>
>;
export type RoleTemplatesControllerGetV1QueryError = ProblemDetailsResponse;

export function useRoleTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRoleTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
          TError,
          Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRoleTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRoleTemplatesControllerGetV1<
  TData = Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>,
  TError = ProblemDetailsResponse,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof roleTemplatesControllerGetV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRoleTemplatesControllerGetV1QueryOptions(templateId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const roleTemplatesControllerUpdateV1 = (
  templateId: string,
  updateRoleTemplateDto: UpdateRoleTemplateDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/role-templates/${templateId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateRoleTemplateDto,
    },
    options,
  );
};

export const getRoleTemplatesControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roleTemplatesControllerUpdateV1>>,
    TError,
    { templateId: string; data: UpdateRoleTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof roleTemplatesControllerUpdateV1>>,
  TError,
  { templateId: string; data: UpdateRoleTemplateDto },
  TContext
> => {
  const mutationKey = ['roleTemplatesControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof roleTemplatesControllerUpdateV1>>,
    { templateId: string; data: UpdateRoleTemplateDto }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return roleTemplatesControllerUpdateV1(templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoleTemplatesControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof roleTemplatesControllerUpdateV1>>
>;
export type RoleTemplatesControllerUpdateV1MutationBody = UpdateRoleTemplateDto;
export type RoleTemplatesControllerUpdateV1MutationError = ProblemDetailsResponse;

export const useRoleTemplatesControllerUpdateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof roleTemplatesControllerUpdateV1>>,
      TError,
      { templateId: string; data: UpdateRoleTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof roleTemplatesControllerUpdateV1>>,
  TError,
  { templateId: string; data: UpdateRoleTemplateDto },
  TContext
> => {
  const mutationOptions = getRoleTemplatesControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const roleTemplatesControllerRemoveV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/platform-admin/role-templates/${templateId}`, method: 'DELETE' },
    options,
  );
};

export const getRoleTemplatesControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof roleTemplatesControllerRemoveV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof roleTemplatesControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['roleTemplatesControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof roleTemplatesControllerRemoveV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return roleTemplatesControllerRemoveV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoleTemplatesControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof roleTemplatesControllerRemoveV1>>
>;

export type RoleTemplatesControllerRemoveV1MutationError = ProblemDetailsResponse;

export const useRoleTemplatesControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof roleTemplatesControllerRemoveV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof roleTemplatesControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getRoleTemplatesControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformNotificationsControllerStatsV1 = (
  params?: PlatformNotificationsControllerStatsV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<NotificationStatsResponse>(
    { url: `/v1/platform-admin/notifications/stats`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformNotificationsControllerStatsV1QueryKey = (
  params?: PlatformNotificationsControllerStatsV1Params,
) => {
  return [`/v1/platform-admin/notifications/stats`, ...(params ? [params] : [])] as const;
};

export const getPlatformNotificationsControllerStatsV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerStatsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformNotificationsControllerStatsV1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>
  > = ({ signal }) => platformNotificationsControllerStatsV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformNotificationsControllerStatsV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>
>;
export type PlatformNotificationsControllerStatsV1QueryError = ProblemDetailsResponse;

export function usePlatformNotificationsControllerStatsV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformNotificationsControllerStatsV1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
          TError,
          Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformNotificationsControllerStatsV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerStatsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
          TError,
          Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformNotificationsControllerStatsV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerStatsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformNotificationsControllerStatsV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerStatsV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerStatsV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformNotificationsControllerStatsV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformNotificationsControllerRecentV1 = (
  params?: PlatformNotificationsControllerRecentV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<NotificationRecentListResponse>(
    { url: `/v1/platform-admin/notifications/recent`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformNotificationsControllerRecentV1QueryKey = (
  params?: PlatformNotificationsControllerRecentV1Params,
) => {
  return [`/v1/platform-admin/notifications/recent`, ...(params ? [params] : [])] as const;
};

export const getPlatformNotificationsControllerRecentV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerRecentV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPlatformNotificationsControllerRecentV1QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>
  > = ({ signal }) => platformNotificationsControllerRecentV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformNotificationsControllerRecentV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>
>;
export type PlatformNotificationsControllerRecentV1QueryError = ProblemDetailsResponse;

export function usePlatformNotificationsControllerRecentV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformNotificationsControllerRecentV1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
          TError,
          Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformNotificationsControllerRecentV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerRecentV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
          TError,
          Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformNotificationsControllerRecentV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerRecentV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformNotificationsControllerRecentV1<
  TData = Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformNotificationsControllerRecentV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof platformNotificationsControllerRecentV1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformNotificationsControllerRecentV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformNotificationsControllerAnnounceV1 = (
  sendAnnouncementDto: SendAnnouncementDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<SendAnnouncementResponse>(
    {
      url: `/v1/platform-admin/notifications/announcements`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendAnnouncementDto,
      signal,
    },
    options,
  );
};

export const getPlatformNotificationsControllerAnnounceV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformNotificationsControllerAnnounceV1>>,
    TError,
    { data: SendAnnouncementDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformNotificationsControllerAnnounceV1>>,
  TError,
  { data: SendAnnouncementDto },
  TContext
> => {
  const mutationKey = ['platformNotificationsControllerAnnounceV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformNotificationsControllerAnnounceV1>>,
    { data: SendAnnouncementDto }
  > = (props) => {
    const { data } = props ?? {};

    return platformNotificationsControllerAnnounceV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformNotificationsControllerAnnounceV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformNotificationsControllerAnnounceV1>>
>;
export type PlatformNotificationsControllerAnnounceV1MutationBody = SendAnnouncementDto;
export type PlatformNotificationsControllerAnnounceV1MutationError = ProblemDetailsResponse;

export const usePlatformNotificationsControllerAnnounceV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformNotificationsControllerAnnounceV1>>,
      TError,
      { data: SendAnnouncementDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformNotificationsControllerAnnounceV1>>,
  TError,
  { data: SendAnnouncementDto },
  TContext
> => {
  const mutationOptions = getPlatformNotificationsControllerAnnounceV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformTemplatesControllerListV1 = (
  params?: PlatformTemplatesControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<LibraryTemplateResponse[]>(
    { url: `/v1/platform-admin/templates`, method: 'GET', params, signal },
    options,
  );
};

export const getPlatformTemplatesControllerListV1QueryKey = (
  params?: PlatformTemplatesControllerListV1Params,
) => {
  return [`/v1/platform-admin/templates`, ...(params ? [params] : [])] as const;
};

export const getPlatformTemplatesControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformTemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformTemplatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlatformTemplatesControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof platformTemplatesControllerListV1>>> = ({
    signal,
  }) => platformTemplatesControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlatformTemplatesControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof platformTemplatesControllerListV1>>
>;
export type PlatformTemplatesControllerListV1QueryError = ProblemDetailsResponse;

export function usePlatformTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: undefined | PlatformTemplatesControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformTemplatesControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof platformTemplatesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformTemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformTemplatesControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof platformTemplatesControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlatformTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformTemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformTemplatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePlatformTemplatesControllerListV1<
  TData = Awaited<ReturnType<typeof platformTemplatesControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params?: PlatformTemplatesControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof platformTemplatesControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPlatformTemplatesControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const platformTemplatesControllerCreateV1 = (
  createLibraryTemplateDto: CreateLibraryTemplateDto,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<CreateLibraryTemplateResponse>(
    {
      url: `/v1/platform-admin/templates`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createLibraryTemplateDto,
      signal,
    },
    options,
  );
};

export const getPlatformTemplatesControllerCreateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformTemplatesControllerCreateV1>>,
    TError,
    { data: CreateLibraryTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformTemplatesControllerCreateV1>>,
  TError,
  { data: CreateLibraryTemplateDto },
  TContext
> => {
  const mutationKey = ['platformTemplatesControllerCreateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformTemplatesControllerCreateV1>>,
    { data: CreateLibraryTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return platformTemplatesControllerCreateV1(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformTemplatesControllerCreateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformTemplatesControllerCreateV1>>
>;
export type PlatformTemplatesControllerCreateV1MutationBody = CreateLibraryTemplateDto;
export type PlatformTemplatesControllerCreateV1MutationError = ProblemDetailsResponse;

export const usePlatformTemplatesControllerCreateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformTemplatesControllerCreateV1>>,
      TError,
      { data: CreateLibraryTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformTemplatesControllerCreateV1>>,
  TError,
  { data: CreateLibraryTemplateDto },
  TContext
> => {
  const mutationOptions = getPlatformTemplatesControllerCreateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformTemplatesControllerUpdateV1 = (
  templateId: string,
  updateLibraryTemplateDto: UpdateLibraryTemplateDto,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    {
      url: `/v1/platform-admin/templates/${templateId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateLibraryTemplateDto,
    },
    options,
  );
};

export const getPlatformTemplatesControllerUpdateV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformTemplatesControllerUpdateV1>>,
    TError,
    { templateId: string; data: UpdateLibraryTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformTemplatesControllerUpdateV1>>,
  TError,
  { templateId: string; data: UpdateLibraryTemplateDto },
  TContext
> => {
  const mutationKey = ['platformTemplatesControllerUpdateV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformTemplatesControllerUpdateV1>>,
    { templateId: string; data: UpdateLibraryTemplateDto }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return platformTemplatesControllerUpdateV1(templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformTemplatesControllerUpdateV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformTemplatesControllerUpdateV1>>
>;
export type PlatformTemplatesControllerUpdateV1MutationBody = UpdateLibraryTemplateDto;
export type PlatformTemplatesControllerUpdateV1MutationError = ProblemDetailsResponse;

export const usePlatformTemplatesControllerUpdateV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformTemplatesControllerUpdateV1>>,
      TError,
      { templateId: string; data: UpdateLibraryTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformTemplatesControllerUpdateV1>>,
  TError,
  { templateId: string; data: UpdateLibraryTemplateDto },
  TContext
> => {
  const mutationOptions = getPlatformTemplatesControllerUpdateV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const platformTemplatesControllerRemoveV1 = (
  templateId: string,
  options?: SecondParameter<typeof apiFetch>,
) => {
  return apiFetch<void>(
    { url: `/v1/platform-admin/templates/${templateId}`, method: 'DELETE' },
    options,
  );
};

export const getPlatformTemplatesControllerRemoveV1MutationOptions = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof platformTemplatesControllerRemoveV1>>,
    TError,
    { templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof platformTemplatesControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['platformTemplatesControllerRemoveV1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof platformTemplatesControllerRemoveV1>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return platformTemplatesControllerRemoveV1(templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlatformTemplatesControllerRemoveV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof platformTemplatesControllerRemoveV1>>
>;

export type PlatformTemplatesControllerRemoveV1MutationError = ProblemDetailsResponse;

export const usePlatformTemplatesControllerRemoveV1 = <
  TError = ProblemDetailsResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof platformTemplatesControllerRemoveV1>>,
      TError,
      { templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof platformTemplatesControllerRemoveV1>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getPlatformTemplatesControllerRemoveV1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const templateCatalogControllerListV1 = (
  params: TemplateCatalogControllerListV1Params,
  options?: SecondParameter<typeof apiFetch>,
  signal?: AbortSignal,
) => {
  return apiFetch<TemplateCatalogItemResponse[]>(
    { url: `/v1/templates`, method: 'GET', params, signal },
    options,
  );
};

export const getTemplateCatalogControllerListV1QueryKey = (
  params?: TemplateCatalogControllerListV1Params,
) => {
  return [`/v1/templates`, ...(params ? [params] : [])] as const;
};

export const getTemplateCatalogControllerListV1QueryOptions = <
  TData = Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TemplateCatalogControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCatalogControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTemplateCatalogControllerListV1QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof templateCatalogControllerListV1>>> = ({
    signal,
  }) => templateCatalogControllerListV1(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TemplateCatalogControllerListV1QueryResult = NonNullable<
  Awaited<ReturnType<typeof templateCatalogControllerListV1>>
>;
export type TemplateCatalogControllerListV1QueryError = ProblemDetailsResponse;

export function useTemplateCatalogControllerListV1<
  TData = Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TemplateCatalogControllerListV1Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCatalogControllerListV1>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof templateCatalogControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateCatalogControllerListV1<
  TData = Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TemplateCatalogControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCatalogControllerListV1>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof templateCatalogControllerListV1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTemplateCatalogControllerListV1<
  TData = Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TemplateCatalogControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCatalogControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useTemplateCatalogControllerListV1<
  TData = Awaited<ReturnType<typeof templateCatalogControllerListV1>>,
  TError = ProblemDetailsResponse,
>(
  params: TemplateCatalogControllerListV1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof templateCatalogControllerListV1>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getTemplateCatalogControllerListV1QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
